/* Extrait de sections/cart-drawer.liquid le 27/09/2026 : le fichier depassait les 256 Ko.
   Asset .js ORDINAIRE, pas .js.liquid : un asset Liquid n'est rendu qu'une fois et mis en cache,
   or ce script lisait cart.items a chaque requete — le calcul du palier cadeau aurait gele.
   Le Liquid est donc remonte dans la section, avant le bloc JSON CartDrawer-Config, et sa
   valeur transite par config.init_eligible. Effet de bord voulu : les gabarits '{{ label }}'
   des bannieres cadeau survivent maintenant jusqu'au .replace() du script, alors que Liquid
   les vidait auparavant. */

  (function() {
  'use strict';
  // Theme section: Cart Drawer (Splide is loaded once in theme.liquid) — dynamic cart UI, suggestions, multi-currency/locale
  
  // Debug flag — keep false in production (logs are no-ops below; enable only when wiring real loggers).
  const DEBUG = false;
  const log = DEBUG ? console.log.bind(console) : function () {};
  const logError = DEBUG ? console.error.bind(console) : function () {};

  // Panier v4 : tout texte venant des réglages passe par ici avant d'entrer dans du HTML.
  // Décode un libellé passé par le filtre t (« m&#39;abonne ») pour un usage en textContent.
  function mng4Txt(s) { var t = document.createElement('textarea'); t.innerHTML = String(s == null ? '' : s); return t.value; }
  function mng4Esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Safe JSON parse for cart API responses (avoids "Unexpected end of JSON input" from empty/intercepted responses)
  async function parseJsonResponse(res) {
    // Check if body was already consumed by an interceptor (e.g. bundle.js FetchInterceptor)
    if (res.bodyUsed) {
      throw new Error('Response body was consumed by fetch interceptor. Disable dev server interceptors for cart drawer.');
    }
    
    const text = await res.text();
    if (!text || !text.trim()) {
      throw new Error('Empty response from server');
    }
    
    try {
      return JSON.parse(text);
    } catch (e) {
      throw new Error('Invalid JSON response from server');
    }
  }

  // 02/10/2026 (CADEAUX-ULTIME) : X-MNG-Cadeaux = requête du tiroir, que le tiroir fait toujours suivre de sa propre
  // synchro des cadeaux : la garde des cadeaux (mngGardeCadeaux) ne se relance pas après elles.
  const CART_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-MNG-Cadeaux': '1' };
  const CART_ACCEPT = { 'Accept': 'application/json' };
  /** Synced with layout/theme.liquid checkout link handler (propagate ?discount=) */
  const DRAWER_DISCOUNT_SESSION_KEY = 'mushngo_cart_discount';
  /** Set from ?discount= on load (theme.liquid); must clear when cart has no code discounts or removal “sticks” only in mushngo. */
  const LINK_DISCOUNT_SESSION_KEY = 'link_discount_code';

  function cartFetchOpts(extra) {
    return Object.assign({ credentials: 'same-origin' }, extra);
  }

  function cartHasApplicableDiscountCodes(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return false;
    return cart.discount_codes.some(function (d) {
      return d && d.code && String(d.code).trim() && d.applicable !== false;
    });
  }

  /** Map promo tag (code or displayed title) to real cart codes so we do not POST unchanged list when title !== code. */
  function resolveDiscountCodesToRemove(liveCart, removedKey) {
    var rk = (removedKey || '').trim().toLowerCase();
    if (!rk) return [];
    var applicable = (liveCart.discount_codes || []).filter(function (d) {
      return d && d.code && String(d.code).trim() && d.applicable !== false;
    });
    var byLower = {};
    applicable.forEach(function (d) {
      var c = String(d.code).trim();
      if (c) byLower[c.toLowerCase()] = c;
    });
    var toDropLower = {};
    if (byLower[rk]) toDropLower[rk] = true;
    var apps = liveCart.discount_applications || liveCart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      var ap = apps[i];
      var ac = ((ap.code || '') + '').trim();
      var at = ((ap.title || '') + '').trim().toLowerCase();
      if (ac && ac.toLowerCase() === rk) toDropLower[ac.toLowerCase()] = true;
      if (at === rk && ac) toDropLower[ac.toLowerCase()] = true;
    }
    var out = [];
    Object.keys(toDropLower).forEach(function (low) {
      if (byLower[low]) out.push(byLower[low]);
    });
    return out;
  }

  /** Cart AJAX line.properties._gift — Shopify may return boolean true, 1, or "1"; Liquid treats all as truthy. */
  function cartLineIsAutoGift(props) {
    if (!props || typeof props !== 'object') return false;
    var g = props._gift;
    if (g === true || g === 'true') return true;
    if (g === 1 || g === '1') return true;
    if (typeof g === 'string' && String(g).trim() === '1') return true;
    return false;
  }

  /**
   * When cart-level promos stack, API responses may omit _gift on the line even though the theme added it.
   * Same configured gift variant + original price > 0 + final 0 => treat as auto-gift for removal when under threshold.
   */
  function lineIsRemovableGiftSku(item, giftVariantIdStr) {
    if (!item || String(item.variant_id) !== String(giftVariantIdStr) || item.quantity <= 0) return false;
    if (item.properties && cartLineIsAutoGift(item.properties)) return true;
    var o = item.original_line_price || 0;
    var f = item.final_line_price != null ? item.final_line_price : o;
    return o > 0 && f === 0;
  }

  function getGiftVariantIdsFromProgressConfig() {
    var configEl = document.getElementById('CartDrawer-ProgressConfig');
    if (!configEl) return [];
    try {
      var raw = mngFl5(JSON.parse(configEl.textContent));
   var milestonesRaw = mngAllMilestones(raw);
      var ids = [];
      for (var i = 0; i < milestonesRaw.length; i++) {
        var m = milestonesRaw[i];
        var type = (m.type || '').toString().toLowerCase();
        var gid = m.giftVariantId;
        if (type === 'free_gift' && gid != null && String(gid) !== '' && String(gid) !== '0') {
          ids.push(String(gid));
        }
      }
      return ids;
    } catch (e) {
      return [];
    }
  }

  /* 05/10/2026 · FLASH DU SOIR (décision d'Alex). De MNG_FL5.debut à MNG_FL5.fin (UTC ; 16:00 à 23:59:59 heure de Paris, actif dès la mise en ligne, décision d'Alex) :
     - Chocolat CADEAU (vChoco, produit à 0 €) dès MNG_FL5.choco centimes, au lieu de 89 €, pour TOUS les paniers : normal ET pack
       (3+2, 3+3, Ultime ; packChoco = false pour le retirer des paniers pack). UN seul Chocolat : en mode pack, le palier Duo (169 €)
       ne rajoute plus que le Café (le client a toujours 2 Café + 1 Chocolat à 169 €).
     - Café CADEAU (vCafe) dès MNG_FL5.seuilCafe si MNG_FL5.cafe = true, panier NORMAL seulement (le palier Café du mode pack reste à 114 €).
     Toute lecture de #CartDrawer-ProgressConfig passe par mngFl5(). Hors fenêtre : configuration intacte (89 / 114 / 119 / 169).
     Test (aperçu seulement, jamais sur le thème publié) : ?flash_now=2026-10-05T19:00:00 (heure de Paris), + &flash_cafe=1 pour le Café. */
  var MNG_FL5 = { debut: '2026-10-05T14:00:00Z', fin: '2026-10-05T21:59:59Z', choco: 4900, packChoco: true, cafe: true, seuilCafe: 12300,
    vChoco: '58767530983798', vCafe: '58768163176822', vBoite: '58881783038326', sansBoite: true, barre: 'A', unique: true }; /* unique : ce soir, une seule échelle 49/59/123 pour TOUS les paniers, packs compris (Alex) */
  /* Barre de ce soir (Alex) : mêmes mots partout, nom court + montant toujours affichés, phrase courte, étiquette des cadeaux du soir. */
  var MNG_FL5_TX = {
    fr: { choco: 'Brainstoorm offert', ship: 'Livraison offerte', cafe: '2e Brainstoorm', duo: 'Duo', gChoco: 'un Brainstoorm offert', gCafe: 'un 2e Brainstoorm offert', done: 'Tout est débloqué ce soir ✓', tag: 'Offert ce soir · jusqu\u2019à minuit' },
    it: { choco: 'Brainstoorm in regalo', ship: 'Spedizione gratuita', cafe: '2° Brainstoorm', duo: 'Duo', gChoco: 'un Brainstoorm in regalo', gCafe: 'un 2° Brainstoorm in regalo', done: 'Tutto sbloccato stasera ✓', tag: 'In regalo stasera · fino a mezzanotte' },
    es: { choco: 'Brainstoorm de regalo', ship: 'Envío gratis', cafe: '2.º Brainstoorm', duo: 'Dúo', gChoco: 'un Brainstoorm de regalo', gCafe: 'un 2.º Brainstoorm de regalo', done: 'Todo desbloqueado esta noche ✓', tag: 'De regalo esta noche · hasta medianoche' },
    de: { choco: 'Brainstoorm gratis', ship: 'Gratisversand', cafe: '2. Brainstoorm', duo: 'Duo', gChoco: 'einen Brainstoorm gratis', gCafe: 'einen 2. Brainstoorm gratis', done: 'Heute Abend alles freigeschaltet ✓', tag: 'Gratis heute Abend · bis Mitternacht' },
    pt: { choco: 'Brainstoorm oferecido', ship: 'Envio grátis', cafe: '2.º Brainstoorm', duo: 'Duo', gChoco: 'um Brainstoorm oferecido', gCafe: 'um 2.º Brainstoorm oferecido', done: 'Tudo desbloqueado esta noite ✓', tag: 'Oferecido esta noite · até à meia-noite' },
    pl: { choco: 'Brainstoorm gratis', ship: 'Darmowa dostawa', cafe: '2. Brainstoorm', duo: 'Duo', gChoco: 'darmowego Brainstoorma', gCafe: 'drugiego darmowego Brainstoorma', done: 'Dziś wieczorem wszystko odblokowane ✓', tag: 'Gratis dziś wieczorem · do północy' },
    cs: { choco: 'Brainstoorm zdarma', ship: 'Doprava zdarma', cafe: '2. Brainstoorm', duo: 'Duo', gChoco: 'Brainstoormu zdarma', gCafe: 'druhého Brainstoormu zdarma', done: 'Dnes večer je vše odemčeno ✓', tag: 'Zdarma dnes večer · do půlnoci' },
    nl: { choco: 'Gratis Brainstoorm', ship: 'Gratis verzending', cafe: '2e Brainstoorm', duo: 'Duo', gChoco: 'een gratis Brainstoorm', gCafe: 'een 2e gratis Brainstoorm', done: 'Vanavond alles ontgrendeld ✓', tag: 'Gratis vanavond · tot middernacht' },
    sv: { choco: 'Gratis Brainstoorm', ship: 'Fri frakt', cafe: '2:a Brainstoorm', duo: 'Duo', gChoco: 'en gratis Brainstoorm', gCafe: 'en 2:a gratis Brainstoorm', done: 'Allt upplåst i kväll ✓', tag: 'Gratis i kväll · till midnatt' },
    hu: { choco: 'Ingyenes Brainstoorm', ship: 'Ingyenes szállítás', cafe: '2. Brainstoorm', duo: 'Duo', gChoco: 'egy ingyenes Brainstoormhoz', gCafe: 'egy 2. ingyenes Brainstoormhoz', done: 'Ma este minden feloldva ✓', tag: 'Ma este ingyen · éjfélig' },
    ro: { choco: 'Brainstoorm cadou', ship: 'Livrare gratuită', cafe: 'Al 2-lea Brainstoorm', duo: 'Duo', gChoco: 'un Brainstoorm cadou', gCafe: 'al 2-lea Brainstoorm cadou', done: 'Totul e deblocat în seara asta ✓', tag: 'Cadou în seara asta · până la miezul nopții' },
    hr: { choco: 'Brainstoorm gratis', ship: 'Besplatna dostava', cafe: '2. Brainstoorm', duo: 'Duo', gChoco: 'besplatnog Brainstoorma', gCafe: '2. besplatnog Brainstoorma', done: 'Večeras je sve otključano ✓', tag: 'Gratis večeras · do ponoći' },
    bg: { choco: 'Brainstoorm подарък', ship: 'Безплатна доставка', cafe: '2-ри Brainstoorm', duo: 'Duo', gChoco: 'Вашия Brainstoorm подарък', gCafe: 'Вашия 2-ри Brainstoorm подарък', done: 'Всичко е отключено тази вечер ✓', tag: 'Подарък тази вечер · до полунощ' },
    el: { choco: 'Brainstoorm δώρο', ship: 'Δωρεάν αποστολή', cafe: '2ο Brainstoorm', duo: 'Duo', gChoco: 'το Brainstoorm δώρο σας', gCafe: 'το 2ο Brainstoorm δώρο σας', done: 'Όλα ξεκλειδώθηκαν απόψε ✓', tag: 'Δώρο απόψε · έως τα μεσάνυχτα' },
    sk: { choco: 'Brainstoorm zdarma', ship: 'Doprava zdarma', cafe: '2. Brainstoorm', duo: 'Duo', gChoco: 'vášho Brainstoormu zdarma', gCafe: 'vášho 2. Brainstoormu zdarma', done: 'Dnes večer je všetko odomknuté ✓', tag: 'Zdarma dnes večer · do polnoci' },
    sl: { choco: 'Brainstoorm brezplačno', ship: 'Brezplačna dostava', cafe: '2. Brainstoorm', duo: 'Duo', gChoco: 'vašega brezplačnega Brainstoorma', gCafe: 'vašega 2. brezplačnega Brainstoorma', done: 'Nocoj je vse odklenjeno ✓', tag: 'Brezplačno nocoj · do polnoči' },
    lt: { choco: '„Brainstoorm“ dovanų', ship: 'Nemokamas pristatymas', cafe: '2-asis „Brainstoorm“', duo: 'Duo', gChoco: 'nemokamo „Brainstoorm“', gCafe: '2-ojo nemokamo „Brainstoorm“', done: 'Šįvakar viskas atrakinta ✓', tag: 'Dovanų šįvakar · iki vidurnakčio' },
    en: { choco: 'Free Brainstoorm', ship: 'Free shipping', cafe: '2nd Brainstoorm', duo: 'Duo', gChoco: 'a free Brainstoorm', gCafe: 'a 2nd free Brainstoorm', done: 'Everything unlocked tonight ✓', tag: 'Free tonight · until midnight' } };
  /* Barre de ce soir : MNG_FL5.barre = 'A' (barre propre) ou 'B' (liste à cocher) ; '' = barre du thème. Aperçu : ?fl5_barre=A|B. */
  try { var mngFl5B = (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') ? new URLSearchParams(location.search).get('fl5_barre') : null; if (mngFl5B === 'A' || mngFl5B === 'B' || mngFl5B === '0') MNG_FL5.barre = mngFl5B === '0' ? '' : mngFl5B; } catch (e) { console.error('[flash] fl5_barre', e); }
  var MNG_FL5_ET = {
    fr: { choco: ['Brainstoorm', 'offert'], ship: ['Livraison', 'offerte'], cafe: ['2e Brainstoorm', 'offert'], duo: ['Pack Duo', 'offert'], caps: ['20 Mush Caps', 'offertes'], des: 'dès ', ok: 'Débloqué', reste: 'Plus que {x}' },
    it: { choco: ['Brainstoorm', 'in regalo'], ship: ['Spedizione', 'gratuita'], cafe: ['2° Brainstoorm', 'in regalo'], duo: ['Duo', 'in regalo'], caps: ['20 Mush Caps', 'in regalo'], des: 'da ', ok: 'Sbloccato', reste: 'Mancano {x}' },
    es: { choco: ['Brainstoorm', 'de regalo'], ship: ['Envío', 'gratis'], cafe: ['2.º Brainstoorm', 'de regalo'], duo: ['Dúo', 'de regalo'], caps: ['20 Mush Caps', 'de regalo'], des: 'desde ', ok: 'Desbloqueado', reste: 'Faltan {x}' },
    de: { choco: ['Brainstoorm', 'gratis'], ship: ['Versand', 'gratis'], cafe: ['2. Brainstoorm', 'gratis'], duo: ['Duo', 'gratis'], caps: ['20 Mush Caps', 'gratis'], des: 'ab ', ok: 'Freigeschaltet', reste: 'Noch {x}' },
    pt: { choco: ['Brainstoorm', 'oferecido'], ship: ['Envio', 'grátis'], cafe: ['2.º Brainstoorm', 'oferecido'], duo: ['Duo', 'oferecido'], caps: ['20 Mush Caps', 'oferecidas'], des: 'a partir de ', ok: 'Desbloqueado', reste: 'Faltam {x}' },
    pl: { choco: ['Brainstoorm', 'gratis'], ship: ['Dostawa', 'gratis'], cafe: ['2. Brainstoorm', 'gratis'], duo: ['Duo', 'gratis'], caps: ['20 Mush Caps', 'gratis'], des: 'od ', ok: 'Odblokowane', reste: 'Jeszcze {x}' },
    cs: { choco: ['Brainstoorm', 'zdarma'], ship: ['Doprava', 'zdarma'], cafe: ['2. Brainstoorm', 'zdarma'], duo: ['Duo', 'zdarma'], caps: ['20 Mush Caps', 'zdarma'], des: 'od ', ok: 'Odemčeno', reste: 'Ještě {x}' },
    nl: { choco: ['Brainstoorm', 'gratis'], ship: ['Verzending', 'gratis'], cafe: ['2e Brainstoorm', 'gratis'], duo: ['Duo', 'gratis'], caps: ['20 Mush Caps', 'gratis'], des: 'vanaf ', ok: 'Ontgrendeld', reste: 'Nog {x}' },
    sv: { choco: ['Brainstoorm', 'gratis'], ship: ['Frakt', 'gratis'], cafe: ['2:a Brainstoorm', 'gratis'], duo: ['Duo', 'gratis'], caps: ['20 Mush Caps', 'gratis'], des: 'från ', ok: 'Upplåst', reste: '{x} kvar' },
    hu: { choco: ['Brainstoorm', 'ingyen'], ship: ['Szállítás', 'ingyen'], cafe: ['2. Brainstoorm', 'ingyen'], duo: ['Duo', 'ingyen'], caps: ['20 Mush Caps', 'ingyen'], des: 'min. ', ok: 'Feloldva', reste: 'Még {x}' },
    ro: { choco: ['Brainstoorm', 'cadou'], ship: ['Livrare', 'gratuită'], cafe: ['Al 2-lea Brainstoorm', 'cadou'], duo: ['Duo', 'cadou'], caps: ['20 de Mush Caps', 'cadou'], des: 'de la ', ok: 'Deblocat', reste: 'Încă {x}' },
    hr: { choco: ['Brainstoorm', 'gratis'], ship: ['Dostava', 'besplatna'], cafe: ['2. Brainstoorm', 'gratis'], duo: ['Duo', 'gratis'], caps: ['20 Mush Caps', 'gratis'], des: 'od ', ok: 'Otključano', reste: 'Još {x}' },
    bg: { choco: ['Brainstoorm', 'подарък'], ship: ['Доставка', 'безплатна'], cafe: ['2-ри Brainstoorm', 'подарък'], duo: ['Duo', 'подарък'], caps: ['20 Mush Caps', 'подарък'], des: 'от ', ok: 'Отключено', reste: 'Още {x}' },
    el: { choco: ['Brainstoorm', 'δώρο'], ship: ['Αποστολή', 'δωρεάν'], cafe: ['2ο Brainstoorm', 'δώρο'], duo: ['Duo', 'δώρο'], caps: ['20 Mush Caps', 'δώρο'], des: 'από ', ok: 'Ξεκλειδώθηκε', reste: 'Ακόμη {x}' },
    sk: { choco: ['Brainstoorm', 'zdarma'], ship: ['Doprava', 'zdarma'], cafe: ['2. Brainstoorm', 'zdarma'], duo: ['Duo', 'zdarma'], caps: ['20 Mush Caps', 'zdarma'], des: 'od ', ok: 'Odomknuté', reste: 'Ešte {x}' },
    sl: { choco: ['Brainstoorm', 'brezplačno'], ship: ['Dostava', 'brezplačna'], cafe: ['2. Brainstoorm', 'brezplačno'], duo: ['Duo', 'brezplačno'], caps: ['20 Mush Caps', 'brezplačno'], des: 'od ', ok: 'Odklenjeno', reste: 'Še {x}' },
    lt: { choco: ['„Brainstoorm“', 'dovanų'], ship: ['Pristatymas', 'nemokamas'], cafe: ['2-asis „Brainstoorm“', 'dovanų'], duo: ['Duo', 'dovanų'], caps: ['20 Mush Caps', 'dovanų'], des: 'nuo ', ok: 'Atrakinta', reste: 'Dar {x}' },
    en: { choco: ['Brainstoorm', 'free'], ship: ['Shipping', 'free'], cafe: ['2nd Brainstoorm', 'free'], duo: ['Duo', 'free'], caps: ['20 Mush Caps', 'free'], des: 'from ', ok: 'Unlocked', reste: '{x} to go' } };
  var MNG_FL5_CAMION = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#5e3eab" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8" fill="#fff"/><circle cx="17" cy="17.5" r="1.8" fill="#fff"/></svg>';
  function mngFl5Barre(drawer, railLabels, ms, won, total) {
    var cle = MNG_FL5.barre, on = (mngFl5Actif() || mngP06Actif()) && (cle === 'A' || cle === 'B') && ms && ms.length;
    var box = drawer.querySelector('#CartDrawer-Fl5Barre'), dr = drawer.querySelector('#CartDrawer') || drawer;
    dr.classList.toggle('fl5-barre-on', !!on); dr.classList.toggle('fl5-barre-B', !!on && cle === 'B');
    if (!on) { if (box) box.hidden = true; return; }
    if (!box) { box = document.createElement('div'); box.id = 'CartDrawer-Fl5Barre'; railLabels.parentNode.insertBefore(box, railLabels.nextSibling); }
    box.hidden = false;
    var E = MNG_FL5_ET[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MNG_FL5_ET.en, cur = drawer.currency, esc = mng4Esc;
    var n = ms.length, next = won.indexOf(false);
    var et = ms.map(function (m, i) {
      var k = m.type === 'free_shipping' ? 'ship' : m.mngAS ? 'as' : (m.mngDuoSeul && mngCaps20Pack() ? 'capsPlus' : m.giftZoom === 'duo' ? 'duo' : (String(m.giftVariantId) === MNG_FL5.vCafe ? 'cafe' : (String(m.giftVariantId) === MNG_FL5.vBoite ? 'caps' : (m.mngVip ? 'vip' : 'choco'))));
      var lb = k === 'as' ? mngVipAsT().l : k === 'vip' ? [mngVipT().l1, mngVipT().l2] : (k === 'caps' ? (E.caps || MNG_FL5_ET.en.caps) : (k === 'capsPlus' ? ['+ ' + (E.caps || MNG_FL5_ET.en.caps)[0], (E.caps || MNG_FL5_ET.en.caps)[1]] : E[k]));
      var etat = won[i] ? 'is-won' : (i === next ? 'is-next' : 'is-fut');
      var vis = k === 'ship' ? MNG_FL5_CAMION : (m.giftImage ? '<img src="' + esc(m.giftImage) + '" alt="" width="40" height="40" loading="lazy">' : '');
      return { k: k, etat: etat, vis: vis, l1: lb[0], l2: lb[1], prix: m.mngChaque ? mngVipT().chaque : drawer.formatMoneyShort(m.threshold, cur), reste: Math.max(0, m.threshold - total) };
    });
    var html;
    if (cle === 'A') {
      /* 21/10/2026 (PANIER-BARRE, Alex : « pas de barre entre 0 et la livraison ») : la piste part du bord gauche (0 €) et non plus
         de la 1re marche, et p se compte en demi-colonnes (marche i au centre de sa colonne = i + 0,5). Sous le 1er seuil, la barre
         avance déjà ; marche acquise sans le montant (abonné livré gratuitement, Chocolat VIP « à chaque achat ») : on part de 0 €. */
      var w = won.filter(Boolean).length, p = 0, clamp = function (x) { return Math.max(0, Math.min(1, x)); };
      if (w >= n) p = n - 0.5;
      else if (w === 0) p = 0.5 * clamp(ms[0].threshold > 0 ? total / ms[0].threshold : 0);
      else { var a = ms[w - 1].threshold, b = ms[w].threshold; if (total < a) a = 0; p = (w - 0.5) + clamp(b > a ? (total - a) / (b - a) : 0); }
      html = '<div class="fl5a" style="--n:' + n + '"><div class="fl5a-tr"><i style="width:' + (p / (n - 0.5) * 100).toFixed(1) + '%"></i></div><ol>' + et.map(function (e) {
        return '<li class="' + e.etat + '"><span class="fl5a-r">' + e.vis + (e.etat === 'is-won' ? '<b class="fl5a-ok">✓</b>' : '') + '</span><span class="fl5a-t"><b>' + esc(e.l1) + '</b><small>' + esc(e.l2) + ' · ' + esc(e.prix) + '</small></span></li>';
      }).join('') + '</ol></div>';
    } else {
      html = '<ul class="fl5l">' + et.map(function (e) {
        var st = e.etat === 'is-won' ? '<b>✓ ' + esc(E.ok) + '</b>' : esc(E.reste.replace('{x}', drawer.formatMoney(e.reste, cur)));
        return '<li class="' + e.etat + '"><span class="fl5l-v">' + e.vis + '</span><span class="fl5l-n">' + esc(e.l1 + ' ' + e.l2) + ' · ' + esc(E.des + e.prix) + '</span><span class="fl5l-s">' + st + '</span></li>';
      }).join('') + '</ul>';
    }
    if (box.getAttribute('data-h') !== html) { box.innerHTML = html; box.setAttribute('data-h', html); }
    var vi = -1; ms.forEach(function (m, i) { if (m.mngVip) vi = i; });
    var vl = drawer.querySelector('#CartDrawer-VipLigne');
    if (vi !== -1 && won[vi]) {
      if (!vl) { vl = document.createElement('p'); vl.id = 'CartDrawer-VipLigne'; vl.setAttribute('style', 'margin:8px 0 0;padding:6px 10px;border-radius:8px;background:#f3eefc;color:#5e3eab;font-size:12.5px;font-weight:700;line-height:1.25;text-align:center'); box.parentNode.insertBefore(vl, box.nextSibling); }
      vl.hidden = false; if (vl.textContent !== mngVipT().ok) vl.textContent = mngVipT().ok;
    } else if (vl) vl.hidden = true;
  }
  /* Suggestions du tiroir ce soir (Alex) : pastille de la marche franchie, ordre logique, nom français. */
  var MNG_FL5_SGX = {
    fr: { choco: 'Ajoutez-le\u00a0: + un Brainstoorm offert', ship: 'Ajoutez-le\u00a0: livraison offerte', cafe: 'Ajoutez-le\u00a0: + un 2e Brainstoorm offert', noms: [[/Brainstoorm Coffee/, 'Brainstoorm Café']] },
    it: { choco: 'Aggiungilo: + un Brainstoorm in regalo', ship: 'Aggiungilo: spedizione gratuita', cafe: 'Aggiungilo: + un 2° Brainstoorm in regalo', noms: [] },
    es: { choco: 'Añádalo: + un Brainstoorm de regalo', ship: 'Añádalo: envío gratis', cafe: 'Añádalo: + un 2.º Brainstoorm de regalo', noms: [] },
    de: { choco: 'Hinzufügen: + ein Brainstoorm gratis', ship: 'Hinzufügen: Gratisversand', cafe: 'Hinzufügen: + ein 2. Brainstoorm gratis', noms: [] },
    pt: { choco: 'Adicione: + um Brainstoorm oferecido', ship: 'Adicione: envio grátis', cafe: 'Adicione: + um 2.º Brainstoorm oferecido', noms: [] },
    pl: { choco: 'Dodaj: + Brainstoorm gratis', ship: 'Dodaj: darmowa dostawa', cafe: 'Dodaj: + drugi Brainstoorm gratis', noms: [] },
    cs: { choco: 'Přidejte: + Brainstoorm zdarma', ship: 'Přidejte: doprava zdarma', cafe: 'Přidejte: + druhý Brainstoorm zdarma', noms: [] },
    nl: { choco: 'Voeg toe: + een gratis Brainstoorm', ship: 'Voeg toe: gratis verzending', cafe: 'Voeg toe: + een 2e gratis Brainstoorm', noms: [] },
    sv: { choco: 'Lägg till: + en gratis Brainstoorm', ship: 'Lägg till: fri frakt', cafe: 'Lägg till: + en 2:a gratis Brainstoorm', noms: [] },
    hu: { choco: 'Add hozzá: + egy ingyenes Brainstoorm', ship: 'Add hozzá: ingyenes szállítás', cafe: 'Add hozzá: + egy 2. ingyenes Brainstoorm', noms: [] },
    ro: { choco: 'Adaugă: + un Brainstoorm cadou', ship: 'Adaugă: livrare gratuită', cafe: 'Adaugă: + al 2-lea Brainstoorm cadou', noms: [] },
    hr: { choco: 'Dodajte: + besplatni Brainstoorm', ship: 'Dodajte: besplatna dostava', cafe: 'Dodajte: + 2. besplatni Brainstoorm', noms: [] },
    bg: { choco: 'Добавете: + Brainstoorm подарък', ship: 'Добавете: безплатна доставка', cafe: 'Добавете: + 2-ри Brainstoorm подарък', noms: [] },
    el: { choco: 'Προσθέστε: + Brainstoorm δώρο', ship: 'Προσθέστε: δωρεάν αποστολή', cafe: 'Προσθέστε: + 2ο Brainstoorm δώρο', noms: [] },
    sk: { choco: 'Pridajte: + Brainstoorm zdarma', ship: 'Pridajte: doprava zdarma', cafe: 'Pridajte: + 2. Brainstoorm zdarma', noms: [] },
    sl: { choco: 'Dodajte: + brezplačni Brainstoorm', ship: 'Dodajte: brezplačna dostava', cafe: 'Dodajte: + 2. brezplačni Brainstoorm', noms: [] },
    lt: { choco: 'Pridėkite: + „Brainstoorm“ dovanų', ship: 'Pridėkite: nemokamas pristatymas', cafe: 'Pridėkite: + 2-asis „Brainstoorm“ dovanų', noms: [] },
    en: { choco: 'Add it: + a free Brainstoorm', ship: 'Add it: free shipping', cafe: 'Add it: + a 2nd free Brainstoorm', noms: [] } };
  function MNG_FL5_SG() { return MNG_FL5_SGX[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MNG_FL5_SGX.en; }
  /* Rang : Brainstoorm 0, cures 1, accessoires 2 (mixeur, gourde, mousseur). */
  function mngFl5Rang(el) {
    var t = ((el && (el.querySelector('.mng4-st, .mng4-rt') || el).textContent) || '').toLowerCase();
    if (/brainstoorm/.test(t)) return 0;
    if (/mixeur|mush cup|gourde|mousseur|frother|blender|borraccia|botella|flasche|garrafa|bottle|montalatte|espumador|milchaufsch/.test(t)) return 2;
    return 1;
  }
  function mngFl5T() { return MNG_FL5_TX[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MNG_FL5_TX.en; }
  /* Habillage du tiroir pendant la fenêtre : libellés sur 2 lignes en colonnes égales, étiquette « Offert ce soir » sur le Chocolat
     (et le Café du panier normal). Rappelé à chaque mise à jour de la barre et à chaque changement du tiroir. */
  function mngFl5Habille(drawer, railLabels, n) {
    var on = mngFl5Actif();
    if (!document.getElementById('mng-fl5-css')) {
      var st = document.createElement('style'); st.id = 'mng-fl5-css';
      st.textContent = '#CartDrawer.fl5-barre-on #CartDrawer-Rail,#CartDrawer.fl5-barre-on #CartDrawer-RailLabels,#CartDrawer.fl5-barre-B #CartDrawer-ProgressSay{display:none!important}'
        + '#CartDrawer-Fl5Barre[hidden]{display:none}#CartDrawer-Fl5Barre{margin-top:8px}'
        + '.fl5a{position:relative}.fl5a-tr{position:absolute;top:20px;left:0;right:calc(50% / var(--n));height:4px;margin-top:-2px;border-radius:2px;background:#e3dbd0}.fl5a-tr i{display:block;height:100%;border-radius:2px;background:#5e3eab}'
        + '.fl5a ol{position:relative;display:grid;grid-template-columns:repeat(var(--n),minmax(0,1fr));margin:0;padding:0;list-style:none}.fl5a li{display:flex;flex-direction:column;align-items:center;text-align:center;min-width:0}'
        + '.fl5a-r{position:relative;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:40px;height:40px;border-radius:50%;background:#fff;border:2px solid #d9d0c4;overflow:visible}.fl5a-r img{width:100%;height:100%;border-radius:50%;object-fit:cover}'
        + '.fl5a li.is-won .fl5a-r{border-color:#5e3eab}.fl5a li.is-next .fl5a-r{border:3px solid #f0d96a}.fl5a li.is-fut .fl5a-r{opacity:.5;filter:grayscale(1)}'
        + '.fl5a-ok{position:absolute;right:-5px;bottom:-3px;display:flex;align-items:center;justify-content:center;width:17px;height:17px;border-radius:50%;background:#5e3eab;color:#fff;font-size:11px;line-height:1;border:2px solid #fff}'
        + '.fl5a-t{display:block;margin-top:5px;line-height:1.15;font-size:12px;color:#21014f}.fl5a-t b{display:block;font-weight:700}.fl5a-t small{display:block;font-size:11.5px;opacity:.85}.fl5a li.is-won .fl5a-t{color:#5e3eab}.fl5a li.is-won .fl5a-t b{font-weight:800}.fl5a li.is-fut .fl5a-t{opacity:.55}'
        + '.fl5l{margin:0;padding:0;list-style:none}.fl5l li{display:flex;align-items:center;gap:9px;min-height:30px;padding:3px 0;font-size:12.5px;line-height:1.2;color:#21014f}.fl5l li+li{border-top:1px solid rgba(33,1,79,.08)}'
        + '.fl5l-v{flex:none;display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:50%;background:#fff;overflow:hidden}.fl5l-v img{width:100%;height:100%;object-fit:cover}.fl5l-v svg{width:17px;height:17px}'
        + '.fl5l-n{flex:1 1 auto;min-width:0;font-weight:600}.fl5l-s{flex:none;font-weight:600;white-space:nowrap}.fl5l li.is-won .fl5l-s{color:#5e3eab}.fl5l li.is-won .fl5l-n{color:#5e3eab}.fl5l li.is-fut{opacity:.6}'
        + '#CartDrawer .fl5-rail .mng4-node::after{content:none!important}#CartDrawer .mng4-labels.mngp-labels.fl5-labels,#CartDrawer.mngp-compact .mng4-labels.mngp-labels.fl5-labels{height:62px!important;min-height:62px!important}#CartDrawer .mng4-labels.mngp-labels.fl5-labels>span{white-space:normal;width:calc(100% / var(--fl5n, 3) - 6px);line-height:1.15}';
      document.head.appendChild(st);
    }
    if (railLabels) { railLabels.classList.toggle('fl5-labels', on); if (n) railLabels.style.setProperty('--fl5n', n); }
    var rl = drawer && drawer.querySelector('#CartDrawer-Rail'); if (rl) rl.classList.toggle('fl5-rail', on); /* pas de pastille numérotée ce soir */
    if (!on || !drawer) return;
    var t = mngFl5T(), pack = cartHasNoGiftProduct(drawer._lastCart || null);
    drawer.querySelectorAll('.cart-line-item--gift[data-variant-id]').forEach(function (l) {
      var v = l.getAttribute('data-variant-id');
      if (v !== MNG_FL5.vChoco && !(MNG_FL5.cafe && !pack && v === MNG_FL5.vCafe)) return;
      var tg = l.querySelector('.mng4-tag'); if (tg && tg.textContent !== t.tag) tg.textContent = t.tag;
    });
    if (!drawer._mngFl5Obs && window.MutationObserver) {
      var tm = 0;
      drawer._mngFl5Obs = new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(function () { mngFl5Habille(drawer, null, 0); }, 60); });
      drawer._mngFl5Obs.observe(drawer, { childList: true, subtree: true });
    }
  }
  var mngFl5Dec = 0;
  try {
    var mngFl5Q = (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') ? new URLSearchParams(location.search).get('flash_now') : null;
    if (mngFl5Q) { var mngFl5Z = Date.parse(/(Z|[+-]\d\d:?\d\d)$/i.test(mngFl5Q) ? mngFl5Q : mngFl5Q + '+02:00'); if (isNaN(mngFl5Z)) console.error('[flash] flash_now illisible', mngFl5Q); else mngFl5Dec = mngFl5Z - Date.now(); }
    if (mngFl5Q && new URLSearchParams(location.search).get('flash_cafe') === '1') MNG_FL5.cafe = true;
  } catch (e) { console.error('[flash] flash_now', e); }
  function mngFl5Actif() { var n = Date.now() + mngFl5Dec; return n >= Date.parse(MNG_FL5.debut) && n <= Date.parse(MNG_FL5.fin); }
  window.mngFl5Actif = mngFl5Actif;
  /* 06/10/2026 · PALIERS PERMANENTS DU LANCEMENT (Alex) : sans date de fin. on: false = retour au tiroir d'avant (59 / 89 / 119 et 114 / 169).
     normal : livraison (config) · choco € Chocolat · cafe € + Café · boîte de 10 capsules retirée (sansBoite).
     pack : packChoco € Chocolat · packCafe € + Café · Pack Duo à duo € (Café + Chocolat EN PLUS, donc 2 de chaque : exception voulue par Alex)
     SEULEMENT si le panier contient un 3+2 ou un 3+3 (duoIds) ; l'Ultime seul n'a pas de Duo. duo: 0 = pas de palier Duo. */
  var MNG_P06 = { on: true, choco: 8900, cafe: 12300, packChoco: 12400, packCafe: 14400, duo: 17900, duoIds: ['15888642605430', '15883228643702'], sansBoite: true };
  /* 13/10/2026 · PALIER HAUT (Alex : « on remplace le café par 20 capsules, on est en rupture de café »).
     cadeauHaut = 'caps20' (panier normal, 123 €) / cadeauHautPack = 'caps20' (pack 144 €, Duo 179 €) : à la place du Café cadeau, 2 boîtes cadeau de 10 capsules
     (vBoite, une ligne, quantité FIXÉE à 2, jamais d'ajout cumulatif). Au Duo, le Chocolat reste. Seuils inchangés.
     cadeauHaut = 'cafe' : comme avant (Café). */
  MNG_P06.cadeauHaut = 'caps20'; MNG_P06.cadeauHautPack = 'caps20'; MNG_P06.capsQte = 2; /* cadeauHaut : panier normal (123 €, confirmé par Alex le 13/10 11h50) ; cadeauHautPack : Ultime 144, 3+2/3+3 144, Duo 179 (à confirmer) */
  var MNG_CAPS_IMG = 'https://cdn.shopify.com/s/files/1/0565/9672/5878/files/mush-caps-boite-10-capsules.jpg?v=1790859011&width=120';
  var MNG_CAPS_TX = {
    fr: { n: '{q} boîtes de 10 capsules, ajoutées à votre commande', nom: '20 Mush Caps offertes', court: '20 Mush Caps', g: '20 Mush Caps offertes', sg: 'Ajoutez-le\u00a0: + 20 Mush Caps offertes' },
    it: { n: '{q} scatole da 10 capsule, aggiunte al suo ordine', nom: '20 Mush Caps in regalo', court: '20 Mush Caps', g: '20 Mush Caps in regalo', sg: 'Aggiungilo: + 20 Mush Caps in regalo' },
    es: { n: '{q} cajas de 10 cápsulas, añadidas a su pedido', nom: '20 Mush Caps de regalo', court: '20 Mush Caps', g: '20 Mush Caps de regalo', sg: 'Añádalo: + 20 Mush Caps de regalo' },
    de: { n: '{q} Schachteln mit je 10 Kapseln, Ihrer Bestellung hinzugefügt', nom: '20 Mush Caps gratis', court: '20 Mush Caps', g: '20 Mush Caps gratis', sg: 'Hinzufügen: + 20 Mush Caps gratis' },
    pt: { n: '{q} caixas de 10 cápsulas, adicionadas à sua encomenda', nom: '20 Mush Caps oferecidas', court: '20 Mush Caps', g: '20 Mush Caps oferecidas', sg: 'Adicione: + 20 Mush Caps oferecidas' },
    pl: { n: '{q} pudełka po 10 kapsułek, dodane do zamówienia', nom: '20 Mush Caps gratis', court: '20 Mush Caps', g: '20 Mush Caps gratis', sg: 'Dodaj: + 20 Mush Caps gratis' },
    cs: { n: '{q} krabičky po 10 kapslích, přidané k objednávce', nom: '20 Mush Caps zdarma', court: '20 Mush Caps', g: '20 Mush Caps zdarma', sg: 'Přidejte: + 20 Mush Caps zdarma' },
    nl: { n: '{q} doosjes van 10 capsules, toegevoegd aan je bestelling', nom: '20 gratis Mush Caps', court: '20 Mush Caps', g: '20 gratis Mush Caps', sg: 'Voeg toe: + 20 gratis Mush Caps' },
    sv: { n: '{q} askar med 10 kapslar, tillagda i din beställning', nom: '20 gratis Mush Caps', court: '20 Mush Caps', g: '20 gratis Mush Caps', sg: 'Lägg till: + 20 gratis Mush Caps' },
    hu: { n: '{q} doboz, egyenként 10 kapszula, a rendeléshez adva', nom: '20 ingyenes Mush Caps', court: '20 Mush Caps', g: '20 ingyenes Mush Caps kapszulához', sg: 'Add hozzá: + 20 ingyenes Mush Caps' },
    ro: { n: '{q} cutii a câte 10 capsule, adăugate la comanda ta', nom: '20 de Mush Caps cadou', court: '20 de Mush Caps', g: '20 de Mush Caps cadou', sg: 'Adaugă: + 20 de Mush Caps cadou' },
    hr: { n: '{q} kutije po 10 kapsula, dodane u vašu narudžbu', nom: '20 besplatnih Mush Caps', court: '20 Mush Caps', g: '20 besplatnih Mush Caps', sg: 'Dodajte: + 20 besplatnih Mush Caps' },
    bg: { n: '{q} кутии по 10 капсули, добавени към Вашата поръчка', nom: '20 Mush Caps подарък', court: '20 Mush Caps', g: '20 Mush Caps подарък', sg: 'Добавете: + 20 Mush Caps подарък' },
    el: { n: '{q} κουτιά των 10 καψουλών, προστέθηκαν στην παραγγελία σας', nom: '20 Mush Caps δώρο', court: '20 Mush Caps', g: '20 Mush Caps δώρο', sg: 'Προσθέστε: + 20 Mush Caps δώρο' },
    sk: { n: '{q} krabičky po 10 kapsúl, pridané k vašej objednávke', nom: '20 Mush Caps zdarma', court: '20 Mush Caps', g: '20 Mush Caps zdarma', sg: 'Pridajte: + 20 Mush Caps zdarma' },
    sl: { n: '{q} škatlici po 10 kapsul, dodani k vašemu naročilu', nom: '20 brezplačnih Mush Caps', court: '20 Mush Caps', g: '20 brezplačnih Mush Caps', sg: 'Dodajte: + 20 brezplačnih Mush Caps' },
    lt: { n: '{q} dėžutės po 10 kapsulių, pridėtos prie jūsų užsakymo', nom: '20 nemokamų Mush Caps', court: '20 Mush Caps', g: '20 nemokamų Mush Caps', sg: 'Pridėkite: + 20 nemokamų Mush Caps' },
    en: { n: '{q} boxes of 10 capsules, added to your order', nom: '20 free Mush Caps', court: '20 Mush Caps', g: '20 free Mush Caps', sg: 'Add it: + 20 free Mush Caps' } };
  function mngCapsT() { return MNG_CAPS_TX[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MNG_CAPS_TX.en; }
  function mngCaps20() { return MNG_P06.cadeauHaut === 'caps20'; }
  function mngCaps20Pack() { return MNG_P06.cadeauHautPack === 'caps20'; }
  /* 13/10/2026 · CADEAU VIP (Alex) : un visiteur arrivé par un lien portant ?mng_cadeau=vip13 (n'importe quelle page) a, en panier
     NORMAL, le Chocolat cadeau dès MNG_VIP.choco (19,90 €) AU LIEU de 89 € : le palier Chocolat 89 € disparaît (un seul Chocolat), livraison et palier haut
     inchangés. Mode pack (3+2, 3+3, Ultime) : rien ne change. Marqueur gardé dans localStorage et dans l'attribut de panier caché
     _mng_cadeau. Aucun code, aucune remise. S'éteint seul à MNG_VIP.fin (14/10 00:20 Paris) ; on: false = coupé.
     Test (aperçu seulement) : ?flash_now=2026-10-14T00:25:00 (heure de Paris). */
  /* pack : VIP en mode pack (Ultime, 3+2, 3+3) : Chocolat dès 49 € (le palier pack Chocolat 124 € disparaît), 144 € inchangé, Duo 179 € sans 2e Chocolat
     (seulement sa partie capsules). pack32Tous : mêmes règles pour TOUT panier contenant un 3+2 (id32), sans marqueur, même fenêtre (option, coupée par défaut). */
  /* as : cure Anti-Stress cadeau (vAS, 0 €) dès seuilAS pour le VIP ; packCaps : seuil des 20 Mush Caps du VIP en mode pack. */
  var MNG_VIP_AS_TX = {
    fr: { l: ['Cure Anti-Stress', 'offerte'], nom: 'Cure Anti-Stress offerte', g: 'votre cure Anti-Stress offerte', sg: 'Ajoutez-le\u00a0: + une cure Anti-Stress offerte' },
    it: { l: ['Cura Anti-Stress', 'in regalo'], nom: 'Cura Anti-Stress in regalo', g: 'la sua cura Anti-Stress in regalo', sg: 'Aggiungilo: + una cura Anti-Stress in regalo' },
    es: { l: ['Cura Anti-Stress', 'de regalo'], nom: 'Cura Anti-Stress de regalo', g: 'su cura Anti-Stress de regalo', sg: 'Añádalo: + una cura Anti-Stress de regalo' },
    de: { l: ['Kur Anti-Stress', 'gratis'], nom: 'Kur Anti-Stress gratis', g: 'Ihre Kur Anti-Stress gratis', sg: 'Hinzufügen: + eine Kur Anti-Stress gratis' },
    pt: { l: ['Suplemento Anti-stress', 'oferecido'], nom: 'Suplemento Anti-stress oferecido', g: 'o seu Suplemento Anti-stress oferecido', sg: 'Adicione: + um Suplemento Anti-stress oferecido' },
    pl: { l: ['Suplement Antystres', 'gratis'], nom: 'Suplement Antystres gratis', g: 'Twojego Suplementu Antystres gratis', sg: 'Dodaj: + Suplement Antystres gratis' },
    cs: { l: ['Doplněk Antistres', 'zdarma'], nom: 'Doplněk Antistres zdarma', g: 'vašeho Doplňku Antistres zdarma', sg: 'Přidejte: + Doplněk Antistres zdarma' },
    nl: { l: ['Anti-stress-kuur', 'gratis'], nom: 'Gratis Anti-stress-kuur', g: 'je gratis Anti-stress-kuur', sg: 'Voeg toe: + een gratis Anti-stress-kuur' },
    sv: { l: ['Antistress-kur', 'gratis'], nom: 'Gratis Antistress-kur', g: 'din gratis Antistress-kur', sg: 'Lägg till: + en gratis Antistress-kur' },
    hu: { l: ['Antistressz kúra', 'ingyen'], nom: 'Ingyenes Antistressz kúra', g: 'az ingyenes Antistressz kúrádhoz', sg: 'Add hozzá: + egy ingyenes Antistressz kúra' },
    ro: { l: ['Cura Anti-Stress', 'cadou'], nom: 'Cura Anti-Stress cadou', g: 'cura ta Anti-Stress cadou', sg: 'Adaugă: + o cură Anti-Stress cadou' },
    hr: { l: ['Dodatak Antistres', 'gratis'], nom: 'Besplatni Dodatak Antistres', g: 'vašeg besplatnog Dodatka Antistres', sg: 'Dodajte: + besplatni Dodatak Antistres' },
    bg: { l: ['Курс Анти-стрес', 'подарък'], nom: 'Курс Анти-стрес подарък', g: 'Вашия курс Анти-стрес подарък', sg: 'Добавете: + курс Анти-стрес подарък' },
    el: { l: ['Κούρα Anti-Stress', 'δώρο'], nom: 'Κούρα Anti-Stress δώρο', g: 'την Κούρα Anti-Stress δώρο σας', sg: 'Προσθέστε: + Κούρα Anti-Stress δώρο' },
    sk: { l: ['Doplnok Antistres', 'zdarma'], nom: 'Doplnok Antistres zdarma', g: 'vášho Doplnku Antistres zdarma', sg: 'Pridajte: + Doplnok Antistres zdarma' },
    sl: { l: ['Dopolnilo Antistres', 'brezplačno'], nom: 'Brezplačno dopolnilo Antistres', g: 'vašega brezplačnega dopolnila Antistres', sg: 'Dodajte: + brezplačno dopolnilo Antistres' },
    lt: { l: ['Antistreso kursas', 'dovanų'], nom: 'Nemokamas Antistreso kursas', g: 'jūsų nemokamo Antistreso kurso', sg: 'Pridėkite: + nemokamas Antistreso kursas' },
    en: { l: ['Anti-Stress cure', 'free'], nom: 'Free Anti-Stress cure', g: 'your free Anti-Stress cure', sg: 'Add it: + a free Anti-Stress cure' } };
  function mngVipAsT() { return MNG_VIP_AS_TX[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MNG_VIP_AS_TX.en; }
  function mngVipAs(base) {
    var A = mngVipAsT(), m = JSON.parse(JSON.stringify(base));
    delete m.mngVip; delete m.mngChaque; delete m.giftZoom;
    m.type = 'free_gift'; m.giftVariantId = Number(MNG_VIP.vAS); m.threshold = MNG_VIP.seuilAS; m.giftImage = MNG_VIP.imgAS; m.mngAS = true;
    m.shortLabel = A.l[0]; m.goalPhrase = A.g; m.unlockLabel = A.sg; m.label = m.unlockedLabel = m.doneLabel = m.bannerLabel = A.nom; m.giftNote = '';
    if (m.gifts) m.gifts = [{ v: Number(MNG_VIP.vAS), q: 1 }];
    return m;
  }
  var MNG_VIP = { as: true, vAS: '58766130708854', seuilAS: 8900, packCaps: 12300, seuilAS32: 12300, caps32: 17900, sansDuo32: true, /* *32 : VIP avec un 3+2 au panier */
    imgAS: 'https://cdn.shopify.com/s/files/1/0565/9672/5878/files/anti-stress-v2-packshot-ashwagandha-reishi-basilic-b6_b3874963-a64c-4c3d-aca8-7ce2f97addc6.png?v=1789731443&width=120',
    pack: true, pack32Tous: false, id32: '15888642605430', on: true, code: 'vip13', param: 'mng_cadeau', cle: 'mng_cadeau', attr: '_mng_cadeau', debut: '2026-10-12T22:00:00Z', fin: '2026-10-13T22:20:00Z', choco: 1 };
  MNG_VIP.sortAvecCode = false; /* 13/10/2026 (Alex : « même avec le code il a son choco, toujours ») : true = le Chocolat VIP sort aussi avec un code */ /* choco : seuil VIP en centimes (Alex 13/10 15h10 : « à chaque achat, ajouté automatiquement » = dès 1 produit payant, cadeaux et assurance exclus) */
  var MNG_VIP_TX = {
    fr: { chaque: 'à chaque achat', g: 'votre Chocolat offert VIP', ok: 'Cadeau VIP\u00a0: votre Brainstoorm Chocolat est offert', l1: 'Chocolat', l2: 'offert VIP', sg: 'Ajoutez-le\u00a0: + votre Chocolat offert VIP' },
    it: { chaque: 'a ogni acquisto', g: 'il suo Cioccolato in regalo VIP', ok: 'Regalo VIP: il suo Brainstoorm Cioccolato è in regalo', l1: 'Cioccolato', l2: 'in regalo VIP', sg: 'Aggiungilo: + il suo Cioccolato in regalo VIP' },
    es: { chaque: 'en cada compra', g: 'su Chocolate de regalo VIP', ok: 'Regalo VIP: su Brainstoorm Chocolate es de regalo', l1: 'Chocolate', l2: 'de regalo VIP', sg: 'Añádalo: + su Chocolate de regalo VIP' },
    de: { chaque: 'bei jeder Bestellung', g: 'Ihre VIP-Schokolade gratis', ok: 'VIP-Geschenk: Ihr Brainstoorm Schokolade ist gratis', l1: 'Schokolade', l2: 'gratis VIP', sg: 'Hinzufügen: + Ihre VIP-Schokolade gratis' },
    pt: { chaque: 'em cada compra', g: 'o seu Chocolate oferecido VIP', ok: 'Oferta VIP: o seu Brainstoorm Chocolate é oferecido', l1: 'Chocolate', l2: 'oferecido VIP', sg: 'Adicione: + o seu Chocolate oferecido VIP' },
    pl: { chaque: 'przy każdym zakupie', g: 'Twojej Czekolady VIP gratis', ok: 'Prezent VIP: Twój Brainstoorm Czekolada jest gratis', l1: 'Czekolada', l2: 'gratis VIP', sg: 'Dodaj: + Twoja Czekolada VIP gratis' },
    cs: { chaque: 'ke každému nákupu', g: 'vaší Čokolády VIP zdarma', ok: 'Dárek VIP: váš Brainstoorm Čokoláda je zdarma', l1: 'Čokoláda', l2: 'zdarma VIP', sg: 'Přidejte: + vaše Čokoláda VIP zdarma' },
    nl: { chaque: 'bij elke bestelling', g: 'je gratis VIP-Chocolade', ok: 'VIP-cadeau: je Brainstoorm Chocolade is gratis', l1: 'Chocolade', l2: 'gratis VIP', sg: 'Voeg toe: + je gratis VIP-Chocolade' },
    sv: { chaque: 'vid varje köp', g: 'din gratis VIP-Choklad', ok: 'VIP-gåva: din Brainstoorm Choklad är gratis', l1: 'Choklad', l2: 'gratis VIP', sg: 'Lägg till: + din gratis VIP-Choklad' },
    hu: { chaque: 'minden vásárláshoz', g: 'az ingyenes VIP Csokidhoz', ok: 'VIP ajándék: a Brainstoorm Csokid ingyenes', l1: 'Csoki', l2: 'ingyen VIP', sg: 'Add hozzá: + az ingyenes VIP Csokid' },
    ro: { chaque: 'la fiecare comandă', g: 'Choco-ul tău VIP cadou', ok: 'Cadou VIP: Brainstoorm Choco e gratuit pentru tine', l1: 'Choco', l2: 'cadou VIP', sg: 'Adaugă: + Choco-ul tău VIP cadou' },
    hr: { chaque: 'uz svaku kupnju', g: 'vaše besplatne VIP Čokolade', ok: 'VIP poklon: vaš Brainstoorm Choco je besplatan', l1: 'Čokolada', l2: 'gratis VIP', sg: 'Dodajte: + vaša besplatna VIP Čokolada' },
    bg: { chaque: 'към всяка поръчка', g: 'Вашия VIP шоколад подарък', ok: 'VIP подарък: Вашият Brainstoorm Choco е безплатен', l1: 'Шоколад', l2: 'VIP подарък', sg: 'Добавете: + Вашия VIP шоколад подарък' },
    el: { chaque: 'σε κάθε παραγγελία', g: 'τη VIP σοκολάτα δώρο σας', ok: 'VIP δώρο: το Brainstoorm Choco σας είναι δωρεάν', l1: 'Σοκολάτα', l2: 'VIP δώρο', sg: 'Προσθέστε: + τη VIP σοκολάτα δώρο σας' },
    sk: { chaque: 'ku každému nákupu', g: 'vašej VIP Čokolády zdarma', ok: 'VIP darček: váš Brainstoorm Choco je zdarma', l1: 'Čokoláda', l2: 'zdarma VIP', sg: 'Pridajte: + vaša VIP Čokoláda zdarma' },
    sl: { chaque: 'ob vsakem nakupu', g: 'vaše brezplačne VIP Čokolade', ok: 'VIP darilo: vaš Brainstoorm Choco je brezplačen', l1: 'Čokolada', l2: 'brezplačno VIP', sg: 'Dodajte: + vaša brezplačna VIP Čokolada' },
    lt: { chaque: 'prie kiekvieno pirkinio', g: 'jūsų nemokamo VIP Šokolado', ok: 'VIP dovana: jūsų Brainstoorm Choco nemokamas', l1: 'Šokoladas', l2: 'VIP dovanų', sg: 'Pridėkite: + jūsų nemokamas VIP Šokoladas' },
    en: { chaque: 'with every order', g: 'your free VIP Chocolate', ok: 'VIP gift: your Brainstoorm Chocolate is free', l1: 'Chocolate', l2: 'free VIP', sg: 'Add it: + your free VIP Chocolate' } };
  function mngVipT() { return MNG_VIP_TX[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MNG_VIP_TX.en; }
  function mngVipTemps() { var n = Date.now() + mngFl5Dec; return !!MNG_VIP.on && n >= Date.parse(MNG_VIP.debut) && n <= Date.parse(MNG_VIP.fin); }
  try { if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main' && new URLSearchParams(location.search).get('vip_32tous') === '1') MNG_VIP.pack32Tous = true; } catch (e) { console.error('[vip] vip_32tous', e); } /* aperçu seulement */
  var mngVipMarque = false, mngVipAttr = false, mngVipEcrit = false;
  try {
    if (MNG_VIP.on) {
      var mngVipQ = new URLSearchParams(location.search).get(MNG_VIP.param);
      if (mngVipQ === MNG_VIP.code && mngVipTemps()) { mngVipMarque = true; try { localStorage.setItem(MNG_VIP.cle, MNG_VIP.code); } catch (e) { /* stockage bloqué : l'attribut de panier prend le relais */ } }
      else { try { mngVipMarque = localStorage.getItem(MNG_VIP.cle) === MNG_VIP.code; } catch (e) { mngVipMarque = false; } }
    }
  } catch (e) { console.error('[vip] lecture du marqueur', e); }
  function mngVipVoitPanier(c) { if (c && c.attributes && c.attributes[MNG_VIP.attr] === MNG_VIP.code) mngVipAttr = true; }
  function mngVipActif() { return mngVipTemps() && mngP06Actif() && (mngVipMarque || mngVipAttr); }
  window.mngVipActif = mngVipActif;
  /* 13/10/2026 · CADEAUX SUR LE PAYÉ (Alex) : un code promo APPLICABLE posé au panier (lien /discount/CODE, ?discount=) retire tous
     les cadeaux produits (paliers normaux et packs, Anti-Stress et 20 Mush Caps VIP compris), et la barre l'annonce. Les paliers
     restants (livraison) se calculent déjà sur le payé (computeGiftProgressTotals : total après codes et remises, sans cadeaux ni assurance).
     MNG_VIP.sortAvecCode = false : le Chocolat VIP (vip13, palier « à chaque achat ») reste même avec un code (Alex, 13/10).
     Limite : un code tapé sur la page de paiement Shopify est invisible au thème. sansCumul.on: false = règle coupée. */
  var MNG_SANS_CUMUL = { on: false };   /* 2/11/2026 (Alex) : les cadeaux restent avec un code, le palier se juge sur le prix payé après code (computeGiftProgressTotals). */
  var MNG_SANS_CUMUL_TX = {
    fr: 'Les cadeaux ne se cumulent pas avec un code promo',
    it: 'I regali non sono cumulabili con un codice sconto',
    es: 'Los regalos no son acumulables con un código promocional',
    de: 'Geschenke sind nicht mit einem Rabattcode kombinierbar',
    pt: 'As ofertas não são acumuláveis com um código promocional',
    pl: 'Prezentów nie można łączyć z kodem rabatowym',
    cs: 'Dárky nelze kombinovat se slevovým kódem',
    nl: 'Cadeaus zijn niet te combineren met een kortingscode',
    sv: 'Gåvor kan inte kombineras med en rabattkod',
    hu: 'Az ajándékok nem vonhatók össze kedvezménykóddal',
    ro: 'Cadourile nu se cumulează cu un cod de reducere',
    hr: 'Pokloni se ne mogu kombinirati s kodom za popust',
    bg: 'Подаръците не се комбинират с код за отстъпка',
    el: 'Τα δώρα δεν συνδυάζονται με κωδικό έκπτωσης',
    sk: 'Darčeky nie je možné kombinovať so zľavovým kódom',
    sl: 'Daril ni mogoče združiti s kodo za popust',
    lt: 'Dovanų negalima derinti su nuolaidos kodu',
    en: 'Gifts cannot be combined with a discount code' };
  function mngSansCumulT() { return MNG_SANS_CUMUL_TX[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MNG_SANS_CUMUL_TX.en; }
  /* 23/10/2026 · PLURIELS pl/cs (Alex) : « Odblokuj 2 prezentów » était faux. Pastille « débloque N cadeaux » des suggestions :
     en polonais et en tchèque, la forme du mot suit le nombre. Texte seul : aucune logique de cadeaux, paliers ou seuils ici.
     Les autres langues gardent sections.cart_drawer.unlock_all tel quel (mngUnlockTxt rend '' hors pl/cs). */
  var MNG_UNLOCK_TX = {
    pl: { one: 'Odblokuj {n} prezent', few: 'Odblokuj {n} prezenty', many: 'Odblokuj {n} prezentów' },
    cs: { one: 'Odemkne {n} dárek', few: 'Odemkne {n} dárky', many: 'Odemkne {n} dárků' } };
  function mngPluriel(lg, n) {
    n = Math.abs(Math.floor(Number(n) || 0)); var d = n % 10, c = n % 100;
    if (lg === 'pl') return n === 1 ? 'one' : (d >= 2 && d <= 4 && (c < 12 || c > 14)) ? 'few' : 'many';
    if (lg === 'cs') return n === 1 ? 'one' : (n >= 2 && n <= 4) ? 'few' : 'many';
    return '';
  }
  function mngUnlockTxt(n) {
    var lg = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase(), T = MNG_UNLOCK_TX[lg];
    return T ? T[mngPluriel(lg, n)].replace('{n}', String(n)) : '';
  }
  function mngCodeRetireCadeaux(cart) { return !!MNG_SANS_CUMUL.on && !!cart && cartHasApplicableDiscountCodes(cart); }
  function mngSansCadeauxSiCode(ms, cart) {
    if (!mngCodeRetireCadeaux(cart)) return ms;
    return (ms || []).filter(function (m) {
      if (!m || String(m.type || '').toLowerCase() !== 'free_gift') return true;
      return MNG_VIP.sortAvecCode === false && !!m.mngChaque && mngVipActif(); /* Chocolat VIP « à chaque achat » */
    });
  }
  /* 19/10/2026 · CADEAUX DU PACK MUSH CAPS, gamme B (décision d'Alex du 18/10). Cadeaux réservés à l'abonnement (1er colis) :
     40 capsules en abonnement = 1 mousseur ; 60 capsules en abonnement = 1 gourde + 1 mousseur ; 20 en abonnement et tout
     achat unique (ligne sans selling_plan) = aucun. Un seul jeu par commande : celui du plus grand pack en abonnement.
     Lignes capsules repérées par variante OU SKU, jamais par position. Cadeaux = lignes _gift à 0 €, sans selling_plan,
     quantité FIXÉE à 1 (/cart/update puis /cart/change, jamais /cart/add) ; ligne _gift = hors paliers, hors seuil de
     livraison, hors bulle. Posés par la synchro du tiroir (étape 4), retirés par son nettoyage (étape 3) et par la garde
     (mngCadeauxPermis : bascule en achat unique, baisse, suppression, départ vers le paiement).
     Paliers MNG_P06 / MNG_VIP / mode pack (Ultime dans MNG_NO_GIFT_PRODUCT_IDS) : INCHANGÉS (Alex n'a pas tranché).
     resteAvecCode : true = le cadeau du pack RESTE avec un code promo (exempté de MNG_SANS_CUMUL) ; false = il saute aussi. */
  var MNG_CAPS_ABO = { on: true, resteAvecCode: true, packs: [
    { sku: 'LAB-MG-PCK-CAP-20', v: '59047630930294', rang: 20, cadeaux: [] },
    { sku: 'LAB-MG-PCK-CAP-40', v: '59047632732534', rang: 40, cadeaux: ['58473001386358'] },
    { sku: 'LAB-MG-PCK-CAP-60', v: '59047634600310', rang: 60, cadeaux: ['59047618642294', '58473001386358'] },
    /* 21/10/2026 : gamme A du test A/B (30 / 60 / 90), mêmes règles : 60-A abo = mousseur, 90 abo = gourde + mousseur, 30 = rien */
    { sku: 'LAB-MG-PCK-CAP-30', v: '59078431834486', rang: 30, cadeaux: [] },
    { sku: 'LAB-MG-PCK-CAP-60-A', v: '59078433374582', rang: 59, cadeaux: ['58473001386358'] },
    { sku: 'LAB-MG-PCK-CAP-90', v: '59078434324854', rang: 90, cadeaux: ['59047618642294', '58473001386358'] }
  ] }; /* 59047618642294 = gourde CADEAU 0 € (jamais 58582242820470, à 29,90 €) ; 58473001386358 = mousseur CADEAU 0 € */
  function mngCapsAboPack(it) {
    if (!it || !(Number(it.quantity) > 0) || cartLineIsAutoGift(it.properties)) return null;
    for (var i = 0; i < MNG_CAPS_ABO.packs.length; i++) {
      var p = MNG_CAPS_ABO.packs[i];
      if (String(it.variant_id) === p.v || (it.sku && String(it.sku) === p.sku)) return p;
    }
    return null;
  }
  /* { variante cadeau: 1 } dû par le plus grand pack capsules EN ABONNEMENT du panier ; {} sinon. */
  function mngCapsAboCadeaux(cart) {
    var out = {}, best = null;
    if (!MNG_CAPS_ABO.on || !cart) return out;
    if (!MNG_CAPS_ABO.resteAvecCode && mngCodeRetireCadeaux(cart)) return out;
    (cart.items || []).forEach(function (it) {
      var p = mngCapsAboPack(it);
      if (p && it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && (!best || p.rang > best.rang)) best = p;
    });
    if (best) best.cadeaux.forEach(function (v) { out[String(v)] = 1; });
    return out;
  }
  function mngCapsAboEstCadeau(vid) {
    return MNG_CAPS_ABO.packs.some(function (p) { return p.cadeaux.indexOf(String(vid)) !== -1; });
  }
  /* Synchro utile même sans palier : cadeau du pack dû, ou ligne cadeau du pack à retirer. */
  function mngCapsAboEnJeu(cart) {
    if (Object.keys(mngCapsAboCadeaux(cart)).length) return true;
    return ((cart && cart.items) || []).some(function (it) { return it && it.quantity > 0 && cartLineIsAutoGift(it.properties) && mngCapsAboEstCadeau(it.variant_id); });
  }
  /* Quantités permises de la garde + cadeaux du pack (au plus 1 de chaque). Copie : l'objet reçu n'est pas modifié. */
  function mngCapsAboFusion(permis, cart) {
    var out = Object.assign({}, permis || {}), dus = mngCapsAboCadeaux(cart);
    Object.keys(dus).forEach(function (k) { out[k] = Math.max(Number(out[k]) || 0, dus[k]); });
    return out;
  }
  /* Pack Duo réservé aux paniers avec un 3+2 ou un 3+3 (cart absent = premier rendu : pas de Duo, le panier relu le remet). */
  function mngP06Pack(raw, cart) {
    var pm = (raw && !Array.isArray(raw) && raw.packMilestones) || [];
    if (!raw || !raw.mngP06) return mngSansCadeauxSiCode(pm, cart);
    var a32 = ((cart && cart.items) || []).some(function (it) { return it && it.quantity > 0 && MNG_P06.duoIds.indexOf(String(it.product_id)) !== -1; });
    var out = a32 ? pm : pm.filter(function (m) { return !m.mngDuo; });
    return mngSansCadeauxSiCode(mngVipPackMs(out, cart), cart);
  }
  /* 13/10/2026 : paliers pack du VIP (A) ou de l'option 3+2 (B). Copies : la configuration lue n'est jamais modifiée. */
  function mngVipPackMs(pm, cart) {
    var parVip = MNG_VIP.pack && mngVipActif();
    var par32 = !parVip && MNG_VIP.pack32Tous && mngVipTemps() && mngP06Actif() && ((cart && cart.items) || []).some(function (it) { return it && it.quantity > 0 && String(it.product_id) === MNG_VIP.id32; });
    if (!parVip && !par32) return pm;
    var C = String(MNG_FL5.vChoco), V = mngVipT(), CT = mngCapsT(), img = null;
    pm.forEach(function (m) { if (m && m.mngCaps && m.giftImage) img = m.giftImage; });
    var out = pm.map(function (m0) {
      var m = JSON.parse(JSON.stringify(m0)), g = m.gifts || [];
      if (!m.mngDuo && g.length === 1 && String(g[0].v) === C) {
        m.threshold = MNG_VIP.choco; m.mngChaque = true;
        if (parVip) { m.goalPhrase = V.g; m.unlockLabel = V.sg; m.mngVip = true; }
      } else if (m.mngDuo) {
        m.gifts = g.filter(function (x) { return String(x.v) !== C; });
        m.mngDuoSeul = true;
        if (mngCaps20Pack()) { m.goalPhrase = CT.g; m.unlockLabel = CT.sg; m.shortLabel = '+ ' + CT.court; m.label = m.unlockedLabel = m.doneLabel = m.bannerLabel = CT.nom; if (img) m.giftImage = img; delete m.giftZoom; }
      }
      return m;
    });
    if (parVip) {
      var asBase = null, v32 = ((cart && cart.items) || []).some(function (it) { return it && it.quantity > 0 && String(it.product_id) === MNG_VIP.id32; });
      out.forEach(function (m) {
        var g = m.gifts || [];
        if (!m.mngDuo && g.length === 1 && String(g[0].v) === C) asBase = m;
        else if (!m.mngDuo && g.length && MNG_VIP.packCaps > 0) m.threshold = v32 ? MNG_VIP.caps32 : MNG_VIP.packCaps; /* palier haut du pack (20 Mush Caps ou Café) : 123 € pour le VIP, 179 € avec un 3+2 */
      });
      if (MNG_VIP.as && asBase) { var am = mngVipAs(asBase); if (v32) am.threshold = MNG_VIP.seuilAS32; out.push(am); }
      if (v32 && MNG_VIP.sansDuo32) out = out.filter(function (m) { return !m.mngDuo; });
    }
    return out.sort(function (a, b) { return (Number(a.threshold) || 0) - (Number(b.threshold) || 0); });
  }
  var MNG_P06_TX = {
    fr: { gChoco: 'votre Brainstoorm offert', gCafe: 'votre 2e Brainstoorm offert', done: 'Tout est débloqué ✓', sgDuo: 'Ajoutez-le\u00a0: + le Pack Duo offert' },
    it: { gChoco: 'il suo Brainstoorm in regalo', gCafe: 'il suo 2° Brainstoorm in regalo', done: 'Tutto sbloccato ✓', sgDuo: 'Aggiungilo: + il Pack Duo in regalo' },
    es: { gChoco: 'su Brainstoorm de regalo', gCafe: 'su 2.º Brainstoorm de regalo', done: 'Todo desbloqueado ✓', sgDuo: 'Añádalo: + el Dúo de regalo' },
    de: { gChoco: 'Ihren Brainstoorm gratis', gCafe: 'Ihren 2. Brainstoorm gratis', done: 'Alles freigeschaltet ✓', sgDuo: 'Hinzufügen: + das Duo gratis' },
    pt: { gChoco: 'o seu Brainstoorm oferecido', gCafe: 'o seu 2.º Brainstoorm oferecido', done: 'Tudo desbloqueado ✓', sgDuo: 'Adicione: + o Duo oferecido' },
    pl: { gChoco: 'Twojego darmowego Brainstoorma', gCafe: 'Twojego drugiego darmowego Brainstoorma', done: 'Wszystko odblokowane ✓', sgDuo: 'Dodaj: + Duo gratis' },
    cs: { gChoco: 'vašeho Brainstoormu zdarma', gCafe: 'vašeho druhého Brainstoormu zdarma', done: 'Vše odemčeno ✓', sgDuo: 'Přidejte: + Duo zdarma' },
    nl: { gChoco: 'je gratis Brainstoorm', gCafe: 'je 2e gratis Brainstoorm', done: 'Alles ontgrendeld ✓', sgDuo: 'Voeg toe: + het gratis Duo' },
    sv: { gChoco: 'din gratis Brainstoorm', gCafe: 'din 2:a gratis Brainstoorm', done: 'Allt upplåst ✓', sgDuo: 'Lägg till: + gratis Duo' },
    hu: { gChoco: 'az ingyenes Brainstoormodhoz', gCafe: 'a 2. ingyenes Brainstoormodhoz', done: 'Minden feloldva ✓', sgDuo: 'Add hozzá: + az ingyenes Duo' },
    ro: { gChoco: 'Brainstoorm-ul tău cadou', gCafe: 'al 2-lea Brainstoorm cadou', done: 'Totul e deblocat ✓', sgDuo: 'Adaugă: + Duo-ul cadou' },
    hr: { gChoco: 'vašeg besplatnog Brainstoorma', gCafe: 'vašeg 2. besplatnog Brainstoorma', done: 'Sve je otključano ✓', sgDuo: 'Dodajte: + besplatni Duo' },
    bg: { gChoco: 'Вашия Brainstoorm подарък', gCafe: 'Вашия 2-ри Brainstoorm подарък', done: 'Всичко е отключено ✓', sgDuo: 'Добавете: + Duo подарък' },
    el: { gChoco: 'το Brainstoorm δώρο σας', gCafe: 'το 2ο Brainstoorm δώρο σας', done: 'Όλα ξεκλειδώθηκαν ✓', sgDuo: 'Προσθέστε: + Duo δώρο' },
    sk: { gChoco: 'vášho Brainstoormu zdarma', gCafe: 'vášho 2. Brainstoormu zdarma', done: 'Všetko je odomknuté ✓', sgDuo: 'Pridajte: + Duo zdarma' },
    sl: { gChoco: 'vašega brezplačnega Brainstoorma', gCafe: 'vašega 2. brezplačnega Brainstoorma', done: 'Vse je odklenjeno ✓', sgDuo: 'Dodajte: + brezplačni Duo' },
    lt: { gChoco: 'jūsų nemokamo „Brainstoorm“', gCafe: 'jūsų 2-ojo nemokamo „Brainstoorm“', done: 'Viskas atrakinta ✓', sgDuo: 'Pridėkite: + nemokamas Duo' },
    en: { gChoco: 'your free Brainstoorm', gCafe: 'your 2nd free Brainstoorm', done: 'Everything unlocked ✓', sgDuo: 'Add it: + the free Duo' } };
  function mngP06Actif() { return !!MNG_P06.on && !mngFl5Actif(); }
  window.mngP06Actif = mngP06Actif;
  function mngP06(raw) {
    try {
      var C = MNG_FL5.vChoco, K = MNG_FL5.vCafe, ms = raw.milestones || [], pm = raw.packMilestones || [], choco = null, cafePack = null, duo = null;
      var T = mngFl5T(), P = MNG_P06_TX[(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase()] || MNG_P06_TX.en, SG = MNG_FL5_SG();
      var parSeuil = function (a, b) { return (Number(a.threshold) || 0) - (Number(b.threshold) || 0); };
      var B = MNG_FL5.vBoite, bImg = MNG_CAPS_IMG;
      ms.forEach(function (m) { if (m && String(m.giftVariantId) === B && m.giftImage) bImg = m.giftImage; });
      if (raw.packGiftImg && raw.packGiftImg[B]) bImg = raw.packGiftImg[B];
      var CT = mngCapsT(), caps = function (m) {
        m.giftVariantId = Number(B); m.giftQty = MNG_P06.capsQte; m.giftImage = bImg; m.mngCaps = true;
        m.shortLabel = CT.court; m.goalPhrase = CT.g; m.unlockLabel = CT.sg; m.label = m.unlockedLabel = m.doneLabel = m.bannerLabel = CT.nom;
        /* 23/10/2026 (LIBELLE-CAPS20) : note « 2 boîtes de 10 » au lieu de « 1 boîte de 10 » du bloc. */
        m.giftNote = String(CT.n || '').replace('{q}', MNG_P06.capsQte);
      };
      if (MNG_P06.sansBoite) ms = ms.filter(function (m) { return !(m && String(m.giftVariantId) === MNG_FL5.vBoite); });
      ms.forEach(function (m) {
        if (m && String(m.giftVariantId) === C && String(m.type || '').toLowerCase() === 'free_gift') { m.threshold = MNG_P06.choco; m.shortLabel = T.choco; m.goalPhrase = P.gChoco; m.unlockLabel = SG.choco; choco = m; }
        else if (m && String(m.type || '').toLowerCase() === 'free_shipping') { m.shortLabel = T.ship; m.unlockLabel = SG.ship; }
      });
      pm.forEach(function (m) { if (m && String(m.giftVariantId) === K) cafePack = m; else if (m && m.gifts && m.gifts.length > 1) duo = m; });
      if (cafePack && !ms.some(function (m) { return String(m.giftVariantId) === K; })) {
        var kc = JSON.parse(JSON.stringify(cafePack)); delete kc.gifts; delete kc.giftZoom;
        kc.threshold = MNG_P06.cafe; kc.shortLabel = T.cafe; kc.goalPhrase = P.gCafe; kc.unlockLabel = SG.cafe;
        if (mngCaps20()) caps(kc);
        ms.push(kc);
      }
      var npm = [];
      if (choco) {
        var pc = JSON.parse(JSON.stringify(choco)); pc.threshold = MNG_P06.packChoco; pc.gifts = [{ v: Number(C), q: 1 }];
        if (!pc.giftImage && raw.packGiftImg && raw.packGiftImg[C]) pc.giftImage = raw.packGiftImg[C];
        pc.doneLabel = pc.doneLabel || pc.unlockedLabel || pc.label; pc.bannerLabel = pc.bannerLabel || pc.unlockedLabel || pc.label; npm.push(pc);
      }
      if (cafePack) { cafePack.threshold = MNG_P06.packCafe; cafePack.gifts = [{ v: Number(K), q: 1 }]; cafePack.shortLabel = T.cafe; cafePack.goalPhrase = P.gCafe; cafePack.unlockLabel = SG.cafe; npm.push(cafePack); }
      if (duo && MNG_P06.duo > 0) { duo.threshold = MNG_P06.duo; duo.shortLabel = T.duo; duo.unlockLabel = P.sgDuo; duo.mngDuo = true; npm.push(duo); }
      if (mngCaps20Pack()) {
        if (cafePack) { caps(cafePack); cafePack.gifts = [{ v: Number(B), q: MNG_P06.capsQte }]; }
        if (duo && duo.gifts) duo.gifts = duo.gifts.map(function (g) { return String(g.v) === K ? { v: Number(B), q: MNG_P06.capsQte } : g; });
      }
      /* VIP : le palier Chocolat du panier normal passe à 49 € (le seul Chocolat de la barre et des règles) ; le Chocolat des packs (copie pc) ne bouge pas. */
      if (choco && mngVipActif()) { var V = mngVipT(); choco.threshold = MNG_VIP.choco; choco.goalPhrase = V.g; choco.unlockLabel = V.sg; choco.mngVip = true; choco.mngChaque = true; if (MNG_VIP.as) ms.push(mngVipAs(choco)); }
      ms.sort(parSeuil); npm.sort(parSeuil);
      raw.milestones = ms; raw.packMilestones = npm; raw.packDoneText = P.done; raw.mngP06 = true;
    } catch (e) { console.error('[paliers] configuration', e); }
    return raw;
  }
  function mngFl5(raw) {
    if (raw && !Array.isArray(raw) && !mngFl5Actif() && mngP06Actif()) return mngP06(raw);
    if (!raw || Array.isArray(raw) || !mngFl5Actif()) return raw;
    try {
      var C = MNG_FL5.vChoco, K = MNG_FL5.vCafe, ms = raw.milestones || [], pm = raw.packMilestones || [], choco = null, cafePack = null;
      var parSeuil = function (a, b) { return (Number(a.threshold) || 0) - (Number(b.threshold) || 0); };
      var T = mngFl5T();
      if (MNG_FL5.sansBoite) ms = ms.filter(function (m) { return !(m && String(m.giftVariantId) === MNG_FL5.vBoite); }); /* Alex : pas de boîte de 10 à 119 € ce soir */
      ms.forEach(function (m) {
        if (m && String(m.giftVariantId) === C && String(m.type || '').toLowerCase() === 'free_gift') { m.threshold = MNG_FL5.choco; m.shortLabel = T.choco; m.goalPhrase = T.gChoco; m.unlockLabel = MNG_FL5_SG().choco; choco = m; }
        else if (m && String(m.type || '').toLowerCase() === 'free_shipping') { m.shortLabel = T.ship; m.unlockLabel = MNG_FL5_SG().ship; }
      });
      raw.packDoneText = T.done;
      if (MNG_FL5.unique) raw.initialNoGiftPack = false;
      pm.forEach(function (m) {
        if (m && String(m.giftVariantId) === K) { cafePack = m; m.shortLabel = T.cafe; m.goalPhrase = T.gCafe; }
        else if (m && m.gifts && m.gifts.length > 1) m.shortLabel = T.duo;
      });
      if (MNG_FL5.cafe && cafePack) {
        // Panier NORMAL seulement (Alex, 5/10) : palier Café ajouté à seuilCafe. Le palier Café du mode pack reste à 114 €.
        if (!ms.some(function (m) { return String(m.giftVariantId) === K; })) { var kc = JSON.parse(JSON.stringify(cafePack)); delete kc.gifts; delete kc.giftZoom; kc.threshold = MNG_FL5.seuilCafe; kc.unlockLabel = MNG_FL5_SG().cafe; ms.push(kc); }
      }
      if (MNG_FL5.packChoco && choco && pm.length) {
        pm.forEach(function (m) { if (m && m.gifts) m.gifts = m.gifts.filter(function (g) { return String(g.v) !== C; }); });
        var pc = JSON.parse(JSON.stringify(choco));
        pc.gifts = [{ v: Number(C), q: 1 }];
        pc.shortLabel = T.choco; pc.goalPhrase = T.gChoco; pc.doneLabel = pc.doneLabel || pc.unlockedLabel || pc.label; pc.bannerLabel = pc.bannerLabel || pc.unlockedLabel || pc.label;
        if (!pc.giftImage && raw.packGiftImg && raw.packGiftImg[C]) pc.giftImage = raw.packGiftImg[C];
        pm.unshift(pc);
      }
      ms.sort(parSeuil); pm.sort(parSeuil);
      raw.milestones = ms; raw.packMilestones = pm;
    } catch (e) { console.error('[flash] paliers', e); }
    return raw;
  }

  /** Règle Alex 18/09/2026 : dès qu'un 3+3 ou un 3+2 est dans le panier, aucun cadeau de palier (free_gift). Même liste que mng4_no_gift_ids (Liquid). */
  // 02/10/2026 : + Mush Caps Ultime, mêmes cadeaux et paliers que le 3+2 (Alex). Les autres Mush Caps restent en règle normale.
  /* 23/10/2026 (ULTIME-HORS-PACK, Alex) : l'Ultime (15906127249782, 60 capsules sans Brainstoorm) retiré : paliers normaux. */
  var MNG_NO_GIFT_PRODUCT_IDS = ['15883228643702', '15888642605430'];
  function cartHasNoGiftProduct(cart) {
    if (MNG_FL5.unique && mngFl5Actif()) return false;
    return ((cart && cart.items) || []).some(function (it) {
      return it && it.quantity > 0 && MNG_NO_GIFT_PRODUCT_IDS.indexOf(String(it.product_id)) !== -1;
    });
 }

 /** Offre Alex 18/09/2026 : panier avec 3+3 ou 3+2 = paliers « packMilestones » (119 € Café CADEAU, 169 € + Chocolat CADEAU)
 *  à la place du palier cadeau standard (89 €, interdit pour ces paniers). Paliers livraison inchangés. Autres paniers : config telle quelle.
 *  cart absent = premier rendu : on suit le Liquid (initialNoGiftPack). */
 function mngEffectiveMilestones(raw, cart) {
  var base = Array.isArray(raw) ? raw : ((raw && raw.milestones) || []);
  var isPack = cart ? cartHasNoGiftProduct(cart) : !!(raw && raw.initialNoGiftPack);
  if (!isPack) return mngSansCadeauxSiCode(base, cart);
  var pack = mngP06Pack(raw, cart);
  return base.filter(function (m) { return (m.type || '').toString().toLowerCase() !== 'free_gift'; }).concat(pack);
 }
 function mngAllMilestones(raw) {
  var base = Array.isArray(raw) ? raw : ((raw && raw.milestones) || []);
  return base.concat((!Array.isArray(raw) && raw && raw.packMilestones) || []);
  }

  /** Merch subtotal / milestones / discount: excludes auto-gift lines (_gift or configured free-gift SKU at 0 final). */
  function lineExcludedFromMerchTotals(item, giftVariantIds) {
    if (!item || item.quantity <= 0) return false;
    if (item.properties && cartLineIsAutoGift(item.properties)) return true;
    var vid = String(item.variant_id);
    if (giftVariantIds.indexOf(vid) === -1) return false;
    return lineIsRemovableGiftSku(item, vid);
  }

  // 29/09/2026 (BUG-01, BUG-07) : la bulle du header et la pastille du tiroir ne comptent que les articles
  // payants : ni l'assurance colis, ni les cadeaux (ligne _gift, variante cadeau connue de window.MNG_GIFT,
  // produit à 0 € au catalogue). Même règle que le Liquid de sections/unified-header.liquid.
  function mngLigneComptee(it, insuranceVid) {
    if (!it || !(Number(it.quantity) > 0)) return false;
    var vid = String(it.variant_id);
    if (insuranceVid && vid === String(insuranceVid)) return false;
    if (it.handle === 'assurance-colis') return false;
    var pr = it.properties || {};
    if (cartLineIsAutoGift(pr) || pr._cart_upsell === 'insurance') return false;
    var gv = (window.MNG_GIFT && Array.isArray(window.MNG_GIFT.variants)) ? window.MNG_GIFT.variants : [];
    if (gv.indexOf(vid) !== -1) return false;
    if (Number(it.original_price) === 0) return false;
    return true;
  }
  // 29/09/2026 (BUG-10) : empreinte d'un panier (lignes et total), pour savoir si une synchro l'a changé.
  function mngSignaturePanier(c) {
    return c ? String(c.total_price) + '|' + ((c.items || []).map(function (i) { return i.key + ':' + i.quantity; }).join(',')) : '';
  }
  // 29/09/2026 (BUG-01) : même balisage que le Liquid de sections/unified-header.liquid (bulle, chiffre).
  var MNG_BULLES = {
    'cart-icon-bubble-mobile': ['cart-count-bubble absolute -top-2 -right-2 bg-yellow text-darkpurple min-w-[20px] h-[20px] flex items-center justify-center rounded-full font-bold leading-none px-0.5 shadow-md z-10', 'text-[11px] font-bold'],
    'cart-icon-bubble': ['cart-count-bubble absolute -top-2 -right-2 md:-top-2.5 md:-right-2.5 bg-yellow text-darkpurple min-w-[22px] h-[22px] md:min-w-[26px] md:h-[26px] flex items-center justify-center rounded-full font-bold leading-none px-1 md:px-1.5 shadow-md z-10', 'text-[12px] md:text-[14px] font-bold']
  };

  // 02/10/2026 (CADEAUX-ULTIME) : page /cart (sections/main-cart.liquid). Son formulaire envoie les quantités par
  // numéro de ligne (updates[]) : après une correction des cadeaux, on la recharge au lieu de l'envoyer.
  function mngPagePanier() {
    return !!((window.MNG_GIFT && window.MNG_GIFT.isCartPage) || document.getElementById('main-cart-items'));
  }
  function mngRechargerPagePanier() {
    var cle = 'mngCadeauxGardeRecharge', s = null, t = Date.now();
    try { s = JSON.parse(sessionStorage.getItem(cle) || 'null'); } catch (e) { s = null; }
    if (!s || t - (s.t || 0) > 20000) s = { n: 0, t: t };
    if (s.n >= 2) { console.error('[cadeaux] page panier non rechargée : déjà 2 rechargements en 20 s, re-dessin sans rechargement'); mngRedessinerPagePanier(); return; }
    try { sessionStorage.setItem(cle, JSON.stringify({ n: s.n + 1, t: s.t })); } catch (e) { /* stockage bloqué */ }
    window.location.reload();
  }

  // 13/10/2026 (BUG-PANIER-SUPPRESSION) : la page /cart envoie « − » et « Supprimer » par NUMÉRO de ligne (assets/cart.js).
  // Quand un cadeau est retiré en arrière-plan (garde, cadeau seul de layout/theme.liquid) sans que la page soit rechargée
  // (plafond de 2 rechargements en 20 s, ou garde qui n'a rien changé elle-même), la page montre une ligne qui n'existe plus
  // et chaque clic vise une mauvaise ligne : refus de Shopify ou autre article modifié (« rien ne fonctionne »).
  // Ici : la page est comparée au panier réel (variantes, dans l'ordre) et re-dessinée sans rechargement si elle diffère.
  function mngPagePanierPerimee(cart) {
    var rows = document.querySelectorAll('#main-cart-items .cart-item');
    var vus = Array.prototype.map.call(rows, function (r) {
      var a = r.querySelector('a[href*="variant="]'), m = a && /variant=(\d+)/.exec(a.getAttribute('href') || '');
      return m ? m[1] : '?';
    });
    var vrais = ((cart && cart.items) || []).map(function (i) { return String(i.variant_id); });
    return vus.join(',') !== vrais.join(',');
  }
  function mngRedessinerPagePanier() {
    var items = document.getElementById('main-cart-items');
    var id = items && items.getAttribute('data-id');
    if (!id) { console.error('[cadeaux] re-dessin de la page panier impossible : section introuvable'); return Promise.resolve(false); }
    var url = window.location.pathname + '?sections=' + encodeURIComponent(id) + '&_=' + Date.now();
    return fetch(url, { credentials: 'same-origin', headers: { 'X-MNG-Cadeaux': '1' } }) /* pas d'Accept JSON : /cart renverrait le panier au lieu des sections */
      .then(function (res) { if (!res.ok) throw new Error('sections ' + res.status); return res.json(); })
      .then(function (data) {
        var html = data && data[id];
        if (!html) throw new Error('section vide');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neuf = doc.querySelector('#main-cart-items .js-contents'), ici = document.querySelector('#main-cart-items .js-contents');
        var piedNeuf = doc.getElementById('main-cart-footer'), pied = document.getElementById('main-cart-footer');
        if (neuf && ici && piedNeuf && pied) { ici.innerHTML = neuf.innerHTML; pied.innerHTML = piedNeuf.innerHTML; return true; }
        // panier vide : la section rend l'état vide hors du formulaire, on remplace toute la section
        var section = items.closest('.shopify-section'), sectionNeuve = doc.querySelector('.shopify-section');
        if (section && sectionNeuve) { section.innerHTML = sectionNeuve.innerHTML; return true; }
        throw new Error('balisage de la section inattendu');
      })
      .catch(function (e) { console.error('[cadeaux] re-dessin de la page panier en échec', e); return false; });
  }

  class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('#CartDrawer-Overlay');
    this.drawer = this.querySelector('#CartDrawer');
    
    // Load config (locale, currency, routes, strings)
    const configEl = document.getElementById('CartDrawer-Config');
    this.config = configEl ? (function() { try { return JSON.parse(configEl.textContent); } catch(e) { return {}; } })() : {};
    this.routes = this.config.routes || {};
    this.strings = this.config.strings || {};
    this.locale = this.config.locale || 'fr';
    this.currency = this.normalizeCurrency(this.config.currency) || 'EUR';
    
    // Close on overlay click
    this.overlay?.addEventListener('click', () => this.close());
    
    // Escape : géré au niveau document pendant l'ouverture (voir open()) — un listener
    // local ne reçoit rien tant que le focus est hors du drawer (audit a11y 2026-06-10)
    
    this.setupDelegatedEvents();
    this.loadRecommendationsIfNeeded();
    this.loadEmptyRecommendationsIfNeeded();
    this.loadMobileRecommendationsIfNeeded();
    this.setupMobileSlider();
    this.setupSubHeaderCarousel();
    this.setupInsuranceToggle();
    this.setupPromoCode();
    this.updateProgress((this.config && this.config.init_eligible) || 0, this.currency);
    // 02/10/2026 (CADEAUX-ULTIME) : panier rendu avec au moins une ligne cadeau (_gift, compte Liquid initialGiftLines) :
    // garde au chargement (panier changé sur /cart, dans un autre onglet, vieux cookie). Sans cadeau : aucune requête.
    try {
      var mngPc = mngFl5(JSON.parse((document.getElementById('CartDrawer-ProgressConfig') || {}).textContent || 'null'));
      if (mngPc && Number(mngPc.initialGiftLines) > 0) this.mngApresMutation('chargement', 0);
    } catch (e) { console.error('[cadeaux] configuration des paliers illisible au chargement', e); }
    window.addEventListener('pageshow', () => { this._mngPaiement = false; });

    // Listen for cart:updated from external ATC buttons (product pages, upsell blocks, etc.)
    document.addEventListener('cart:updated', async (event) => {
      const cart = event.detail;
      if (cart && typeof cart.item_count !== 'undefined') {
        if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
        await this.refreshFromCart(cart);
      } else {
        try {
          const res = await fetch(this.getCartJsUrl(), cartFetchOpts({ headers: CART_ACCEPT }));
          const cartData = await parseJsonResponse(res);
          if (cartData.currency) this.currency = this.normalizeCurrency(cartData.currency);
          await this.refreshFromCart(cartData);
        } catch (err) {
        }
      }
    });
    var resizeT = 0;
    window.addEventListener('resize', function() {
      clearTimeout(resizeT);
      resizeT = setTimeout(function() {
        if (typeof this.updateEmptySuggestionsDesktopVisibility === 'function') this.updateEmptySuggestionsDesktopVisibility();
      }.bind(this), 150);
    }.bind(this));
  }

  async loadRecommendationsIfNeeded() {
    const placeholder = this.querySelector('.cart-drawer-recommendations-placeholder[data-recommendations-url]');
    if (!placeholder || !placeholder.dataset.recommendationsUrl) {
      return;
    }
    const url = placeholder.dataset.recommendationsUrl;
    try {
      const res = await fetch(url);
      const text = await res.text();
      const wrap = document.createElement('div');
      wrap.innerHTML = text;
      const sectionEl = wrap.querySelector('[id^="shopify-section-"]');
      const content = sectionEl ? sectionEl.innerHTML : text;
      if (content.trim()) {
        placeholder.innerHTML = content;
        var cards = placeholder.querySelectorAll('.cart-drawer-rec-card');
        for (var c = 3; c < cards.length; c++) cards[c].remove();
        placeholder.classList.remove('cart-drawer-recommendations-placeholder');
        this.formatAllDrawerMoney();
      } else {
        placeholder.innerHTML = '';
      }
    } catch (err) {
      placeholder.innerHTML = '';
    }
  }

  async loadEmptyRecommendationsIfNeeded() {
    const placeholder = this.querySelector('.cart-drawer-empty-recommendations-placeholder[data-empty-recommendations-url]');
    if (!placeholder || !placeholder.dataset.emptyRecommendationsUrl) return;
    const url = placeholder.dataset.emptyRecommendationsUrl;
    try {
      const res = await fetch(url);
      const text = await res.text();
      const wrap = document.createElement('div');
      wrap.innerHTML = text;
      const sectionEl = wrap.querySelector('[id^="shopify-section-"]');
      const content = sectionEl ? sectionEl.innerHTML : text;
      if (content.trim()) {
        placeholder.innerHTML = content;
        placeholder.classList.remove('cart-drawer-empty-recommendations-placeholder');
        placeholder.classList.add('flex', 'flex-col', 'gap-3', 'w-full');
        this.formatAllDrawerMoney();
      } else {
        placeholder.innerHTML = '';
      }
    } catch (err) {
      placeholder.innerHTML = '';
    }
  }

  // ── Mobile recommendations AJAX placeholder → Splide slides ────────────────
  async loadMobileRecommendationsIfNeeded() {
    const placeholder = this.querySelector('.cart-drawer-mobile-recommendations-placeholder[data-recommendations-url]');
    if (!placeholder || !placeholder.dataset.recommendationsUrl) return;
    const url = placeholder.dataset.recommendationsUrl;
    const list = this.querySelector('#CartDrawer-MobileSplide .splide__list');
    if (!list) return;
    try {
      const res = await fetch(url);
      const text = await res.text();
      const wrap = document.createElement('div');
      wrap.innerHTML = text;
      const cards = wrap.querySelectorAll('.cart-drawer-rec-card');
      if (cards.length) {
        placeholder.closest('.splide__slide').remove();
        cards.forEach(function (card) {
          card.classList.remove('mb-[22px]');
          const li = document.createElement('li');
          li.className = 'splide__slide';
          li.appendChild(card);
          list.appendChild(li);
        });
        this.formatAllDrawerMoney();
        if (this.mobileSplide) this.mobileSplide.refresh();
      } else {
        placeholder.closest('.splide__slide').remove();
        if (this.mobileSplide) this.mobileSplide.refresh();
      }
    } catch (err) {
      if (placeholder.parentElement) placeholder.closest('.splide__slide') && placeholder.closest('.splide__slide').remove();
    }
  }

  // ── Mobile suggestions: Splide carousel (1 per slide, gap, arrows) ────────
  setupMobileSlider() {
    const root = this.querySelector('#CartDrawer-MobileSplide');
    if (!root) return;
    if (typeof window.Splide === 'undefined') {
      var self = this;
      window.addEventListener('load', function once() {
        window.removeEventListener('load', once);
        self.setupMobileSlider();
      });
      return;
    }

    if (this.mobileSplide) {
      this.mobileSplide.destroy();
      this.mobileSplide = null;
    }

    this.mobileSplide = new window.Splide(root, {
      perPage: 1,
      gap: '0.75rem',
      arrows: true,
      pagination: false,
      rewind: true,
      drag: true,
      waitForTransition: true,
      autoHeight: true
    });

    this.mobileSplide.mount();
  }

  setupSubHeaderCarousel() {
    if (this._subHeaderCarouselTimer) {
      clearInterval(this._subHeaderCarouselTimer);
      this._subHeaderCarouselTimer = null;
    }
    const root = this.querySelector('#CartDrawer-SubHeaderCarousel');
    if (!root) return;
    const slides = Array.prototype.slice.call(root.querySelectorAll('.cd-subheader-slide'));
    if (slides.length < 2) return;
    const intervalMs = Math.max(2000, parseInt(String(root.dataset.interval || '6000'), 10) || 6000);
    const respectReduced = root.dataset.respectReducedMotion !== 'false';
    if (respectReduced && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    var idx = 0;
    function show(i) {
      slides.forEach(function (s, j) {
        var on = j === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    }
    this._subHeaderCarouselTimer = setInterval(function () {
      idx = (idx + 1) % slides.length;
      show(idx);
    }, intervalMs);
  }

  async open() {
    const opts = typeof arguments[0] === 'object' ? arguments[0] : {};
    const skipSync = opts.skipSync === true;

    // a11y : mémoriser le déclencheur pour y rendre le focus à la fermeture
    this._returnFocusEl = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    // Add active class for CSS compatibility
    this.classList.add('animate', 'active');

    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('overflow-hidden');

    // Show overlay
    this.overlay.style.opacity = '1';
    this.overlay.style.pointerEvents = 'auto';

    // Show drawer
    this.drawer.style.transform = 'translateX(0)';
    if (this.drawer) this.drawer.setAttribute('aria-hidden', 'false');

    // a11y (audit 2026-06-10) : sans déplacement du focus dans le dialog, clavier et
    // lecteur d'écran restaient derrière l'overlay (8 Tab consécutifs hors drawer mesurés)
    const closeBtn = this.querySelector('.cart-drawer-close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    if (!this._docKeydownHandler) {
      this._docKeydownHandler = (e) => {
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key !== 'Tab' || !this.drawer) return;
        const focusables = Array.from(this.drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
        )).filter((el) => el.offsetParent !== null);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (!this.drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
    }
    document.addEventListener('keydown', this._docKeydownHandler);
    
    // Sync totals and checkout button with current cart when opening (skip if already have fresh cart, e.g. from refreshFromCart)
    if (!skipSync) {
      try {
        const cartUrl = (this.routes.cart || '/cart');
        const cartJsUrl = cartUrl.endsWith('.js') ? cartUrl : cartUrl + '.js';
        const res = await fetch(cartJsUrl, cartFetchOpts({ headers: CART_ACCEPT }));
        const cart = await parseJsonResponse(res);
        if (cart && typeof this.updateCartUI === 'function') this.updateCartUI(cart);
      } catch (e) {
      }
    } else if (typeof this.updateEmptySuggestionsDesktopVisibility === 'function') {
      this.updateEmptySuggestionsDesktopVisibility();
    }
  }

  close() {
    if (this._docKeydownHandler) document.removeEventListener('keydown', this._docKeydownHandler);
    // a11y : rendre le focus au déclencheur AVANT de poser aria-hidden — un focus laissé
    // dans du contenu masqué est perdu pour le lecteur d'écran (mesuré à l'audit)
    if (this._returnFocusEl && document.contains(this._returnFocusEl)) {
      this._returnFocusEl.focus({ preventScroll: true });
    }
    // filet : si la restitution n'a pas pris (déclencheur disparu, ou body non focusable
    // après une ouverture programmatique), ne jamais laisser le focus dans le contenu masqué
    if (this.drawer && this.drawer.contains(document.activeElement) && document.activeElement.blur) {
      document.activeElement.blur();
    }
    this._returnFocusEl = null;

    // Remove active class
    this.classList.remove('active', 'animate');

    document.body.style.overflow = '';
    document.documentElement.classList.remove('overflow-hidden');
    
    // Hide overlay
    this.overlay.style.opacity = '0';
    this.overlay.style.pointerEvents = 'none';
    
    // Hide drawer
    this.drawer.style.transform = 'translateX(100%)';
    if (this.drawer) this.drawer.setAttribute('aria-hidden', 'true');
  }

  async refreshFromCart(cart) {
    // Called when items are added from product pages – update UI first, then open
    await this.updateCartUI(cart);
    this.open({ skipSync: true });
  }

  /**
   * Fetch section HTML via Section Rendering API. Tries current path first (section ID is template-scoped),
   * then root URL, then section_id endpoint (returns raw HTML) when sections= returns null.
   */
  async fetchSectionHtml(sectionId) {
    const cacheBuster = '&_=' + Date.now();
    const rootPath = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root.replace(/\/$/, '') || '/' : '/';
    const currentPath = window.location.pathname || '/';
    const pathsToTry = [currentPath, rootPath];
    
    const trySectionsApi = async (path) => {
      const sep = path.includes('?') ? '&' : '?';
      const url = path + sep + 'sections=' + encodeURIComponent(sectionId) + cacheBuster;
      const res = await fetch(url, cartFetchOpts({ headers: CART_ACCEPT }));
      const data = await parseJsonResponse(res);
      let html = data && data[sectionId];
      if (typeof html === 'string' && html.length > 0) return html;
      if (data && typeof data === 'object') {
        const key = Object.keys(data).find(k => k && typeof data[k] === 'string' && data[k].length > 0);
        if (key) return data[key];
      }
      return null;
    };
    
    // 1) Try sections API (current path then root)
    for (const path of pathsToTry) {
      try {
        const html = await trySectionsApi(path);
        if (html) return html;
      } catch (e) {
      }
    }
    
    // 2) Try section_id API (single section, returns raw HTML) – current path then root
    for (const path of pathsToTry) {
      try {
        const sep = path.includes('?') ? '&' : '?';
        const url = path + sep + 'section_id=' + encodeURIComponent(sectionId) + cacheBuster;
        const res = await fetch(url, { headers: { 'Accept': 'text/html' } });
        const text = await res.text();
        if (text && text.trim().length > 0) return text;
      } catch (e) {
      }
    }
    return null;
  }

  async refreshLineItemsOnly(cart) {
    const sectionId = this.dataset.sectionId || 'cart-group__cart_drawer';
    log('refreshLineItemsOnly: start', { sectionId, cartItemCount: (cart && cart.items) ? cart.items.length : 0 });
    const currentCartItems = this.querySelector('#CartDrawer-CartItems');
    if (currentCartItems) currentCartItems.classList.add('cd-refreshing');
    try {
      const sectionHtml = await this.fetchSectionHtml(sectionId);
      const hasHtml = sectionHtml && typeof sectionHtml === 'string';
      if (!hasHtml) {
        if (currentCartItems) currentCartItems.classList.remove('cd-refreshing');
        return this.refreshDrawerContent(cart);
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const newCartDrawer = doc.querySelector('cart-drawer');
      const newCartItems = newCartDrawer ? newCartDrawer.querySelector('#CartDrawer-CartItems') : null;

      if (newCartItems && currentCartItems) {
        currentCartItems.classList.remove('cd-refreshing');
        currentCartItems.innerHTML = newCartItems.innerHTML;
        currentCartItems.querySelectorAll('.cart-line-item').forEach(function (el) {
          el.classList.add('cd-item-enter');
          el.addEventListener('animationend', function () { el.classList.remove('cd-item-enter'); }, { once: true });
        });
        if (cart && cart.items && cart.items.length) this.appendMissingGiftLineItems(cart);
      } else {
        if (currentCartItems) currentCartItems.classList.remove('cd-refreshing');
        return this.refreshDrawerContent(cart);
      }
    } catch (err) {
      if (currentCartItems) currentCartItems.classList.remove('cd-refreshing');
      return this.refreshDrawerContent(cart);
    }
  }

  /**
   * Group display by variant + selling_plan + properties: merge adjacent rows with same group key into one row.
   * No API merge – cart stays as-is; we only collapse the item list display.
   */
  collapseDuplicateDisplayRows() {
    const container = this.querySelector('#CartDrawer-CartItems');
    if (!container) return;
    function propsGroupKey(propsAttr) {
      if (!propsAttr || propsAttr === '{}') return '{}';
      try {
        const raw = propsAttr.replace(/&quot;/g, '"').replace(/&amp;/g, '&');
        const o = JSON.parse(raw);
        if (!o || typeof o !== 'object') return '{}';
        const keys = Object.keys(o).sort();
        const out = {};
        keys.forEach(function (k) { out[k] = o[k]; });
        return JSON.stringify(out);
      } catch (_) { return propsAttr || '{}'; }
    }
    function rowGroupKey(row) {
      const vid = (row.getAttribute('data-variant-id') || '').trim();
      const sp = (row.getAttribute('data-selling-plan-id') || '').trim();
      const props = propsGroupKey(row.getAttribute('data-properties') || '');
      return vid + '|' + sp + '|' + props;
    }
    function getRowKeys(row) {
      const keysStr = row.getAttribute('data-line-keys') || row.getAttribute('data-line-key') || '';
      return keysStr.split(',').map(function (k) { return k.trim(); }).filter(Boolean);
    }
    function setRowKeys(row, keys) {
      if (keys.length) {
        row.setAttribute('data-line-key', keys[0]);
        row.setAttribute('data-line-keys', keys.join(','));
        row.querySelectorAll('[data-line-key]').forEach(function (el) { el.setAttribute('data-line-key', keys[0]); });
      }
    }
    const rows = Array.prototype.slice.call(container.querySelectorAll('.cart-line-item')).filter(function (row) {
      return !row.classList.contains('cart-line-item--gift') && row.getAttribute('data-is-gift') !== 'true';
    });
    var i = 1;
    while (i < rows.length) {
      const prev = rows[i - 1];
      const curr = rows[i];
      if (rowGroupKey(prev) !== rowGroupKey(curr)) {
        i++;
        continue;
      }
      const prevKeys = getRowKeys(prev);
      const currKeys = getRowKeys(curr);
      const currQtyEl = curr.querySelector('.qty-value');
      const prevQtyEl = prev.querySelector('.qty-value');
      var addQty = 0;
      if (currQtyEl) {
        var n = parseInt(currQtyEl.textContent, 10);
        if (!isNaN(n)) addQty = n;
      }
      setRowKeys(prev, prevKeys.concat(currKeys));
      if (prevQtyEl) prevQtyEl.textContent = (parseInt(prevQtyEl.textContent, 10) || 0) + addQty;
      const subscribeCheckbox = prev.querySelector('.subscribe-checkbox');
      if (subscribeCheckbox) subscribeCheckbox.dataset.quantity = prevQtyEl ? prevQtyEl.textContent : '';
      curr.remove();
      rows.splice(i, 1);
    }
  }

  /**
   * Appends gift line item nodes for any cart items that are free_gift milestones but missing from the DOM.
   * Fixes the case where the section was rendered before the gift was in the cart (e.g. after syncGiftProducts).
   */
  appendMissingGiftLineItems(cart) {
    const configEl = document.getElementById('CartDrawer-ProgressConfig');
    if (!configEl) {
      log('appendMissingGiftLineItems: no config');
      return;
    }
    let raw;
    try { raw = mngFl5(JSON.parse(configEl.textContent)); } catch (e) {
      log('appendMissingGiftLineItems: config parse error', e);
      return;
    }
  const milestonesRaw = mngEffectiveMilestones(raw, cart).concat(mngAllMilestones(raw));
    const giftVariantIds = milestonesRaw
      .filter(function (m) {
        const type = (m.type || '').toString().toLowerCase();
        const gid = m.giftVariantId;
        return type === 'free_gift' && gid != null && String(gid) !== '0';
      })
      .map(function (m) { return String(m.giftVariantId); });
    if (!giftVariantIds.length) {
      log('appendMissingGiftLineItems: no gift variant IDs in config');
      return;
    }

    const container = this.querySelector('#CartDrawer-CartItems');
    if (!container) {
      log('appendMissingGiftLineItems: no #CartDrawer-CartItems');
      return;
    }

    const existingKeys = new Set();
    container.querySelectorAll('.cart-line-item[data-line-key]').forEach(function (el) {
      const k = el.getAttribute('data-line-key');
      if (k) existingKeys.add(k);
    });
    // Count existing gift nodes per variant (section may render gift with different key than current cart)
    const existingGiftCountByVariant = {};
    giftVariantIds.forEach(function (vid) { existingGiftCountByVariant[vid] = 0; });
    container.querySelectorAll('.cart-line-item--gift').forEach(function (el) {
      const vid = el.getAttribute('data-variant-id') || (function () {
        const key = el.getAttribute('data-line-key');
        const item = (cart.items || []).find(function (i) { return i.key === key; });
        return item ? String(item.variant_id) : null;
      })();
      if (vid) existingGiftCountByVariant[String(vid)] = (existingGiftCountByVariant[String(vid)] || 0) + 1;
    });
    function isGiftLine(item) {
      return item.properties && cartLineIsAutoGift(item.properties);
    }
    const giftCountInCartByVariant = {};
    (cart.items || []).forEach(function (item) {
      if (!giftVariantIds.includes(String(item.variant_id)) || !isGiftLine(item)) return;
      giftCountInCartByVariant[String(item.variant_id)] = (giftCountInCartByVariant[String(item.variant_id)] || 0) + 1;
    });
    log('appendMissingGiftLineItems', { giftVariantIds, existingKeyCount: existingKeys.size, cartItemCount: (cart.items || []).length, existingGiftCountByVariant, giftCountInCartByVariant });

    const currency = (cart.currency || this.currency || '').toString().trim();
    var appended = 0;
    (cart.items || []).forEach(function (item) {
      if (existingKeys.has(item.key)) return;
      if (!giftVariantIds.includes(String(item.variant_id)) || !isGiftLine(item)) return;
      var existingForVariant = existingGiftCountByVariant[String(item.variant_id)] || 0;
      var neededForVariant = giftCountInCartByVariant[String(item.variant_id)] || 1;
      if (existingForVariant >= neededForVariant) return;

      log('appendMissingGiftLineItems: appending gift', { key: item.key, variant_id: item.variant_id, title: item.product_title || item.title });
      appended++;
      const title = (item.product_title || item.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      const variantTitle = (item.variant_title || '');
      const variantTitleEscaped = variantTitle.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      let imgUrl = '';
      if (item.image && typeof item.image === 'string') imgUrl = item.image;
      else if (item.image && item.image.url) imgUrl = item.image.url;
      else if (item.featured_image && item.featured_image.url) imgUrl = item.featured_image.url;
      // Panier v4 : même carte que le rendu serveur (maquette). Note et valeur lues dans la
      // configuration du palier ; une ligne qui coûte quelque chose affiche son prix.
      const mng4M = milestonesRaw.find(function (m) { return String(m.giftVariantId) === String(item.variant_id); }) || {};
      const mng4Qty = Math.max(1, Number(item.quantity) || 1);
      var mng4Value = (Number(mng4M.giftValue) || 0) * mng4Qty;
      if (Number(item.original_line_price) > mng4Value) mng4Value = Number(item.original_line_price);
      const mng4Final = Number(item.final_line_price) || 0;
   const mng4Name = mng4Esc(String(item.product_title || item.title || '').split(' - ')[0] + (mng4Qty > 1 ? ' ×' + mng4Qty : ''));
      const mng4Strings = this.strings || {};
      const mng4Price = mng4Final === 0
        ? '<b>' + (mng4Strings.gift_free || '') + '</b>' + (mng4Value > 0 ? '<s>' + mng4Esc(this.formatMoney(mng4Value, currency)) + '</s>' : '')
        : '<b>' + mng4Esc(this.formatMoney(mng4Final, currency)) + '</b>' + (mng4Value > mng4Final ? '<s>' + mng4Esc(this.formatMoney(mng4Value, currency)) + '</s>' : '');
      const html =
        '<div class="cart-line-item cart-line-item--gift mng4-line mng4-giftl" data-line-key="' + mng4Esc(item.key || '') + '" data-variant-id="' + mng4Esc(item.variant_id) + '" data-is-gift="true">' +
        '<span class="mng4-l-imgw">' + (imgUrl ? '<img alt="' + mng4Name + '" class="mng4-l-img" src="' + mng4Esc(imgUrl) + '" loading="lazy" width="76" height="76">' : '') + '</span>' +
        '<div class="mng4-l-body">' +
        '<span class="mng4-tag">' + (mng4Strings.gift_tag || '') + '</span>' +
        '<div class="mng4-l-top"><p class="mng4-l-name font-[\'IntegralCF\'] font-bold not-italic uppercase">' + mng4Name + '</p>' +
        '<div class="mng4-l-price' + (mng4Final === 0 ? ' is-free' : '') + '">' + mng4Price + '</div></div>' +
        (mng4M.giftNote ? '<p class="mng4-l-var">' + mng4Esc(mng4M.giftNote) + '</p>' : '') +
        '</div></div>';

      container.insertAdjacentHTML('beforeend', html);
      const newEl = container.lastElementChild;
      if (newEl) {
        newEl.classList.add('cd-item-enter');
        newEl.addEventListener('animationend', () => newEl.classList.remove('cd-item-enter'), { once: true });
      }
      existingKeys.add(item.key);
      existingGiftCountByVariant[String(item.variant_id)] = (existingGiftCountByVariant[String(item.variant_id)] || 0) + 1;
    }.bind(this));
    if (appended) log('appendMissingGiftLineItems: appended', appended, 'gift(s)');
  }

  async refreshSuggestions() {
    const drawer = this.querySelector('#CartDrawer');
    if (!drawer || !drawer.firstElementChild) {
      return;
    }
    const sectionId = this.dataset.sectionId || 'cart-group__cart_drawer';
    try {
      const sectionHtml = await this.fetchSectionHtml(sectionId);
      if (!sectionHtml) {
        return;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const newDrawer = doc.querySelector('#CartDrawer');
      const newSidebar = newDrawer?.firstElementChild;
      const currentSidebar = drawer.firstElementChild;
      if (newSidebar && currentSidebar && newSidebar.tagName === currentSidebar.tagName) {
        currentSidebar.innerHTML = newSidebar.innerHTML;
        this.loadRecommendationsIfNeeded();
        this.formatAllDrawerMoney();
      }
      // Also refresh mobile slider
      const newMobileSlider = doc.querySelector('#CartDrawer-MobileSuggestions');
      const currentMobileSlider = this.querySelector('#CartDrawer-MobileSuggestions');
      if (newMobileSlider && currentMobileSlider) {
        currentMobileSlider.innerHTML = newMobileSlider.innerHTML;
        this.loadMobileRecommendationsIfNeeded();
        this.setupMobileSlider();
        this.formatAllDrawerMoney();
      }
    } catch (err) {
    }
  }

  async refreshDrawerContent(cart) {
    const wasOpen = this.classList.contains('active');
    const sectionId = this.dataset.sectionId || 'cart-group__cart_drawer';
    
    try {
      const sectionHtml = await this.fetchSectionHtml(sectionId);
      if (!sectionHtml) {
        return;
      }
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const inner = doc.querySelector('cart-drawer');
      if (inner) {
        this.innerHTML = inner.innerHTML;
      }
      
      this.overlay = this.querySelector('#CartDrawer-Overlay');
      this.drawer = this.querySelector('#CartDrawer');
      this.overlay?.addEventListener('click', () => this.close());
      this.setupDelegatedEvents();
      this.loadRecommendationsIfNeeded();
      this.setupInsuranceToggle();
      this.setupPromoCode();
      this.setupSubHeaderCarousel();
      
      if (cart && cart.items && cart.items.length && typeof this.appendMissingGiftLineItems === 'function') {
        this.appendMissingGiftLineItems(cart);
      }
      if (wasOpen) this.open({ skipSync: true });
    } catch (err) {
      if (wasOpen) this.open({ skipSync: true });
    }
  }

  setupDelegatedEvents() {
    // Guard: only set up once
    if (this._delegatedEventsSetup) {
      return;
    }
    this._delegatedEventsSetup = true;

    // 29/09/2026 (CLIC-01) : plus de clic dans le vide. La pastille « Débloquez … » d'une suggestion ajoute ce
    // produit (comme son bouton, même prix affiché dessous) ; la ligne « Total » mène au paiement (comme le bouton jaune).
    this.addEventListener('click', (e) => {
      const cible = e.target && e.target.closest ? e.target : null;
      if (!cible) return;
      const pastille = cible.closest('.mng4-unlock');
      if (pastille && !pastille.hidden) {
        const carte = pastille.closest('[data-suggestion-product-id]');
        const bouton = carte && carte.querySelector('form[data-cart-drawer-suggestion-form] button[type="submit"]');
        if (bouton && !bouton.disabled) { e.preventDefault(); bouton.click(); }
        return;
      }
      if (cible.closest('[data-mng-total]')) {
        const cta = this.querySelector('#CartDrawer-CheckoutForm');
        if (cta) cta.click();
      }
    });

    // Panier v4 : code promo replié derrière « J'ai un code promo ».
    this.addEventListener('click', (e) => {
      const t = e.target && e.target.closest ? e.target.closest('.mng4-promo-toggle') : null;
      if (t) this.mng4PromoOpen(t.getAttribute('aria-expanded') !== 'true');
    });

    // Panier v4 : le script d'A/B test (Intelligems, groupe B) remplace data-selling-plan-id de la
    // case par le plan « 1er mois réduit » après le rendu : on relit alors le prix de ce plan.
    if (typeof MutationObserver === 'function') {
      this._mng4PlanObserver = new MutationObserver((muts) => {
        const seen = new Set();
        muts.forEach((m) => {
          const line = m.target && m.target.closest ? m.target.closest('.cart-line-item') : null;
          if (!line || seen.has(line)) return;
          seen.add(line);
          const key = (line.getAttribute('data-line-key') || '').split(',')[0].trim();
          const item = this._lastCart && (this._lastCart.items || []).find((i) => i.key === key);
          this.mng4SyncSub(line, item || null);
        });
      });
      this._mng4PlanObserver.observe(this, { attributes: true, subtree: true, attributeFilter: ['data-selling-plan-id'] });
    }

    // Quantity clicks are optimistic: the UI updates instantly, network calls are
    // debounced so a burst of taps collapses into one /cart/change per line.
    this._qtyPending = {};
    this._qtyTimer = null;
    this._flushQtyPending = async () => {
      const pending = this._qtyPending;
      this._qtyPending = {};
      this._qtyTimer = null;
      const entries = Object.keys(pending).map(function (k) { return pending[k]; });
      if (!entries.length) return;
      let cart = null;
      try {
        // Un fetch par RAFALE (pas par clic) : filtre les keys périmées avant
        // d'appeler /cart/change — sans ça, Shopify répond "Pas d'identifiant
        // ou de paramètre de ligne valide" quand le serveur a fusionné/recréé
        // des lignes entre-temps (gift auto, doublons). Régression vue en prod
        // le 2026-06-10 (Alex/Safari).
        cart = await this.fetchCart();
        for (let i = 0; i < entries.length; i++) {
          const entry = entries[i];
          const liveKeys = entry.keys.filter(function (k) {
            return (cart.items || []).some(function (item) { return String(item.key) === String(k); });
          });
          if (!liveKeys.length) continue; // ligne disparue côté serveur → le updateCartUI final resynchronise
          let lineFailed = false;
          for (let ki = 0; ki < liveKeys.length; ki++) {
            const res = await fetch(this.getCartChangeUrl(), cartFetchOpts({
              method: 'POST',
              headers: CART_HEADERS,
              body: JSON.stringify({ id: liveKeys[ki], quantity: ki === 0 ? entry.qty : 0 })
            }));
            const data = await parseJsonResponse(res);
            if (!res.ok) { lineFailed = true; break; } // key morte entre fetch et change → resync silencieux, pas de message client
            cart = data; // /cart/change.js returns the full cart state
          }
          if (lineFailed) continue;
          if (entry.qty === 0 && entry.lineItem && entry.lineItem.isConnected) {
            entry.lineItem.classList.add('cd-item-exit');
            entry.lineItem.addEventListener('animationend', function () { entry.lineItem.remove(); }, { once: true });
          } else if (cart && entry.lineItem && entry.lineItem.isConnected) {
            const cartItem = (cart.items || []).find(function (item) { return item.key === liveKeys[0]; });
            if (cartItem) {
              const qtyEl = entry.lineItem.querySelector('.qty-value');
              if (qtyEl) qtyEl.textContent = cartItem.quantity; // reconcile (inventory caps, merged lines)
              this.updateLineItemPriceBlock(entry.lineItem, cartItem, cart.currency);
            }
          }
        }
        if (cart) {
          if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
          this.updateCartUI(cart); // resynchronise aussi les lignes sautées (continue) et l'optimistic qty
        }
      } catch (err) {
        // Réseau/serveur réellement en échec : resync silencieux d'abord,
        // message client uniquement si même le resync échoue.
        try {
          cart = await this.fetchCart();
          this.updateCartUI(cart);
        } catch (e2) {
          this.showCartError(err.message || this.strings.cart_error);
        }
      }
    };

    // Single click handler for quantity, remove, subscribe, and promo tag remove
    // NOTE: the checkout link (#CartDrawer-CheckoutForm) is a plain <a> tag –
    // do NOT intercept it here; let the browser follow it naturally.
    this.addEventListener('click', async (e) => {
      const mngLienPaiement = e.target.closest('a[id="CartDrawer-CheckoutForm"]');
      if (mngLienPaiement) {
        // instrumentation funnel : les smart events Clarity sous-détectent (CTA custom,
        // audit 2026-06-10) — event explicite, insensible aux libellés
        if (typeof window.clarity === 'function') window.clarity('event', 'begin_checkout');
        // 02/10/2026 (CADEAUX-ULTIME) : jamais de paiement avec un cadeau au-delà de son palier. Panier relu, cadeaux en
        // trop retirés, puis départ vers la même adresse (code promo ajouté par layout/theme.liquid compris).
        e.preventDefault();
        const mngVers = mngLienPaiement.href;
        this.mngPayerApresGarde(function () { window.location.href = mngVers; });
        return;
      }

      const promoRemoveBtn = e.target.closest('.promo-tag-remove');
      if (promoRemoveBtn) {
        e.preventDefault();
        const tag = promoRemoveBtn.closest('.promo-tag');
        if (!tag) return;
        const removedKey = (tag.dataset.promoCode || tag.dataset.promoTitle || '').trim();
        const container = this.querySelector('#CartDrawer-AppliedPromo');
        if (!container) return;
        promoRemoveBtn.disabled = true;
        try {
          var liveCart = await this.fetchCart();
          var applicableCodes = (liveCart.discount_codes || [])
            .filter(function (d) {
              return d && d.code && d.applicable !== false;
            })
            .map(function (d) { return String(d.code).trim(); })
            .filter(Boolean);
          var toDropCanon = resolveDiscountCodesToRemove(liveCart, removedKey);
          if (!toDropCanon.length && applicableCodes.length && removedKey) {
            var rl = removedKey.toLowerCase();
            var resolvedCodeToDrop = null;
            (liveCart.discount_codes || []).forEach(function (d) {
              if (!d || !d.code || d.applicable === false) return;
              var c = String(d.code).trim();
              if (c.toLowerCase() === rl) resolvedCodeToDrop = c;
            });
            if (!resolvedCodeToDrop) {
              var apps2 = liveCart.discount_applications || liveCart.cart_level_discount_applications || [];
              for (var ai = 0; ai < apps2.length; ai++) {
                var ap2 = apps2[ai];
                var t2 = ((ap2.title || '') + '').trim().toLowerCase();
                var c2b = ((ap2.code || '') + '').trim();
                if (c2b && c2b.toLowerCase() === rl) {
                  resolvedCodeToDrop = c2b;
                  break;
                }
                if (t2 === rl && c2b) {
                  resolvedCodeToDrop = c2b;
                  break;
                }
              }
            }
            if (resolvedCodeToDrop) toDropCanon = [resolvedCodeToDrop];
          }
          var dropSet = {};
          toDropCanon.forEach(function (c) { dropSet[String(c).toLowerCase()] = true; });
          var remainingCodes = applicableCodes.filter(function (c) { return !dropSet[c.toLowerCase()]; });
          if (removedKey && !toDropCanon.length && applicableCodes.length) {
            this.showCartError(this.strings.promo_remove_failed || 'Could not remove this discount. Refresh the page and try again.');
            return;
          }
          const res = await fetch(
            this.getCartUpdateUrl(),
            cartFetchOpts({
              method: 'POST',
              headers: CART_HEADERS,
              body: JSON.stringify({ discount: remainingCodes.join(',') })
            })
          );
          const data = await parseJsonResponse(res);
          if (!res.ok) throw new Error(data.description || this.strings.cart_error || 'Failed to remove code');
          const cart = data;
          if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
          this.updateCartUI(cart);
        } catch (err) {
          this.showCartError(err.message || this.strings.cart_error);
        } finally {
          promoRemoveBtn.disabled = false;
        }
        return;
      }
      
      const qtyBtn = e.target.closest('.qty-minus, .qty-plus');
      const removeBtn = e.target.closest('.item-remove');
      
      if (qtyBtn) {
        const lineItem = qtyBtn.closest('.cart-line-item');
        if (!lineItem) return;
        const keysStr = lineItem.getAttribute('data-line-keys') || lineItem.getAttribute('data-line-key') || qtyBtn.dataset.lineKey || '';
        const keys = keysStr.split(',').map(function (k) { return (k && k.trim) ? k.trim() : String(k).trim(); }).filter(function (k) { return k.length > 0; });
        if (!keys.length) return;
        const isMinus = qtyBtn.classList.contains('qty-minus');
        const qtyEl = lineItem.querySelector('.qty-value');
        if (!qtyEl) return;
        const currentQty = parseInt(qtyEl.textContent, 10);
        if (isNaN(currentQty)) return;
        const newQty = isMinus ? Math.max(0, currentQty - 1) : currentQty + 1;
        const activeBtn = isMinus ? lineItem.querySelector('.qty-minus') : lineItem.querySelector('.qty-plus');
        if (activeBtn) {
          activeBtn.classList.add('cd-tapped');
          activeBtn.addEventListener('animationend', function () { activeBtn.classList.remove('cd-tapped'); }, { once: true });
        }
        qtyEl.textContent = newQty;
        const subscribeCheckbox = lineItem.querySelector('.subscribe-checkbox');
        if (subscribeCheckbox) subscribeCheckbox.dataset.quantity = String(newQty);
        this._qtyPending[keys[0]] = { keys: keys, qty: newQty, lineItem: lineItem };
        if (this._qtyTimer) clearTimeout(this._qtyTimer);
        this._qtyTimer = setTimeout(() => { this._flushQtyPending(); }, 450);
      } else if (removeBtn) {
        const lineEl = removeBtn.closest('.cart-line-item');
        if (!lineEl) return;
        const keysStr = lineEl.getAttribute('data-line-keys') || lineEl.getAttribute('data-line-key') || removeBtn.dataset.lineKey || '';
        const keys = keysStr.split(',').map(function (k) { return (k && k.trim) ? k.trim() : String(k).trim(); }).filter(function (k) { return k.length > 0; });
        if (!keys.length) {
          this.showCartError(this.strings.cart_error || 'Impossible de supprimer cet article.');
          return;
        }
        removeBtn.disabled = true;
        removeBtn.classList.add('cd-btn-loading');
        lineEl.style.pointerEvents = 'none';
        try {
          var cart = await this.fetchCart();
          var keysToRemove = keys.filter(function (k) {
            return (cart.items || []).some(function (item) { return String(item.key) === String(k); });
          });
          if (keysToRemove.length === 0) {
            this.updateCartUI(cart);
            if (lineEl) {
              lineEl.classList.add('cd-item-exit');
              lineEl.addEventListener('animationend', function () { lineEl.remove(); }, { once: true });
            }
            return;
          }
          var lastCart = null;
          for (var ri = 0; ri < keysToRemove.length; ri++) {
            const res = await fetch(this.getCartChangeUrl(), cartFetchOpts({
              method: 'POST',
              headers: CART_HEADERS,
              body: JSON.stringify({ id: keysToRemove[ri], quantity: 0 })
            }));
            const data = await parseJsonResponse(res);
            if (!res.ok) throw new Error(data.description || data.message || this.strings.cart_error || 'Cart error');
            lastCart = data;
          }
          if (lastCart && lastCart.currency) this.currency = this.normalizeCurrency(lastCart.currency);
          if (lineEl) {
            lineEl.classList.add('cd-item-exit');
            lineEl.addEventListener('animationend', function () { lineEl.remove(); }, { once: true });
          }
          this.updateCartUI(lastCart);
        } catch (err) {
          this.showCartError(err.message || this.strings.cart_error);
          if (lineEl) lineEl.style.pointerEvents = '';
        } finally {
          removeBtn.disabled = false;
          removeBtn.classList.remove('cd-btn-loading');
        }
      }
    });

    // Single change handler for subscribe checkboxes
    this.addEventListener('change', async (e) => {
      const checkbox = e.target.closest('.subscribe-checkbox');
      if (!checkbox) return;
      
      const lineItem = checkbox.closest('.cart-line-item');
      const lineNumber = lineItem ? parseInt(lineItem.dataset.lineNumber, 10) : 0;

      const key = checkbox.dataset.lineKey;
      const sellingPlanId = checkbox.dataset.sellingPlanId;
      const quantity = parseInt(checkbox.dataset.quantity, 10) || 1;
      const isChecked = checkbox.checked;
      
      const keysStr = lineItem && (lineItem.getAttribute('data-line-keys') || lineItem.getAttribute('data-line-key') || '');
      const lineKey = (checkbox.dataset.lineKey || (keysStr && keysStr.split(',').map(function (k) { return k.trim(); }).filter(Boolean)[0]) || '').trim();
      if (!lineKey && (!lineNumber || isNaN(lineNumber))) {
        checkbox.checked = !isChecked;
        return;
      }
      
      checkbox.disabled = true;
      if (lineItem) lineItem.classList.add('cart-loading');
      if (lineItem) lineItem.style.transition = 'opacity 0.15s ease';
      
      try {
        const body = lineKey
          ? { id: lineKey, quantity: quantity, selling_plan: isChecked ? parseInt(sellingPlanId, 10) : null }
          : { line: lineNumber, quantity: quantity, selling_plan: isChecked ? parseInt(sellingPlanId, 10) : null };
        
        const res = await fetch(this.getCartChangeUrl(), cartFetchOpts({
            method: 'POST',
          headers: CART_HEADERS,
          body: JSON.stringify(body)
        }));
        
        const data = await parseJsonResponse(res);
        
        if (!res.ok) throw new Error(data.description || this.strings.cart_error || 'Failed to update subscription');
        
        let cart = data;
        try {
          cart = await this.fetchCart();
        } catch (fetchErr) {
        }
        if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
        await this.refreshLineItemsOnly(cart);
          this.updateCartUI(cart);
      } catch (err) {
        checkbox.checked = !isChecked;
        this.showCartError(err.message || this.strings.cart_error);
      } finally {
        checkbox.disabled = false;
        if (lineItem) lineItem.classList.remove('cart-loading');
      }
    });

    // Single submit handler for suggestion forms
    this.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[data-cart-drawer-suggestion-form]');
      if (!form) return;
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Prevent double add: native form submit or duplicate event can cause add twice
      if (form.dataset.cartDrawerSubmitting === '1') {
        return;
      }
      form.dataset.cartDrawerSubmitting = '1';
      
      const idInput = form.querySelector('input[name="id"]');
      const submitBtn = form.querySelector('button[type="submit"]');
      if (!idInput || !idInput.value) {
        delete form.dataset.cartDrawerSubmitting;
        return;
      }
      const variantId = parseInt(idInput.value, 10);
      if (isNaN(variantId)) {
        delete form.dataset.cartDrawerSubmitting;
        return;
      }
      const origText = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.classList.add('cd-btn-loading');
        submitBtn.innerHTML = '<span style="visibility:hidden">' + submitBtn.innerHTML + '</span>';
      }
      try {
        // Match existing line (same variant): use its selling_plan and properties so the add merges into one line
        var addPayload = { id: variantId, quantity: 1 };
        var planInput = form.querySelector('input[name="selling_plan"]');
        if (planInput && planInput.value) addPayload.selling_plan = planInput.value;
        var existingLine = null;
        try {
          var existingCart = await this.fetchCart();
          existingLine = (existingCart.items || []).find(function (item) { return String(item.variant_id) === String(variantId); });
          if (existingLine) {
            delete addPayload.selling_plan;
            if (existingLine.selling_plan_allocation && existingLine.selling_plan_allocation.selling_plan && existingLine.selling_plan_allocation.selling_plan.id) {
              addPayload.selling_plan = existingLine.selling_plan_allocation.selling_plan.id;
            }
            if (existingLine.properties && typeof existingLine.properties === 'object' && Object.keys(existingLine.properties).length > 0) {
              addPayload.properties = existingLine.properties;
            }
          }
        } catch (_) {}
        log('suggestion add: merge payload', { variantId, foundExisting: !!existingLine, addPayload, existingLineProps: existingLine && existingLine.properties, existingSellingPlan: existingLine && existingLine.selling_plan_allocation && existingLine.selling_plan_allocation.selling_plan && existingLine.selling_plan_allocation.selling_plan.id });
        const res = await fetch(this.getCartAddUrl(), cartFetchOpts({
          method: 'POST',
          headers: CART_HEADERS,
          body: JSON.stringify({ items: [addPayload] })
        }));
        
        // Try to parse add response, but if interceptor consumed it, skip and just fetch cart
        let addFailed = false;
        if (!res.bodyUsed) {
          try {
            const data = await parseJsonResponse(res);
            if (!res.ok) throw new Error(data.description || this.strings.cart_error || 'Cart error');
          } catch (e) {
            // Add response parse failed (possibly interceptor issue), continue to cart fetch
            addFailed = true;
          }
        } else {
        }
        
        // Always fetch full cart after add (we need it for updateCartUI)
        const cartJsUrl = this.getCartUrl() + (this.getCartUrl().endsWith('.js') ? '' : '.js');
        const cartRes = await fetch(cartJsUrl, cartFetchOpts({ headers: CART_ACCEPT }));
        const cart = await parseJsonResponse(cartRes);
        if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
        this.updateCartUI(cart);
        this.open();
        } catch (err) {
        this.showCartError(err.message || this.strings.cart_error);
      } finally {
        delete form.dataset.cartDrawerSubmitting;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('cd-btn-loading');
          submitBtn.innerHTML = origText;
        }
      }
    });
  }

  setupInsuranceToggle() {
    const insuranceContainer = this.querySelector('[data-insurance-variant-id]');
    if (!insuranceContainer) {
      return;
    }
    
    const toggle = insuranceContainer.querySelector('.insurance-toggle');
    if (!toggle) {
      return;
    }
    
    
    toggle.addEventListener('click', async (e) => {
      const variantId = insuranceContainer.dataset.insuranceVariantId;
      const isInCart = insuranceContainer.dataset.insuranceInCart === 'true';
      const lineKey = insuranceContainer.dataset.insuranceLineKey;
      toggle.disabled = true;
      toggle.classList.add('cd-btn-loading');
      try {
        if (isInCart) {
          // Remove insurance from cart
          const res = await fetch(this.getCartChangeUrl(), cartFetchOpts({
            method: 'POST',
            headers: CART_HEADERS,
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          }));
          const data = await parseJsonResponse(res);
          if (!res.ok) throw new Error(data.description || this.strings.cart_error || 'Failed to remove insurance');
          const cart = data;
          if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
          
          // Update toggle state
          insuranceContainer.dataset.insuranceInCart = 'false';
          insuranceContainer.dataset.insuranceLineKey = '';
          toggle.setAttribute('aria-checked', 'false');
          
          // Update toggle visual
          const stroke = toggle.querySelector('.toggle-stroke');
          const circle = toggle.querySelector('.toggle-circle');
          if (stroke) stroke.setAttribute('stroke', '#C4A6FF');
          if (circle) {
            circle.setAttribute('cx', '14');
            circle.setAttribute('fill', '#C4A6FF');
          }
          
          this.updateCartUI(cart);
        } else {
          // Add insurance to cart
          const res = await fetch(this.getCartAddUrl(), cartFetchOpts({
            method: 'POST',
            headers: CART_HEADERS,
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId),
                quantity: 1,
                properties: { _cart_upsell: 'insurance' }
              }]
            })
          }));
          
          
          // Try to parse add response, but if interceptor consumed it, skip and just fetch cart
          if (!res.bodyUsed) {
            try {
              const addData = await parseJsonResponse(res);
              if (!res.ok) throw new Error(addData.description || this.strings.cart_error || 'Failed to add insurance');
            } catch (e) {
            }
          } else {
          }
          
          const cartJsUrl = this.getCartUrl() + (this.getCartUrl().endsWith('.js') ? '' : '.js');
          const cartRes = await fetch(cartJsUrl, cartFetchOpts({ headers: CART_ACCEPT }));
          const cart = await parseJsonResponse(cartRes);
          if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
          
          // Find the insurance line key
          const insuranceItem = cart.items.find(item => 
            item.properties && item.properties._cart_upsell === 'insurance'
          );
          
          if (insuranceItem) {
            // Update toggle state
            insuranceContainer.dataset.insuranceInCart = 'true';
            insuranceContainer.dataset.insuranceLineKey = insuranceItem.key;
            toggle.setAttribute('aria-checked', 'true');
            
            // Update toggle visual
            const stroke = toggle.querySelector('.toggle-stroke');
            const circle = toggle.querySelector('.toggle-circle');
            if (stroke) stroke.setAttribute('stroke', 'white');
            if (circle) {
              circle.setAttribute('cx', '36');
              circle.setAttribute('fill', 'white');
            }
          }
          
          this.updateCartUI(cart);
        }
      } catch (err) {
        this.showCartError(err.message || this.strings.cart_error);
      } finally {
        toggle.disabled = false;
        toggle.classList.remove('cd-btn-loading');
      }
    });
  }

  showCartError(message) {
    const el = this.querySelector('#CartDrawer-Error');
    if (!el) return;
    el.textContent = message || this.strings.cart_error || '';
    el.classList.remove('hidden');
    el.setAttribute('role', 'alert');
    clearTimeout(this._cartErrorTimeout);
    this._cartErrorTimeout = setTimeout(() => {
      el.classList.add('hidden');
      el.textContent = '';
    }, 5000);
  }

  setupPromoCode() {
    const input = this.querySelector('[data-promo-input]');
    const button = this.querySelector('[data-promo-apply]');
    const message = this.querySelector('[data-promo-message]');
    
    if (!input || !button || !message) {
      return;
    }

    let errorCooldown = false;
    input.addEventListener('input', () => input.classList.remove('cd-promo-input-error'));

    const applyCode = async () => {
      if (button.disabled) return; // Enter pendant le cooldown anti-rafale
      const code = input.value.trim();

      if (!code) {
        this.showPromoMessage(this.strings.promo_empty || 'Veuillez entrer un code promo', 'error', message);
        return;
      }
      
      try {
        button.disabled = true;
        button.classList.add('cd-btn-loading');
        
        const res = await fetch(
          this.getCartUpdateUrl(),
          cartFetchOpts({
            method: 'POST',
            headers: CART_HEADERS,
            body: JSON.stringify({ discount: code })
          })
        );
        const data = await parseJsonResponse(res);
        if (!res.ok) throw new Error(data.description || this.strings.promo_invalid || 'Invalid code');
        
        const cart = data;
        if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
        
        // Vérifier si le code est réellement applicable (Shopify renvoie 200 même pour un code invalide)
        const appliedCode = (cart.discount_codes || []).find(function (d) {
          return d.code && d.code.toLowerCase() === code.toLowerCase();
        });
        if (!appliedCode) {
          throw new Error(this.strings.promo_invalid || 'Code promo invalide ou inexistant');
        }
        if (appliedCode.applicable === false) {
          throw new Error(this.strings.promo_not_applicable || 'Ce code promo ne s\'applique pas à votre panier');
        }
        
        this.showPromoMessage(this.strings.promo_success || 'Code appliqué !', 'success', message);
        
        // Show applied code immediately so it's visible right away (API often omits discount_applications)
        const appliedPromoEl = this.querySelector('#CartDrawer-AppliedPromo');
        const hasDiscount = (cart.total_discount || 0) > 0;
        if (appliedPromoEl && hasDiscount && code) {
          appliedPromoEl.classList.remove('hidden');
          const safe = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
          const removeLabel = (this.strings.remove_promo || 'Remove code').replace(/"/g, '&quot;');
          appliedPromoEl.innerHTML = '<span class="promo-tag inline-flex items-center gap-1.5 rounded-full bg-[#21014f]/80 border border-white/50 px-3 py-1.5 text-[11px] font-[\'Source_Sans_Pro\'] font-semibold not-italic text-white" data-promo-title="' + safe + '" data-promo-code="' + safe + '"><span class="promo-tag-label">' + safe + '</span><button type="button" class="promo-tag-remove w-[14px] h-[14px] rounded-full flex items-center justify-center text-white hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/50 shrink-0" aria-label="' + removeLabel + '"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M1 1L7 7M7 1L1 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button></span>';
        }
        
        // Update cart UI (totals, progress, etc.)
        this.updateCartUI(cart);
        if (!cartHasApplicableDiscountCodes(cart)) {
          this.persistDrawerDiscountCodes(code);
        }
        
        // Clear input after 2 seconds
        setTimeout(() => {
          input.value = '';
          message.classList.add('hidden');
        }, 2000);
      } catch (err) {
        this.showPromoMessage(err.message || this.strings.promo_invalid || '', 'error', message);
        // friction n°1 mesurée (audit 2026-06-10) : échec invisible → martèlement.
        // Secousse + liseré + cooldown 1,8 s, et tag Clarity pour traiter la cause
        // (codes popup expirés ?) dans le dashboard.
        input.classList.add('cd-promo-input-error');
        const row = this.querySelector('#CartDrawer-PromoRow');
        if (row) {
          row.classList.remove('cd-promo-shake');
          void row.offsetWidth;
          row.classList.add('cd-promo-shake');
          row.addEventListener('animationend', () => row.classList.remove('cd-promo-shake'), { once: true });
        }
        if (typeof window.clarity === 'function') {
          window.clarity('set', 'promo_rejected', code);
          window.clarity('event', 'promo_code_rejected');
        }
        errorCooldown = true;
        button.style.opacity = '0.6';
        setTimeout(() => {
          errorCooldown = false;
          button.disabled = false;
          button.style.opacity = '';
        }, 1800);
      } finally {
        button.classList.remove('cd-btn-loading');
        if (!errorCooldown) button.disabled = false;
      }
    };
    
    button.addEventListener('click', applyCode);
    input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        applyCode();
      }
    });
  }

  showPromoMessage(text, type, element) {
    element.textContent = text;
    // erreur en 14px blanc gras (l'ancien rouge 11px passait inaperçu : ~7 800 clics
    // « Appliquer »/7j dont des boucles d'échec — audit 2026-06-10). Styles inline :
    // toute classe utilitaire nouvelle serait inopérante (build CSS figé).
    element.className = `font-['Source_Sans_Pro'] leading-[18px] ${type === 'error' ? '' : 'text-[#f9f785]'}`;
    element.style.cssText = type === 'error' ? 'font-size:14px;font-weight:700;color:#ffffff;' : 'font-size:11px;';
    element.classList.remove('hidden');
  }

  updateEmptySuggestionsDesktopVisibility() {
    const emptyWrapper = this.querySelector('#CartDrawer-EmptyWrapper');
    const emptySuggestions = this.querySelector('#CartDrawer-EmptySuggestions');
    if (!emptySuggestions) return;
    const isEmptyVisible = emptyWrapper ? !emptyWrapper.classList.contains('hidden') : false;
    if (isEmptyVisible && window.innerWidth >= 1024) {
      emptySuggestions.style.setProperty('display', 'none');
    } else {
      emptySuggestions.style.removeProperty('display');
    }
  }

  async updateCartUI(cart, opts) {
    var skipGiftSync    = (opts && opts.skipGiftSync)    || false;
    var skipLineRefresh = (opts && opts.skipLineRefresh) || false;
    
    // Clear error
    const errEl = this.querySelector('#CartDrawer-Error');
    if (errEl) { errEl.classList.add('hidden'); errEl.textContent = ''; }
    
    // Update currency
    if (cart.currency) this.currency = this.normalizeCurrency(cart.currency);
    this._lastCart = cart;
    
    // Ensure progress/gift thresholds can be converted to cart currency (dynamic rate if not from Shopify)
    await this.ensureExchangeRate(cart.currency);
    
    // Check if we need to refresh line items (count only direct children = one per line item)
    // Exclude insurance items from count since they're hidden in the UI
    const lineCount = this.querySelectorAll('#CartDrawer-CartItems > .cart-line-item').length;
    const insuranceVariantId = this.querySelector('[data-insurance-variant-id]')?.dataset?.insuranceVariantId;
    const cartItemCount = cart.items ? cart.items.filter(item => {
      return !insuranceVariantId || String(item.variant_id) !== String(insuranceVariantId);
    }).length : 0;
    
    // Clé de ligne périmée (Shopify recrée la ligne, nouvelle clé, quand un code promo s'applique) : re-rendu, sinon « − » et « Supprimer » visent une clé morte (27/09/2026).
    const mngKeys = new Set((cart.items || []).map(function (i) { return String(i.key); }));
    const mngStale = Array.prototype.some.call(this.querySelectorAll('#CartDrawer-CartItems > .cart-line-item'), function (r) {
      return (r.getAttribute('data-line-keys') || r.getAttribute('data-line-key') || '').split(',').some(function (k) { k = k.trim(); return k && !mngKeys.has(k); });
    });
    if (!skipLineRefresh && (lineCount !== cartItemCount || mngStale)) {
      await this.refreshLineItemsOnly(cart);
    }

    // Group display by variant + selling_plan + properties (one row per logical line, no API merge)
    this.collapseDuplicateDisplayRows();

    // Sync every line item's price and subscription state from cart (keeps checkbox and discount in sync)
    const container = this.querySelector('#CartDrawer-CartItems');
    if (container && cart.items && cart.items.length) {
      container.querySelectorAll('.cart-line-item').forEach(function (lineItem) {
        const keysStr = lineItem.getAttribute('data-line-keys') || lineItem.getAttribute('data-line-key');
        if (!keysStr) return;
        const keys = keysStr.split(',').map(function (k) { return k.trim(); }).filter(Boolean);
        const cartItems = keys.map(function (k) { return cart.items.find(function (item) { return item.key === k; }); }).filter(Boolean);
        if (!cartItems.length) return;
        const cartItem = cartItems.length === 1 ? cartItems[0] : {
          final_line_price: cartItems.reduce(function (sum, i) { return sum + (i.final_line_price || 0); }, 0),
          original_line_price: cartItems.reduce(function (sum, i) { return sum + (i.original_line_price || 0); }, 0),
          quantity: cartItems.reduce(function (sum, i) { return sum + (i.quantity || 0); }, 0),
          key: cartItems[0].key,
          variant_id: cartItems[0].variant_id,
          product_title: cartItems[0].product_title,
          title: cartItems[0].title,
          selling_plan_allocation: cartItems[0].selling_plan_allocation,
          line_level_discount_allocations: [].concat.apply([], cartItems.map(function (i) { return i.line_level_discount_allocations || []; }))
        };
        if (typeof this.updateLineItemPriceBlock === 'function') this.updateLineItemPriceBlock(lineItem, cartItem, cart.currency);
      }.bind(this));
    }

    // Single pass: update all UI elements
    const isEmpty = !cart.item_count || cart.item_count === 0;

    // Toggle visibility
    const emptyWrapper = this.querySelector('#CartDrawer-EmptyWrapper');
    const emptyState = this.querySelector('#CartDrawer-EmptyState');
    const hasItems = this.querySelector('#CartDrawer-HasItems');
    const footer = this.querySelector('#CartDrawer-Footer');
    if (emptyWrapper) emptyWrapper.classList.toggle('hidden', !isEmpty);
    else if (emptyState) emptyState.classList.toggle('hidden', !isEmpty);
    if (hasItems) hasItems.classList.toggle('hidden', isEmpty);
    if (footer) footer.classList.toggle('hidden', isEmpty);
    const mobileSlider = this.querySelector('#CartDrawer-MobileSuggestions');
    if (mobileSlider) mobileSlider.classList.toggle('hidden', isEmpty);
    const progressBlock = this.querySelector('#CartDrawer-ProgressBlock');
    if (progressBlock) progressBlock.classList.toggle('hidden', isEmpty);

    this.updateEmptySuggestionsDesktopVisibility();

    // Gift + merch totals: single source (milestones, gift sync, subtotal / discount excluding auto-gift).
    var giftTotals = this.computeGiftProgressTotals(cart);
    // Must run BEFORE syncGiftProducts: that block re-applies DRAWER_DISCOUNT_SESSION_KEY after add/remove gift;
    // if session still held a code the customer just removed, it would come back.
    this.syncDrawerDiscountSessionFromCart(cart);

    // Display total = cart.total_price minus any checkout-only gift savings
    const displayTotal = giftTotals.displayTotal;
    const displayTotalFormatted = this.formatMoney(displayTotal, cart.currency);

    // Subtotal = catalogue-priced merch lines only; reduction = giftTotals.reductionDisplayCents (see computeGiftProgressTotals).
    const subtotalBeforeDiscount = giftTotals.nonGiftOriginalSum;
    const subtotalEl = this.querySelector('#CartDrawer-Subtotal');
    if (subtotalEl) subtotalEl.textContent = this.formatMoney(subtotalBeforeDiscount, cart.currency);
    const totalEl = this.querySelector('#CartDrawer-Total');
    if (totalEl) totalEl.textContent = displayTotalFormatted;

    // Update checkout button – use display total so label matches what checkout charges
    const checkoutBtn = this.querySelector('#CartDrawer-CheckoutButtonText');
    if (checkoutBtn) {
      const template = (this.strings.checkout_button || 'Procéder au paiement - [amount]');
      checkoutBtn.textContent = template.replace(/\[amount\]|\{\{\s*amount\s*\}\}/g, displayTotalFormatted);
    }

    const applications = cart.discount_applications || cart.cart_level_discount_applications || [];
    const hasApplications = applications && applications.length > 0;
    const hasApplicableCodes = cartHasApplicableDiscountCodes(cart);
    const totalReduction = giftTotals.reductionDisplayCents;
    const showReductionRow =
      totalReduction > 0 ||
      (cart.total_discount || 0) > 0 ||
      hasApplications ||
      hasApplicableCodes;
    const reductionEl = this.querySelector('#CartDrawer-Reduction');
    const reductionAmountEl = this.querySelector('#CartDrawer-ReductionAmount');
    if (reductionEl && reductionAmountEl) {
      reductionEl.classList.toggle('hidden', !showReductionRow);
      // Prefer reductionDisplay (matches merch subtotal); fall back to cart.total_discount if bridge is zero (rare).
      var reductionAmountCents = totalReduction > 0 ? totalReduction : (cart.total_discount || 0);
      reductionAmountEl.textContent = reductionAmountCents > 0 ? '\u2212' + this.formatMoney(reductionAmountCents, cart.currency) : '';
    }

    const appliedPromoEl = this.querySelector('#CartDrawer-AppliedPromo');
    if (appliedPromoEl) {
      const removeLabel = this.strings.remove_promo || 'Remove code';
      const showPromoTags = hasApplications || hasApplicableCodes;
      var tagHtml = '';
      if (showPromoTags) {
        // Panier v4 : « EXEMPLE10 · −10 % » (maquette) — pourcentage lu dans l'application de réduction.
        const mng4PctTpl = mng4Txt((this.strings || {}).sub_pct || '');
        const mng4Loc = this.locale || 'fr';
        if (hasApplications) {
          tagHtml = applications.filter(function (a) {
            a = (a && a.discount_application) || a; // réponse de /cart/update.js : application imbriquée
            var t = ((a.title || a.code || '') + '').toLowerCase();
            return t.indexOf('abo-free-ship') === -1;
          }).map(function (a) {
            a = (a && a.discount_application) || a;
            const label = (a.title || a.code || '').toString().trim();
            const safe = label.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
            if (!safe) return '';
            var rawCode = ((a.code || '') + '').trim();
            var codeAttr = rawCode ? ' data-promo-code="' + rawCode.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;') + '"' : '';
            return '<span class="promo-tag inline-flex items-center gap-1.5 rounded-full bg-[#21014f]/80 border border-white/50 px-3 py-1.5 text-[11px] font-[&#39;Source_Sans_Pro&#39;] font-semibold not-italic text-white" data-promo-title="' + safe + '"' + codeAttr + '><span class="promo-tag-label">' + safe + ((a.value_type === 'percentage' && Number(a.value) > 0 && mng4PctTpl) ? ' · ' + mng4Esc(mng4PctTpl.replace(/\{\{\s*pct\s*\}\}/g, Number(a.value).toLocaleString(mng4Loc))) : '') + '</span><button type="button" class="promo-tag-remove w-[14px] h-[14px] rounded-full flex items-center justify-center text-white hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/50 shrink-0" aria-label="' + removeLabel.replace(/"/g, '&quot;') + '"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M1 1L7 7M7 1L1 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button></span>';
          }).filter(Boolean).join('');
        }
        if (!tagHtml && hasApplicableCodes && Array.isArray(cart.discount_codes)) {
          tagHtml = cart.discount_codes
            .filter(function (d) {
              return d && d.code && String(d.code).trim() && d.applicable !== false && String(d.code).toLowerCase().indexOf('abo-free-ship') === -1;
            })
            .map(function (d) {
              var code = String(d.code).trim();
              // Panier v4 : pourcentage lu dans l'application correspondante, sous ses deux formes.
              var mng4App = (cart.cart_level_discount_applications || []).map(function (x) { return (x && x.discount_application) || x; })
                .find(function (x) { return String((x && x.title) || '').toLowerCase() === code.toLowerCase(); });
              var mng4Sfx = (mng4App && mng4App.value_type === 'percentage' && Number(mng4App.value) > 0 && mng4PctTpl)
                ? ' · ' + mng4Esc(mng4PctTpl.replace(/\{\{\s*pct\s*\}\}/g, Number(mng4App.value).toLocaleString(mng4Loc))) : '';
              var safe = code.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
              return '<span class="promo-tag inline-flex items-center gap-1.5 rounded-full bg-[#21014f]/80 border border-white/50 px-3 py-1.5 text-[11px] font-[&#39;Source_Sans_Pro&#39;] font-semibold not-italic text-white" data-promo-title="' + safe + '" data-promo-code="' + safe + '"><span class="promo-tag-label">' + safe + mng4Sfx + '</span><button type="button" class="promo-tag-remove w-[14px] h-[14px] rounded-full flex items-center justify-center text-white hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/50 shrink-0" aria-label="' + removeLabel.replace(/"/g, '&quot;') + '"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M1 1L7 7M7 1L1 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button></span>';
            })
            .join('');
        }
      }
      appliedPromoEl.innerHTML = tagHtml;
      appliedPromoEl.classList.toggle('hidden', !tagHtml);
    }
    // Panier v4 : bloc promo de la maquette — replié une fois le code accepté, ligne « Code X » dans
    // les totaux, note « Réduction de … appliquée au total ».
    {
      const mng4Promo = this.querySelector('#CartDrawer-Promo');
      const mng4Applied = this.querySelector('#CartDrawer-AppliedPromo');
      const mng4HasCode = !!(mng4Applied && !mng4Applied.classList.contains('hidden') && mng4Applied.innerHTML.trim());
      if (mng4Promo) {
        const had = mng4Promo.classList.contains('has-code');
        mng4Promo.classList.toggle('has-code', mng4HasCode);
        if (mng4HasCode && !had) this.mng4PromoOpen(false);
      }
      const mng4Codes = (cart.discount_codes || []).filter(function (d) {
        return d && d.code && d.applicable !== false && String(d.code).toLowerCase().indexOf('abo-free-ship') === -1;
      }).map(function (d) { return String(d.code).trim(); });
      const mng4RedLabel = this.querySelector('#CartDrawer-ReductionLabel');
      if (mng4RedLabel) {
        const tpl = mng4Txt(this.strings.promo_code_row || '');
        const want = (mng4Codes.length && tpl) ? tpl.replace(/\{\{\s*code\s*\}\}/g, mng4Codes.join(', ')) : mng4Txt(this.strings.reduction || '');
        if (want && mng4RedLabel.textContent !== want) mng4RedLabel.textContent = want;
      }
      const mng4Note = this.querySelector('#CartDrawer-PromoNote');
      if (mng4Note) {
        const amt = totalReduction > 0 ? totalReduction : (cart.total_discount || 0);
        const tplN = mng4Txt(this.strings.promo_note || '');
        const txt = (mng4HasCode && amt > 0 && tplN) ? tplN.replace(/\{\{\s*amount\s*\}\}/g, this.formatMoney(amt, cart.currency)) : '';
        if (mng4Note.textContent !== txt) mng4Note.textContent = txt;
        mng4Note.hidden = !txt;
      }
    }
    
    // Progress bar uses eligibleTotal from computeGiftProgressTotals (min of merch line finals vs display total).
    this.updateProgress(giftTotals.eligibleTotal, cart.currency);
    // 29/09/2026 (BUG-07) : articles payants seulement, pour la bulle du header comme pour la pastille du tiroir.
    const mngNb = this.mngNbPayant(cart);
    this.updateHeaderCartCount(mngNb);
    // Panier v4 : pastille à côté du titre, même compte que l'icône du header.
    const mng4Count = this.querySelector('#CartDrawer-Count');
    if (mng4Count) {
      const mng4N = mngNb;
      mng4Count.textContent = mng4N < 100 ? String(mng4N) : '99+';
      mng4Count.hidden = mng4N === 0;
    }
    this.mng4SyncTotals(cart);
    this.mngLogosPaiement(cart);
    
    // Do not refresh suggestions on every cart update – it refetches section HTML and recos every time,
    // causing constant reload/lag. Suggestions are loaded once on init and after full drawer refresh.
    
    // Unify currency: format all Liquid-rendered prices (suggestions, insurance) with cart currency
    this.formatAllDrawerMoney(cart.currency);
    
    // Auto-add / auto-remove gift products for free_gift milestones (skip on recursive call)
    if (!skipGiftSync) {
      try {
        var giftSync = await this.syncGiftProducts(cart);
        if (giftSync.changed) {
          await this.refreshLineItemsOnly(giftSync.cart);
          // Recurse once with updated cart; both flags prevent looping and double-refresh
          await this.updateCartUI(giftSync.cart, { skipGiftSync: true, skipLineRefresh: true });
          return;
        }
      } catch (giftErr) {
        // gift sync failure is non-fatal – continue with original cart
      }
    }
    
    // Ensure any gift items in cart are visible (patch if section HTML didn't include them)
    if (cart && cart.items && cart.items.length) this.appendMissingGiftLineItems(cart);

    this.syncDrawerDiscountSessionFromCart(cart);
    this.syncSuggestionsWithCart(cart);
  }

  // jamais proposer en upsell un produit déjà au panier (Jul 2026-06-11).
  // Le rendu serveur filtre en Liquid ; ici on synchronise sans re-fetch quand le
  // panier change côté client (ajout depuis une suggestion, suppression de ligne...)
  syncSuggestionsWithCart(cart) {
    try { if (mngFl5Actif() || mngP06Actif()) this.mng4UpdateUnlocks(); } catch (e) { console.error('[flash] suggestions', e); }
    const inCart = new Set(((cart && cart.items) || []).map((i) => String(i.product_id)));
  const mngpPack = cartHasNoGiftProduct(cart);
  const mngpOff = (el) => (el.dataset.mngPackOnly === '1' && !mngpPack) || (el.dataset.mngPackHide === '1' && mngpPack);
    // cartes hors carrousel (sidebar desktop + vue panier vide) : simple toggle
    let mngN = 0; // 6 places, un produit au panier cède la sienne (Alex 26/09)
    this.querySelectorAll('[data-suggestion-product-id]').forEach((el) => {
      if (el.closest('.splide__slide')) return; // le carrousel Splide est géré ci-dessous
   el.style.display = (inCart.has(el.dataset.suggestionProductId) || (el.matches('.mng4-scard:not([data-mng-pack-only])') && ++mngN > 6) || mngpOff(el)) ? 'none' : '';
    });
    // carrousel mobile : Splide casse sur des slides en display:none — on retire/réinsère
    // les <li> depuis un pool mémorisé, puis on remonte l'instance (destroy+mount géré
    // par setupMobileSlider). Les cartes recos auto (sans data-attribute) ne sont pas touchées.
    const track = this.querySelector('#CartDrawer-MobileSplide .splide__list');
    if (!track) return;
    if (!this._suggestionSlidePool || this._suggestionSlidePoolTrack !== track) {
      // (re)capture du pool après chaque re-render serveur (le track est alors recréé)
      this._suggestionSlidePool = Array.from(track.children).filter((li) => li.querySelector('[data-suggestion-product-id]'));
      this._suggestionSlidePoolTrack = track;
    }
    const pid = (li) => li.querySelector('[data-suggestion-product-id]').dataset.suggestionProductId;
  let mngM = 0;
  const want = this._suggestionSlidePool.filter((li) => !inCart.has(pid(li)) && (li.querySelector('[data-mng-pack-only]') || ++mngM <= 6) && !mngpOff(li.querySelector('[data-suggestion-product-id]')));
    // Panier v4 : la suggestion qui débloque la marche suivante passe en tête (maquette).
    const mng4First = this._mng4FirstPid ? want.findIndex((li) => pid(li) === String(this._mng4FirstPid)) : -1;
  if (mng4First > 0) {
   const mngpHead = mngpPack ? want.filter((li) => li.querySelector('[data-mng-pack-only="1"]')).length : 0;
   const mngpLi = want.splice(mng4First, 1)[0];
   want.splice(mngpLi.querySelector('[data-mng-pack-only="1"]') ? 0 : Math.min(mngpHead, want.length), 0, mngpLi);
  }
    const current = Array.from(track.children).filter((li) => li.querySelector('[data-suggestion-product-id]'));
    const sig = (arr) => arr.map(pid).join(',');
    if (sig(want) !== sig(current)) {
      current.forEach((li) => li.remove());
      want.forEach((li) => track.appendChild(li));
      this.setupMobileSlider();
    }
    const mobileWrapper = this.querySelector('#CartDrawer-MobileSuggestions');
    if (mobileWrapper) {
      const cartEmpty = !(cart && cart.items && cart.items.length);
      mobileWrapper.classList.toggle('hidden', want.length === 0 || cartEmpty);
    }
  }

  // Ce soir : cartes triées (Brainstoorm, cures, accessoires), pastilles recalculées sur cet ordre, puis la suggestion qui
  // franchit la prochaine marche en tête, sur ordinateur comme sur mobile (le mobile la remonte déjà plus bas). Noms en français.
  mngFl5Trier() {
    var tri = function (arr, carte) {
      return arr.map(function (x, i) { return { x: x, i: i, r: mngFl5Rang(carte(x)) }; }).sort(function (a, b) { return (a.r - b.r) || (a.i - b.i); }).map(function (o) { return o.x; });
    };
    if (!document.getElementById('mng-fl5-sg-css')) { var st = document.createElement('style'); st.id = 'mng-fl5-sg-css';
      st.textContent = '#CartDrawer .mng4-scard .mng4-unlock{white-space:normal!important;text-overflow:clip!important;line-height:14px!important;top:-12px!important}#CartDrawer .mng4-scard.is-tagged{margin-top:8px;padding-top:26px!important}';
      document.head.appendChild(st); }
    var noms = MNG_FL5_SG().noms;
    this.querySelectorAll('.mng4-st, .mng4-rt').forEach(function (n) {
      noms.forEach(function (p) { var w = document.createTreeWalker(n, NodeFilter.SHOW_TEXT); while (w.nextNode()) { if (p[0].test(w.currentNode.nodeValue)) w.currentNode.nodeValue = w.currentNode.nodeValue.replace(p[0], p[1]); } });
    });
    var sc = Array.prototype.slice.call(this.querySelectorAll('.mng4-scard:not([data-mng-pack-only])'));
    var parent = sc.length ? sc[0].parentNode : null;
    if (parent && sc.every(function (el) { return el.parentNode === parent; })) {
      var tr = tri(sc, function (el) { return el; });
      if (tr.some(function (el, i) { return el !== sc[i]; })) { var ref = sc[sc.length - 1].nextSibling; tr.forEach(function (el) { parent.insertBefore(el, ref); }); }
    }
    var track = this.querySelector('#CartDrawer-MobileSplide .splide__list');
    if (track && (!this._suggestionSlidePool || this._suggestionSlidePoolTrack !== track)) {
      this._suggestionSlidePool = Array.from(track.children).filter(function (li) { return li.querySelector('[data-suggestion-product-id]'); });
      this._suggestionSlidePoolTrack = track;
    }
    if (this._suggestionSlidePool) this._suggestionSlidePool = tri(this._suggestionSlidePool, function (li) { return li.querySelector('[data-suggestion-product-id]'); });
  }
  mngFl5Tete() {
    var cible = this._mngFl5DeskFirst, premier = this.querySelector('.mng4-scard:not([data-mng-pack-only])');
    if (cible && premier && cible !== premier && cible.parentNode === premier.parentNode) premier.parentNode.insertBefore(cible, premier);
  }

  formatAllDrawerMoney(currency) {
    const code = currency || this.currency;
    this.querySelectorAll('.cart-drawer-money').forEach(function (el) {
      const cents = parseInt(el.getAttribute('data-cents'), 10);
      if (!isNaN(cents)) el.textContent = this.formatMoney(cents, el.getAttribute('data-currency') || code);
    }.bind(this));
  }

  updateLineItemPriceBlock(lineItem, cartItem, currency) {
    if (!lineItem || !cartItem) return;
    const currencyCode = currency || this.currency;
    const isSubscribed = !!(cartItem.selling_plan_allocation);
    const qty = Math.max(1, cartItem.quantity || 1);
    
    const priceEl = lineItem.querySelector('.cart-line-price');
    const originalEl = lineItem.querySelector('.cart-line-original');
    var displayFinal = cartItem.final_line_price;
    var displayOriginal = cartItem.original_line_price;
    // Panier v4 : abonnement → prix barré = prix avant plan, lu dans l'allocation. Le calcul
    // « ÷ (1 − remise) » ne reste qu'en repli (il donnait 35,57 € pour un 1er mois à 24,90 €).
    var mng4Spa = cartItem.selling_plan_allocation;
    if (isSubscribed && mng4Spa && Number(mng4Spa.compare_at_price) > 0) {
      displayOriginal = Number(mng4Spa.compare_at_price) * qty;
    } else if (isSubscribed && displayOriginal != null && displayFinal != null && displayOriginal <= displayFinal) {
      var pct = parseInt(lineItem.getAttribute('data-subscribe-discount-pct') || '0', 10);
      if (pct > 0 && pct < 100) displayOriginal = Math.round(displayFinal * 100 / (100 - pct));
    }
    if (priceEl) priceEl.textContent = this.formatMoney(displayFinal, currencyCode);
    const showOriginal = displayOriginal != null && displayFinal != null && displayOriginal > displayFinal;
    if (originalEl) {
      originalEl.classList.toggle('hidden', !showOriginal);
      if (showOriginal) {
        originalEl.textContent = this.formatMoney(displayOriginal, currencyCode);
        if (isSubscribed && priceEl && originalEl.parentNode === priceEl.parentNode && originalEl.nextSibling !== priceEl)
          originalEl.parentNode.insertBefore(originalEl, priceEl);
      }
    }
    
    // 02/10/2026 (Alex) : « Offre Mush Caps » sous le prix barré si une remise automatique « Offre de lancement » s'applique.
    // Pendant l'offre, l'interrupteur d'abonnement de cette ligne est masqué (abonnement plus cher que l'offre ; Alex 02/10).
    // Les lignes déjà en abonnement ne portent pas cette remise : inchangées. Coupé avec le reste par mngl_on (config.launch_on).
    const mnglOn = !!(this.config && this.config.launch_on) && (cartItem.line_level_discount_allocations || []).some(function (a) {
      var d = a && a.discount_application;
      return d && Number(a.amount) > 0 && d.type === 'automatic' && /Offre de lancement/.test(String(d.title || ''));
    });
    const mnglEl = lineItem.querySelector('.mngl-l');
    if (mnglEl) {
      mnglEl.hidden = !mnglOn;
      if (this.strings && this.strings.launch_offer && mnglEl.textContent !== this.strings.launch_offer) mnglEl.textContent = this.strings.launch_offer;
    }
    const mnglSub = lineItem.querySelector('.mng4-sub');
    if (mnglSub) mnglSub.hidden = mnglOn && !isSubscribed;
    const checkbox = lineItem.querySelector('.subscribe-checkbox');
    if (checkbox) {
      checkbox.checked = isSubscribed;
      checkbox.dataset.isSubscribed = isSubscribed ? 'true' : 'false';
      checkbox.dataset.quantity = String(cartItem.quantity || 1);
      const checkIconUrl = this.config.cart_check_icon || '';
      checkbox.style.backgroundImage = isSubscribed && checkIconUrl ? "url('" + checkIconUrl + "')" : 'none';
    }
    this.mng4SyncSub(lineItem, cartItem);
  }

  // 29/09/2026 (CRO-03) : fréquence réelle d'un plan Recharge, lue dans son option « Order Frequency and Unit »
  // (valeur « 4-week », « 1-month »…). Modèles écrits par sections/cart-drawer.liquid (français seulement) :
  // sans modèle, rien n'est affiché (autres langues inchangées).
  mngFreqTxt(src) {
    const s = this.strings || {};
    let v = '';
    if (typeof src === 'string') v = src;
    else if (Array.isArray(src)) {
      src.some(function (o) {
        const x = String((o && o.value) || '');
        if (/^\d+-(day|week|month|year)s?$/i.test(x)) { v = x; return true; }
        return false;
      });
    }
    const m = /^(\d+)-(day|week|month|year)s?$/i.exec(String(v || '').trim());
    if (!m) return '';
    const n = parseInt(m[1], 10);
    const u = m[2].toLowerCase();
    const tpl = mng4Txt(n === 1 ? s['sub_freq_' + u + '_1'] : s['sub_freq_' + u]);
    return tpl ? tpl.replace(/\[n\]/g, String(n)) : '';
  }

  // Panier v4 : textes de l'interrupteur d'abonnement. Prix lus, jamais recalculés : abonné → ceux
  // de sa ligne (cart.js) ; sinon ceux du plan que la case appliquera, pris dans data-mng4-plans
  // (allocations Shopify de la variante). Le script d'A/B test du groupe B remplace le plan de la
  // case après coup : l'observateur posé dans setupDelegatedEvents() rappelle alors cette fonction.
  mng4SyncSub(lineItem, cartItem) {
    const box = lineItem ? lineItem.querySelector('.mng4-sub') : null;
    const cb = box ? box.querySelector('.subscribe-checkbox') : null;
    if (!box || !cb) return;
    const s = this.strings || {};
    const cur = this.currency;
    const spa = cartItem ? cartItem.selling_plan_allocation : null;
    const on = cartItem ? !!spa : !!cb.checked;
    const qty = Math.max(1, (cartItem && cartItem.quantity) || parseInt(cb.dataset.quantity, 10) || 1);
    let p = 0, c = 0, n = 0;
    if (on && spa) {
      p = Number(spa.per_delivery_price != null ? spa.per_delivery_price : spa.price) || 0;
      c = Number(spa.compare_at_price) || 0;
      const adj = spa.price_adjustments || [];
      const last = adj.length > 1 ? adj[adj.length - 1] : null;
      if (last && Number(last.price) !== p) n = Number(last.price) || 0;
    } else {
      let plans = {};
      try { plans = JSON.parse(box.getAttribute('data-mng4-plans') || '{}'); } catch (e) { plans = {}; }
      const pl = plans[String(cb.dataset.sellingPlanId || '')];
      if (!pl) return; // plan inconnu : on garde le rendu serveur
      p = Number(pl.p) || 0; c = Number(pl.c) || 0; n = Number(pl.n) || 0;
    }
    p *= qty; c *= qty; n *= qty;
    const fm = (v) => mng4Esc(this.formatMoney(v, cur));
    let small = '';
    if (n > 0 && s.sub_price_first_html) {
      small = s.sub_price_first_html.replace(/\{\{\s*price\s*\}\}/g, fm(p)).replace(/\{\{\s*next\s*\}\}/g, fm(n));
    } else if (!on && c > p && s.sub_price_instead_html) {
      small = s.sub_price_instead_html.replace(/\{\{\s*price\s*\}\}/g, fm(p)).replace(/\{\{\s*compare\s*\}\}/g, fm(c));
    }
    // 29/09/2026 (CRO-03) : « livré toutes les 4 semaines » (plan réel), après le prix s'il y en a un.
    let freq = '';
    try {
      const plF = JSON.parse(box.getAttribute('data-mng4-plans') || '{}')[String((on && spa && spa.selling_plan && spa.selling_plan.id) || cb.dataset.sellingPlanId || '')];
      freq = this.mngFreqTxt((plF && plF.f) || (on && spa && spa.selling_plan ? spa.selling_plan.options : ''));
    } catch (e) { freq = ''; }
    if (freq) small = small ? small + ' · ' + mng4Esc(freq) : mng4Esc(freq.charAt(0).toUpperCase() + freq.slice(1));
    const titleEl = box.querySelector('.mng4-sub-title');
    const title = (on ? s.sub_on : s.sub_off) || '';
    // Un libellé passé par le filtre t arrive échappé (« m&#39;abonne ») : innerHTML le décode,
    // textContent l'afficherait tel quel (vu le 2026-09-18).
    if (titleEl && title && titleEl.getAttribute('data-mng4') !== title) {
      titleEl.innerHTML = title;
      titleEl.setAttribute('data-mng4', title);
    }
    const smallEl = box.querySelector('.mng4-sub-price');
    if (smallEl && smallEl.getAttribute('data-mng4') !== small) {
      smallEl.innerHTML = small;
      smallEl.setAttribute('data-mng4', small);
      smallEl.hidden = !small;
    }
    const pctEl = box.querySelector('.mng4-pct');
    if (pctEl) {
      const pct = c > p ? Math.round((c - p) * 100 / c) : 0;
      const txt = pct > 0 && s.sub_pct ? s.sub_pct.replace(/\{\{\s*pct\s*\}\}/g, String(pct)) : '';
      if (pctEl.textContent !== txt) pctEl.textContent = txt;
      pctEl.hidden = !txt;
    }
  }

  // 29/09/2026 (BUG-07) : nombre d'articles payants du panier (voir mngLigneComptee).
  mngNbPayant(cart) {
    const ins = this.querySelector('[data-insurance-variant-id]');
    const insVid = ins ? ins.getAttribute('data-insurance-variant-id') : '';
    return ((cart && cart.items) || []).reduce(function (n, it) {
      return n + (mngLigneComptee(it, insVid) ? Number(it.quantity) : 0);
    }, 0);
  }

  // 29/09/2026 (BUG-01, A11Y-01) : la bulle du header est créée si elle manque (panier vide au chargement),
  // masquée à 0 ; le lien panier porte un nom accessible avec le nombre d'articles.
  updateHeaderCartCount(count) {
    const n = typeof count === 'number' && count > 0 ? count : 0;
    const s = this.strings || {};
    const lu = mng4Txt(n === 1 ? s.cart_count_one : s.cart_count_other).replace(/\d+/, String(n));
    const nom = mng4Txt(s.cart_label);
    Object.keys(MNG_BULLES).forEach(function (id) {
      const lien = document.getElementById(id);
      if (!lien) return;
      let bulle = lien.querySelector('.cart-count-bubble');
      if (!bulle && n > 0) {
        bulle = document.createElement('div');
        bulle.className = MNG_BULLES[id][0];
        const chiffre = document.createElement('span');
        chiffre.setAttribute('aria-hidden', 'true');
        chiffre.className = MNG_BULLES[id][1];
        const texte = document.createElement('span');
        texte.className = 'visually-hidden';
        bulle.appendChild(chiffre);
        bulle.appendChild(texte);
        lien.appendChild(bulle);
      }
      if (bulle) {
        const texte = bulle.querySelector('.visually-hidden');
        if (texte && lu) texte.textContent = lu;
        bulle.style.display = n > 0 ? '' : 'none';
      }
      if (nom) lien.setAttribute('aria-label', n > 0 && lu ? nom + ' (' + lu + ')' : nom);
    });
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(span => {
      span.textContent = n < 100 ? n : '99+';
    });
  }

  // Thresholds in config are in shop currency (EUR) cents. Convert to cart currency (same unit: cents/fils) for comparison.
  // Rate = how many units of cart currency per 1 unit of shop currency (e.g. 1 EUR = 3.95 AED → rate 3.95).
  getThresholdInCartCurrency(thresholdShopCents, cartCurrency) {
    const shopCurrency = (this._progressConfig && this._progressConfig.shop_currency) || 'EUR';
    const cart = (cartCurrency || this.currency || '').toString().trim().toUpperCase();
    const shop = (shopCurrency || 'EUR').toString().trim().toUpperCase();
    var cents = Number(thresholdShopCents);
    if (!Number.isFinite(cents) || cents < 0) cents = 0;
    if (cart === shop) return cents;
    var rate = (typeof Shopify !== 'undefined' && Shopify.currency && parseFloat(Shopify.currency.rate) > 0)
      ? parseFloat(Shopify.currency.rate)
      : (this._cachedProgressRate > 0 ? this._cachedProgressRate : 1);
    var result = Math.round(cents * rate);
    return Number.isFinite(result) && result >= 0 ? result : cents;
  }

  // Fetch and cache exchange rate (shop → cart) when Shopify.currency.rate is not set. Works with any shop + cart currency.
  // Uses a common base (EUR then USD fallback) so we get a full set of rates and compute shop→cart for all currencies.
  async ensureExchangeRate(cartCurrency) {
    const configEl = document.getElementById('CartDrawer-ProgressConfig');
    var shopCurrency = 'EUR';
    if (configEl) {
      try {
        var raw = mngFl5(JSON.parse(configEl.textContent));
        shopCurrency = (raw.shop_currency || 'EUR').toString().trim().toUpperCase();
      } catch (e) {}
    }
    const cart = (cartCurrency || this.currency || '').toString().trim().toUpperCase();
    if (!cart || cart === shopCurrency) {
      this._cachedProgressRate = 1;
      return;
    }
    if (typeof Shopify !== 'undefined' && Shopify.currency && parseFloat(Shopify.currency.rate) > 0) {
      this._cachedProgressRate = parseFloat(Shopify.currency.rate);
      return;
    }
    // 29/09/2026 (SEC-08) : plus d'appel à api.exchangerate-api.com (tiers sans contrat, adresse IP du client
    // envoyée hors consentement). Shopify pose Shopify.currency.rate sur les pages de la boutique (lu juste
    // au-dessus) ; à défaut, taux 1, comme getThresholdInCartCurrency().
    this._cachedProgressRate = 1;
  }

  updateProgress(cartTotal, cartCurrency) {
    const configEl = document.getElementById('CartDrawer-ProgressConfig');
    if (!configEl) return;
    
    try {
      const raw = mngFl5(JSON.parse(configEl.textContent));
      const shopCurrency = raw.shop_currency || 'EUR';
   const milestonesRaw = mngEffectiveMilestones(raw, this._lastCart || null);
      var mng4Ladder = this.querySelector('.mng4-ladder');
      if (mng4Ladder && mng4Ladder.parentElement) mng4Ladder.parentElement.hidden = !milestonesRaw.length;
      if (!milestonesRaw.length) return;
      this._progressConfig = { shop_currency: shopCurrency };
      
      const currency = cartCurrency || this.currency;
      /* 22/10/2026 (corrections-czpl-2210) : raw.shipThrDevise (Liquid, couronnes et zlotys) = seuil ROND de livraison offerte
         dans la devise du panier (2 250 Kč, 400 zł), affiché et comparé pour la marche « livraison » seulement ; sans ce champ,
         ou pour les paliers cadeaux : conversion de l'euro au taux Shopify, comme avant. */
      var shipDev = (raw.shipThrDevise > 0 && String(raw.shipThrCur || '').toUpperCase() === String(currency || '').toUpperCase()) ? Number(raw.shipThrDevise) : 0;
      const milestones = milestonesRaw.map(function (m) {
        return {
          threshold: (shipDev && m.type === 'free_shipping') ? shipDev : this.getThresholdInCartCurrency(m.threshold, currency),
          thresholdOriginal: m.threshold,
          label: m.label,
          unlockedLabel: m.unlockedLabel,
          type: m.type,
          giftVariantId: m.giftVariantId,
          goalPhrase: m.goalPhrase,
          giftImage: m.giftImage,
     unlockLabel: m.unlockLabel,
     doneLabel: m.doneLabel,
     shortLabel: m.shortLabel,
     giftZoom: m.giftZoom,
     mngVip: !!m.mngVip,
     mngDuoSeul: !!m.mngDuoSeul,
     mngChaque: !!m.mngChaque,
     mngAS: !!m.mngAS
        };
      }.bind(this));
      
      milestones.sort((a, b) => a.threshold - b.threshold);
      
      const maxThreshold = milestones[milestones.length - 1].threshold;
      if (!maxThreshold) return;
      
    const progressBar = this.querySelector('#CartDrawer-Progress');
      const progressContainer = this.querySelector('#CartDrawer-ProgressBar');
      const progressText = this.querySelector('#CartDrawer-ProgressText');
      if (!progressBar || !progressContainer || !progressText) return;

      log('updateProgress:', { cartTotal, maxThreshold, milestoneCount: milestones.length, currency });

      // ── Panier v4 (maquette Alex, 2026-09-18) ────────────────────────────────────────────────
      // Une phrase, une marche par palier, le cadeau en photo au bout. Seul le DESSIN change :
      // syncGiftProducts calcule de son côté et ne lit rien ici.
      const progress = Math.min(100, Math.max(0, (cartTotal / maxThreshold) * 100));
      progressBar.style.width = progress + '%';

      // Abonné livré gratuitement dans son pays : la marche « livraison » est acquise quel que soit
      // le montant (maquette, état 4). Le panier courant fait foi ; au premier rendu, le Liquid.
      var lastCart = this._lastCart;
      var hasSub = lastCart
        ? (lastCart.items || []).some(function (it) { return !!(it && it.selling_plan_allocation); })
        : !!raw.initialHasSubscription;
      var aboShipFree = !!raw.aboShippingFree && hasSub;
      var won = milestones.map(function (m) {
        return cartTotal >= m.threshold || (aboShipFree && m.type === 'free_shipping') || !!m.mngChaque;
      });
      var stepFrom = 0;
      var fills = milestones.map(function (m, i) {
        var span = m.threshold - stepFrom, base = stepFrom;
        stepFrom = m.threshold;
        if (won[i]) return 100;
        return span > 0 ? Math.max(0, Math.min(100, (cartTotal - base) / span * 100)) : 0;
      });
      var nextIndex = won.indexOf(false);
      var nextMilestone = nextIndex === -1 ? null : milestones[nextIndex];

      var rail = this.querySelector('#CartDrawer-Rail');
      var railLabels = this.querySelector('#CartDrawer-RailLabels');
      var say = this.querySelector('#CartDrawer-ProgressSay');

      // La structure n'est reconstruite que si la configuration change (seuils, libellés, image).
      var railKey = JSON.stringify(milestones.map(function (m) { return [m.threshold, m.label, m.type, m.giftImage || '']; }));
      if (rail && railLabels && this._railKey !== railKey) {
        var n = milestones.length;
        rail.innerHTML = milestones.map(function (m, i) {
          var last = i === n - 1;
          var seg = '<div class="mng4-seg" style="' + (last ? 'flex:1 1 auto' : 'flex:0 0 calc(' + (100 / n).toFixed(3) + '% - 6px)')
            + '"><span class="mng4-fill"></span></div>';
          var mark = (m.type === 'free_gift' && m.giftImage)
      ? '<span class="mng4-gift' + (m.giftZoom ? ' mng4-gift--' + mng4Esc(m.giftZoom) : '') + '"><img src="' + mng4Esc(m.giftImage) + '" alt="" width="36" height="36" decoding="async"></span>'
            : '<span class="mng4-node"></span>';
          return seg + mark;
        }).join('');
        railLabels.style.gridTemplateColumns = 'repeat(' + n + ', minmax(0, 1fr))';
        railLabels.innerHTML = milestones.map(function () { return '<span></span>'; }).join('');
        this._railKey = railKey;
      }

      if (rail) {
        var fillEls = rail.querySelectorAll('.mng4-fill');
        var markEls = rail.querySelectorAll('.mng4-node, .mng4-gift');
        fills.forEach(function (f, i) {
          if (fillEls[i]) fillEls[i].style.width = f + '%';
          if (markEls[i]) markEls[i].classList.toggle('is-on', won[i]);
        });
      }

   var mngpMode = milestones.some(function (m) { return !!m.shortLabel; });
   if (railLabels) railLabels.classList.toggle('mngp-labels', mngpMode);
   mngFl5Habille(this, railLabels, milestones.length);
   try { if (railLabels) mngFl5Barre(this, railLabels, milestones, won, cartTotal); } catch (e) { console.error('[flash] barre', e); }
   if (railLabels && mngpMode) {
    milestones.forEach(function (m, i) {
     var cell = railLabels.children[i];
     if (!cell) return;
     var short = m.shortLabel || (m.type === 'free_shipping' ? (raw.packShipShort || m.label) : m.label);
     var html = '<b>' + mng4Esc(short) + '</b><i>' + mng4Esc(this.formatMoneyShort(m.threshold, this.currency)) + '</i>';
     if (cell.innerHTML !== html) cell.innerHTML = html;
     cell.classList.toggle('is-on', won[i]);
    }.bind(this));
    var mngpPlace = function () {
    if (!railLabels.classList.contains('mngp-labels')) return;
    var mngpNodes = rail ? rail.querySelectorAll('.mng4-node, .mng4-gift') : [];
    var mngpBox = railLabels.getBoundingClientRect();
    var mngpPos = [];
    milestones.forEach(function (m, i) {
     var cell = railLabels.children[i];
     if (!cell) return;
     var cx = null;
     if (mngpNodes[i] && mngpBox.width) {
      var nb = mngpNodes[i].getBoundingClientRect();
      if (nb.width) cx = nb.left + nb.width / 2 - mngpBox.left;
     }
     var W = mngpBox.width || railLabels.offsetWidth || 0;
     if (cx == null) cx = W * (i + 1) / milestones.length;
     var w = cell.offsetWidth || 0;
     mngpPos.push({ cell: cell, w: w, left: Math.max(0, Math.min(W - w, cx - w / 2)) });
    }.bind(this));
    for (var pi = mngpPos.length - 2; pi >= 0; pi--) {
     var maxLeft = mngpPos[pi + 1].left - 12 - mngpPos[pi].w;
     if (mngpPos[pi].left > maxLeft) mngpPos[pi].left = Math.max(0, maxLeft);
    }
    mngpPos.forEach(function (pp) { pp.cell.style.left = pp.left + 'px'; });
    };
    mngpPlace();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(mngpPlace);
    setTimeout(mngpPlace, 450);
   } else if (railLabels) {
    Array.prototype.forEach.call(railLabels.children, function (c) { c.style.left = ''; });
   }

   if (railLabels && !mngpMode) {
        // Pas de repli contenant des accolades doubles : ce script vit dans un fichier Liquid, qui les
        // remplacerait par du vide au rendu. La chaîne existe dans les 6 langues ; sinon, le libellé seul.
        var fromTpl = this.strings.progress_from;
        milestones.forEach(function (m, i) {
          var cell = railLabels.children[i];
          if (!cell) return;
          cell.classList.toggle('is-on', won[i]);
          cell.textContent = (won[i] || !fromTpl)
            ? m.label
            : fromTpl.replace(/\{\{\s*label\s*\}\}/g, m.label)
                     .replace(/\{\{\s*amount\s*\}\}/g, this.formatMoneyShort(m.threshold, this.currency));
        }.bind(this));
      }

      if (say) {
        if (!nextMilestone) {
          // « Livraison offerte et Anti-Stress offert » : la conjonction vient de la langue du visiteur.
     var names = milestones.map(function (m) { return m.doneLabel || m.label; });
          var joined;
     var plusNames = names.filter(function (x) { return /^\+\s/.test(x); });
     if (mngpMode && raw.packDoneText) {
      joined = raw.packDoneText;
     } else if (plusNames.length) {
      joined = names.filter(function (x) { return !/^\+\s/.test(x); }).join(', ') + ' ' + plusNames.join(' ');
     } else {
          try {
            joined = new Intl.ListFormat(this.locale || 'fr', { style: 'long', type: 'conjunction' }).format(names);
          } catch (e) {
            joined = names.join(' · ');
     }
          }
          say.textContent = joined;
          say.classList.add('is-done');
        } else {
          var sayTpl = this.strings.progress_remaining || '';
          var rest = this.formatMoney(nextMilestone.threshold - cartTotal, this.currency);
          if (!sayTpl) sayTpl = rest + ' · ' + (nextMilestone.goalPhrase || nextMilestone.label);
          say.innerHTML = mng4Esc(sayTpl)
            .replace(/\{\{\s*amount\s*\}\}/g, '<em>' + mng4Esc(rest) + '</em>')
            .replace(/\{\{\s*label\s*\}\}/g, mng4Esc(nextMilestone.goalPhrase || nextMilestone.label));
          say.classList.remove('is-done');
        }
      }

      // Panier v4 : ligne « Livraison » des totaux, alignée sur la marche livraison de la barre.
      var shipRow = this.querySelector('#CartDrawer-Shipping');
      if (shipRow) {
        var shipIdx = -1;
        milestones.forEach(function (m, i) { if (shipIdx === -1 && (m.type || 'free_shipping') === 'free_shipping') shipIdx = i; });
        var shipSt = (shipIdx !== -1 && cartTotal >= milestones[shipIdx].threshold) ? 'free' : (aboShipFree ? 'abo' : 'later');
        var shipTxt = mng4Txt(shipSt === 'free' ? this.strings.ship_free : (shipSt === 'abo' ? this.strings.ship_free_abo : this.strings.ship_later)) || '';
        // 29/09/2026 (CRO-05) : sous le seuil, le port réel et le seuil du pays (« dès 3,90 € · offerte dès 59 € »)
        // au lieu de « calculée à l'étape suivante » seul. Modèles et port écrits par sections/cart-drawer.liquid.
        if (shipSt === 'later' && shipIdx !== -1 && this.strings.ship_later_seuil) {
          var portC = Number(raw.shipPortCents) || 0;
          var shipTpl = mng4Txt(portC > 0 ? this.strings.ship_later_port : this.strings.ship_later_seuil);
          if (shipTpl) shipTxt = shipTpl.replace('[seuil]', this.formatMoneyShort(milestones[shipIdx].threshold, this.currency)).replace('[port]', this.formatMoney(this.getThresholdInCartCurrency(portC, this.currency), this.currency));
        }
        var shipV = shipRow.querySelector('.mng4-v');
        if (shipV && shipTxt && shipV.textContent !== shipTxt) shipV.textContent = shipTxt;
        shipRow.classList.toggle('is-y', shipSt !== 'later');
      }

      // Panier v4 : écart restant de chaque marche non franchie, pour les pastilles des suggestions.
      this._mng4Gaps = milestones.map(function (m, i) {
        return won[i] ? null : { gap: m.threshold - cartTotal, label: m.unlockLabel || '' };
      }).filter(function (g) { return g && g.label; });
      this.mng4UpdateUnlocks();

      // Texte masqué conservé : d'autres fonctions le lisent encore.
      if (!nextMilestone) {
        var lastM = milestones[milestones.length - 1];
        progressText.textContent = lastM.unlockedLabel || lastM.label || (this.strings.progress_unlocked || 'Tous les avantages débloqués !');
      } else {
        var template = this.strings.progress_remaining || '';
        progressText.textContent = template
          .replace(/\{\{\s*amount\s*\}\}/g, this.formatMoney(nextMilestone.threshold - cartTotal, this.currency))
          .replace(/\{\{\s*label\s*\}\}/g, nextMilestone.label);
      }

      // 13/10/2026 (CADEAUX SUR LE PAYÉ) : code promo au panier = pas de cadeau, dit sous la phrase de la barre.
      var mngNc = this.querySelector('#CartDrawer-SansCumul');
      var mngNcOn = mngCodeRetireCadeaux(lastCart) && mngAllMilestones(raw).some(function (m) { return m && String(m.type || '').toLowerCase() === 'free_gift'; });
      if (mngNcOn && !mngNc && say && say.parentNode) {
        mngNc = document.createElement('p');
        mngNc.id = 'CartDrawer-SansCumul';
        mngNc.setAttribute('role', 'status');
        mngNc.style.cssText = 'margin:4px 0 0;font-size:12px;line-height:1.3;font-weight:600;text-align:center;opacity:.92';
        say.parentNode.insertBefore(mngNc, say.nextSibling);
      }
      if (mngNc) { mngNc.textContent = mngNcOn ? mngSansCumulT() : ''; mngNc.hidden = !mngNcOn; }

      log('updateProgress: done', { progress: progress.toFixed(1) + '%', nextMilestone: nextMilestone && nextMilestone.label });
    } catch (err) {
      logError('updateProgress:', err);
    }
  }

  // 29/09/2026 (CRO-18) : logos du pied = moyens réellement proposés au paiement. Apple Pay (activé sur la
  // boutique) seulement si l'appareil le propose (Safari sur appareil Apple) ; ailleurs le paiement ne l'affiche pas.
  // Klarna seulement sans abonnement au panier : relevé au paiement le 29/09, proposé pour un achat unique
  // (71,29 €), absent pour un abonnement (49,90 €).
  mngLogosPaiement(cart) {
    const ap = this.querySelector('[data-mng-pay="applepay"]');
    if (ap) {
      let ok = false;
      try { ok = !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch (e) { ok = false; }
      ap.hidden = !ok;
    }
    const kl = this.querySelector('[data-mng-pay="klarna"]');
    if (kl && cart) kl.hidden = ((cart.items || []).some(function (it) { return !!(it && it.selling_plan_allocation); }));
  }

  // Panier v4 : lignes des totaux ajoutées par la maquette. Économie abonnement = (prix avant plan −
  // prix de la livraison) × quantité, lus dans les allocations ; une ligne par cadeau automatique offert.
  mng4SyncTotals(cart) {
    const s = this.strings || {};
    const cur = (cart && cart.currency) || this.currency;
    var saving = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      const a = it.selling_plan_allocation;
      if (!a) return;
      const c = Number(a.compare_at_price) || 0;
      const p = Number(a.per_delivery_price != null ? a.per_delivery_price : a.price) || 0;
      if (c > p) saving += (c - p) * (Number(it.quantity) || 1);
    });
    const sRow = this.querySelector('#CartDrawer-AboSaving');
    if (sRow) {
      const v = sRow.querySelector('.mng4-v');
      const txt = saving > 0 ? this.formatMoney(saving, cur) : '';
      if (v && v.textContent !== txt) v.textContent = txt;
      sRow.hidden = !txt;
    }
  const mngpIsPack = cartHasNoGiftProduct(cart);
  const mngpDrawerEl = this.querySelector('#CartDrawer');
  if (mngpDrawerEl) mngpDrawerEl.classList.add('mngp-compact'); // Alex 18/09 : tiroir compact pour tous les paniers
  const pgEl = this.querySelector('#CartDrawer-PackGifts');
  if (pgEl) {
   var pgHtml = '';
   if (cartHasNoGiftProduct(cart)) {
    var pgCfg = {};
    try { pgCfg = mngFl5(JSON.parse(document.getElementById('CartDrawer-ProgressConfig').textContent)) || {}; } catch (e) {}
    var pgImgs = pgCfg.packGiftImg || {};
    var pgItems = ((cart && cart.items) || []).filter(function (it) {
     return it.properties && cartLineIsAutoGift(it.properties) && Number(it.final_line_price) === 0 && it.quantity > 0;
    });
    var pgOrder = Object.keys(pgImgs); // Café (119 €) puis Chocolat (169 €)
    pgItems.sort(function (a, b) { return pgOrder.indexOf(String(a.variant_id)) - pgOrder.indexOf(String(b.variant_id)); });
    if (pgItems.length) {
     pgHtml = '<span class="mngp-gifts-t">' + mng4Esc(pgCfg.packGiftsTitle || '') + '</span>' + pgItems.map(function (it) {
      var src = pgImgs[String(it.variant_id)] || (it.image && (typeof it.image === 'string' ? it.image : it.image.url)) || '';
      var q = Number(it.quantity) || 1;
      return '<span class="mngp-giftw"><span class="mngp-gift"><img src="' + mng4Esc(src) + '" alt="' + mng4Esc(String(it.product_title || '').split(' - ')[0]) + '" width="30" height="30"></span>'
       + (q > 1 ? '<span class="mngp-q">×' + q + '</span>' : '') + '</span>';
     }).join('') + '<span class="mngp-gifts-o">' + mng4Esc(s.gift_free || '') + '</span>';
    }
   }
   if (pgEl.getAttribute('data-mngp') !== pgHtml) { pgEl.innerHTML = pgHtml; pgEl.setAttribute('data-mngp', pgHtml); }
   pgEl.hidden = !pgHtml;
  }
    const gRows = this.querySelector('#CartDrawer-GiftRows');
    if (gRows) {
   var mngpGiftLines = ((cart && cart.items) || []).filter(function (it) {
        return it.properties && cartLineIsAutoGift(it.properties) && Number(it.final_line_price) === 0;
   });
   var mngpRowLbl = '';
   if (mngpGiftLines.length) {
    try { mngpRowLbl = (mngFl5(JSON.parse(document.getElementById('CartDrawer-ProgressConfig').textContent)) || {}).packGiftsRow || ''; } catch (e) {}
   }
   const html = mngpRowLbl
    ? '<div class="mng4-r is-y"><span>' + mng4Esc(mngpRowLbl) + ' (' + mngpGiftLines.reduce(function (n, it) { return n + (Number(it.quantity) || 1); }, 0) + ')</span><span>' + (s.gift_free || '') + '</span></div>'
    : mngpGiftLines.map(function (it) {
    return '<div class="mng4-r is-y"><span>' + mng4Esc(String(it.product_title || it.title || '').split(' - ')[0]) + (Number(it.quantity) > 1 ? ' ×' + Number(it.quantity) : '') + '</span><span>' + (s.gift_free || '') + '</span></div>';
      }).join('');
      if (gRows.getAttribute('data-mng4') !== html) {
        gRows.innerHTML = html;
        gRows.setAttribute('data-mng4', html);
      }
    }
  }

  mng4PromoOpen(open) {
    const box = this.querySelector('#CartDrawer-Promo');
    const body = this.querySelector('#CartDrawer-PromoBody');
    const btn = this.querySelector('.mng4-promo-toggle');
    if (!box || !body || !btn) return;
    body.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    box.classList.toggle('is-open', !!open);
    if (open) {
      const input = this.querySelector('[data-promo-input]');
      if (input) setTimeout(function () { input.focus(); }, 30);
    }
  }

  // Panier v4 : pour chaque marche restante, pastille « Débloque … » sur la suggestion la moins chère
  // dont le prix suffit à la franchir (ordre de la liste en cas d'égalité) ; « Débloque les 2 cadeaux »
  // si la même suffit aux deux. Les produits déjà au panier ne comptent pas. Sur mobile, la suggestion
  // de la marche suivante passe en tête du carrousel : voir syncSuggestionsWithCart.
  mng4UpdateUnlocks() {
    var mngFl5On = false; try { mngFl5On = mngFl5Actif() || mngP06Actif(); if (mngFl5On) this.mngFl5Trier(); } catch (e) { console.error('[flash] tri des suggestions', e); }
    this._mngFl5DeskFirst = null;
    const gaps = this._mng4Gaps || [];
    const s = this.strings || {};
    const inCart = new Set(((this._lastCart && this._lastCart.items) || []).map(function (i) { return String(i.product_id); }));
  const mngpPack = cartHasNoGiftProduct(this._lastCart);
    const pool = (this._suggestionSlidePool || []).map(function (li) { return li.querySelector('.mng4-rcard'); }).filter(Boolean);
    const groups = [
      Array.prototype.slice.call(this.querySelectorAll('.mng4-scard')),
      pool.length ? pool : Array.prototype.slice.call(this.querySelectorAll('.mng4-rcard'))
    ];
    this._mng4FirstPid = null;
    groups.forEach(function (cards, gi) {
   var mngK = 0;
   const avail = cards.filter(function (el) { return !inCart.has(String(el.getAttribute('data-suggestion-product-id'))) && (el.hasAttribute('data-mng-pack-only') || ++mngK <= 6) && (mngpPack ? el.getAttribute('data-mng-pack-hide') !== '1' : el.getAttribute('data-mng-pack-only') !== '1'); });
      const tags = new Map();
      gaps.forEach(function (g, i) {
        var best = null;
        avail.forEach(function (el) {
          const price = Number(el.getAttribute('data-mng4-price')) || 0;
          if (price >= g.gap && (!best || price < best.price)) best = { el: el, price: price };
        });
        if (!best) return;
        const arr = tags.get(best.el) || [];
        arr.push(g.label);
        tags.set(best.el, arr);
        if (gi === 1 && i === 0) this._mng4FirstPid = best.el.getAttribute('data-suggestion-product-id');
        if (gi === 0 && i === 0) this._mngFl5DeskFirst = best.el;
      }.bind(this));
      cards.forEach(function (el) {
        const arr = tags.get(el);
        var txt = '';
        if (arr && arr.length > 1) txt = mng4Txt(mngUnlockTxt(arr.length) || String(s.unlock_all || '').replace(/\{\{\s*count\s*\}\}/g, String(arr.length))) || arr.join(' · ');
        else if (arr) txt = arr[0];
        const pill = el.querySelector('.mng4-unlock');
        if (pill) {
          if (pill.textContent !== txt) pill.textContent = txt;
          pill.hidden = !txt;
        }
        el.classList.toggle('is-tagged', !!txt);
      });
    }.bind(this));
    if (mngFl5On) { try { this.mngFl5Tete(); } catch (e) { console.error('[flash] tête des suggestions', e); } }
  }

  // ── Gift product auto-add/remove ─────────────────────────────────────────
  // Returns { cart, changed } where cart is the latest cart object.
  // Uses the cart subtotal EXCLUDING gift items to evaluate thresholds, so
  // an expensive gift item can never tip the cart over its own trigger.
  // 29/09/2026 (BUG-04) : quantités de cadeau voulues par les paliers pour ce panier, { variante: quantité } (paniers
  // 3+3 / 3+2 : Café 1 à 119 €, puis Café 2 + Chocolat 1 à 169 €, 0 sous le palier). Vide pour un autre panier (1 par
  // cadeau). Lu par la synchro du tiroir ET par la garde « 1 par commande » de layout/theme.liquid (window.mngCadeauxCibles),
  // qui ne ramène donc plus à 1 le Café du palier Duo.
  mngCadeauxCibles(cart) {
    const out = {};
    const configEl = document.getElementById('CartDrawer-ProgressConfig');
    let raw = null;
    try { raw = configEl ? mngFl5(JSON.parse(configEl.textContent)) : null; } catch (e) { raw = null; }
    if (raw && !Array.isArray(raw) && cart && !cartHasNoGiftProduct(cart)) {
      /* 13/10/2026 : panier normal, seuls les cadeaux à quantité > 1 (20 capsules = 2 boîtes) : la garde « 1 par commande » ne les ramène pas à 1. */
      const curN = (cart.currency || this.currency || '').toString().trim().toUpperCase();
      const eligN = this.computeGiftProgressTotals(cart).eligibleTotal;
      mngEffectiveMilestones(raw, cart).forEach(function (m) {
        if (!m || !(Number(m.giftQty) > 1) || eligN < this.getThresholdInCartCurrency(m.threshold, curN)) return;
        out[String(m.giftVariantId)] = Math.max(out[String(m.giftVariantId)] || 0, Number(m.giftQty));
      }.bind(this));
      return out;
    }
    if (!raw || Array.isArray(raw) || !raw.packMilestones || !cart || !cartHasNoGiftProduct(cart)) return out;
    const cur = (cart.currency || this.currency || '').toString().trim().toUpperCase();
    const elig = this.computeGiftProgressTotals(cart).eligibleTotal;
    mngP06Pack(raw, cart).forEach(function (m) {
      const reached = elig >= this.getThresholdInCartCurrency(m.threshold, cur);
      (m.gifts || [{ v: m.giftVariantId, q: 1 }]).forEach(function (g) {
        const k = String(g.v);
        out[k] = (out[k] || 0) + (reached ? (Number(g.q) || 1) : 0);
      });
    }.bind(this));
    return out;
  }

  // 02/10/2026 (CADEAUX-ULTIME) : quantité PERMISE de chaque cadeau _gift pour ce panier, { variante: quantité }.
  // Panier 3+3 / 3+2 / Ultime : mngCadeauxCibles (119 € Café 1, 169 € Café 2 + Chocolat 1). Autre panier : 1 par
  // cadeau de palier « free_gift » atteint, 0 sinon. Variante absente = 0 (cadeau de l'autre mode, ancien cadeau).
  // null = configuration illisible : la garde ne touche à rien.
  mngCadeauxPermis(cart) {
    const configEl = document.getElementById('CartDrawer-ProgressConfig');
    let raw = null;
    try { raw = configEl ? mngFl5(JSON.parse(configEl.textContent)) : null; } catch (e) { raw = null; }
    if (!raw || !cart) return null;
    if (!Array.isArray(raw) && raw.packMilestones && cartHasNoGiftProduct(cart)) return mngCapsAboFusion(this.mngCadeauxCibles(cart), cart);
    const out = {};
    const cur = (cart.currency || this.currency || '').toString().trim().toUpperCase();
    const elig = this.computeGiftProgressTotals(cart).eligibleTotal;
    mngEffectiveMilestones(raw, cart).forEach(function (m) {
      const gid = m && m.giftVariantId;
      if (!m || (m.type || '').toString().toLowerCase() !== 'free_gift' || gid == null || String(gid) === '' || String(gid) === '0') return;
      const k = String(gid);
      out[k] = Math.max(out[k] || 0, elig >= this.getThresholdInCartCurrency(m.threshold, cur) ? (Number(m.giftQty) || 1) : 0);
    }.bind(this));
    return mngCapsAboFusion(out, cart);
  }

  // 02/10/2026 (CADEAUX-ULTIME) : lignes cadeau (_gift) au-delà de la quantité permise, [{ key, quantity à garder }].
  mngCadeauxEnTrop(cart) {
    const permis = this.mngCadeauxPermis(cart);
    if (!permis) return [];
    const reste = Object.assign({}, permis);
    const out = [];
    ((cart && cart.items) || []).forEach(function (it) {
      if (!it || !(Number(it.quantity) > 0) || !it.properties || !cartLineIsAutoGift(it.properties)) return;
      const k = String(it.variant_id);
      const garde = Math.max(0, Math.min(Number(it.quantity), Number(reste[k]) || 0));
      reste[k] = (Number(reste[k]) || 0) - garde;
      if (garde < Number(it.quantity)) out.push({ key: it.key, quantity: garde, variant_id: it.variant_id });
    });
    return out;
  }

  // 02/10/2026 (CADEAUX-ULTIME, commandes #36291 #36325 #36361) : garde des cadeaux. Relit le panier et ramène chaque
  // cadeau _gift à sa quantité permise, jamais d'ajout. Même verrou que syncGiftProducts (une opération cadeaux à la
  // fois). Renvoie { cart, changed, reste } ; reste > 0 = un cadeau dépasse encore (changement refusé), dit en console.
  mngGardeCadeaux(raison) {
    const self = this;
    const prev = self._mngGiftRun;
    const run = (prev ? prev.then(function () {}, function () {}) : Promise.resolve())
      .then(function () { return self.mngGardeCadeauxMaintenant(raison); });
    self._mngGiftRun = run;
    const fin = function () { if (self._mngGiftRun === run) self._mngGiftRun = null; };
    run.then(fin, fin);
    return run;
  }

  async mngGardeCadeauxMaintenant(raison) {
    let cart = await this.fetchCart();
    await this.ensureExchangeRate(cart.currency);
    const enTrop = this.mngCadeauxEnTrop(cart);
    if (!enTrop.length) return { cart: cart, changed: false, reste: 0 };
    const actifs = function (c) {
      return ((c && c.discount_codes) || []).filter(function (d) { return d && d.code && String(d.code).trim() && d.applicable !== false; })
        .map(function (d) { return String(d.code).trim(); });
    };
    const codes = actifs(cart);
    let fait = 0;
    for (let tour = 0; tour < 8; tour++) {
      const l = this.mngCadeauxEnTrop(cart)[0];
      if (!l) break;
      const res = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS,
        body: JSON.stringify({ id: l.key, quantity: l.quantity }) }));
      if (!res.ok) { console.error('[cadeaux] garde (' + raison + ') : /cart/change refusé (' + res.status + ')', l); break; }
      cart = await parseJsonResponse(res);
      fait++;
    }
    // un /cart/change peut faire tomber un code promo du panier (cf. syncGiftProducts) : on le remet
    const restants = actifs(cart).map(function (c) { return c.toLowerCase(); });
    const perdus = codes.filter(function (c) { return restants.indexOf(c.toLowerCase()) === -1; });
    if (fait && perdus.length) {
      const re = await fetch(this.getCartUpdateUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS,
        body: JSON.stringify({ discount: codes.join(',') }) }));
      if (re.ok) cart = await parseJsonResponse(re);
      else console.error('[cadeaux] garde (' + raison + ') : code promo non remis (' + re.status + ')', perdus);
    }
    const reste = this.mngCadeauxEnTrop(cart);
    console.warn('[cadeaux] garde (' + raison + ') : ' + fait + ' ligne(s) cadeau ramenée(s) au palier', enTrop);
    if (reste.length) console.error('[cadeaux] garde (' + raison + ') : cadeau ENCORE au-delà du palier', reste);
    try { if (typeof window.clarity === 'function') window.clarity('event', reste.length ? 'mng_cadeau_hors_palier_reste' : 'mng_cadeau_hors_palier_corrige'); } catch (e) { /* Clarity absent */ }
    return { cart: cart, changed: fait > 0, reste: reste.length };
  }

  // 02/10/2026 (CADEAUX-ULTIME) : après un changement du panier fait hors du tiroir, ou au chargement : garde, puis tiroir
  // redessiné (sans nouvelle synchro, donc sans ajout) ou page /cart rechargée.
  mngApresMutation(raison, delai) {
    clearTimeout(this._mngGardeT);
    this._mngGardeT = setTimeout(async () => {
      let r = null;
      try { r = await this.mngGardeCadeaux(raison); }
      catch (e) { console.error('[cadeaux] garde (' + raison + ') en échec', e); return; }
      if (!r || !r.changed) {
        // 13/10/2026 (BUG-PANIER-SUPPRESSION) : cadeau retiré par un autre script (layout/theme.liquid) : page re-dessinée si elle ne suit plus.
        if (r && mngPagePanier() && mngPagePanierPerimee(r.cart)) await mngRedessinerPagePanier();
        return;
      }
      if (mngPagePanier()) { mngRechargerPagePanier(); return; }
      try { await this.updateCartUI(r.cart, { skipGiftSync: true }); }
      catch (e) { console.error('[cadeaux] tiroir non redessiné après la garde', e); }
    }, delai == null ? 350 : delai);
  }

  // 02/10/2026 (CADEAUX-ULTIME) : « Paiement » (lien du tiroir, « Commander » de /cart) : garde d'abord, puis départ.
  // Garde en échec ou plus lente que 4 s : départ quand même (erreur en console + évènement Clarity
  // mng_garde_cadeaux_echec), pour ne jamais bloquer un paiement. siCorrige : page /cart rechargée au lieu du départ.
  mngPayerApresGarde(partirVers, siCorrige) {
    if (this._mngPaiement) return;
    this._mngPaiement = true;
    const self = this;
    let fini = false;
    let minuteur = null;
    const conclure = function (action, erreur) {
      if (fini) return;
      fini = true;
      clearTimeout(minuteur);
      if (erreur) {
        console.error('[cadeaux] passage au paiement SANS garde : ' + erreur);
        try { if (typeof window.clarity === 'function') window.clarity('event', 'mng_garde_cadeaux_echec'); } catch (e) { /* Clarity absent */ }
      }
      setTimeout(function () { self._mngPaiement = false; }, 8000);
      action();
    };
    minuteur = setTimeout(function () { conclure(partirVers, 'garde plus lente que 4 s'); }, 4000);
    this.mngGardeCadeaux('paiement').then(function (r) {
      if (r && r.changed && typeof siCorrige === 'function') { self._mngPaiement = false; conclure(siCorrige, ''); return; }
      conclure(partirVers, '');
    }, function (e) { conclure(partirVers, (e && e.message) || String(e)); });
  }

  // 29/09/2026 (BUG-10) : une seule synchronisation des cadeaux à la fois. Un appel qui arrive pendant qu'une
  // synchro tourne attend la fin, puis repart du panier relu (/cart.js) : plus de /cart/add.js du même cadeau
  // en parallèle (3 ajouts puis 2 corrections, mesuré par l'audit du 26/09). Les appels en attente partagent la
  // même relance ; chacun apprend si le panier a changé depuis le sien (changed), pour se redessiner.
  syncGiftProducts(cart, discountRepairDepth) {
    if (discountRepairDepth) return this.mngSyncGiftProductsNow(cart, discountRepairDepth);
    var self = this;
    if (self._mngGiftRun) {
      if (!self._mngGiftNext) {
        var relance = function () {
          self._mngGiftNext = null;
          return self.fetchCart().then(function (frais) { return self.syncGiftProducts(frais); });
        };
        self._mngGiftNext = self._mngGiftRun.then(relance, relance);
      }
      return self._mngGiftNext.then(function (r) {
        return { cart: r.cart, changed: !!r.changed || mngSignaturePanier(r.cart) !== mngSignaturePanier(cart) };
      });
    }
    var run = self.mngSyncGiftProductsNow(cart);
    self._mngGiftRun = run;
    var fin = function () { if (self._mngGiftRun === run) self._mngGiftRun = null; };
    run.then(fin, fin);
    return run;
  }

  async mngSyncGiftProductsNow(cart, discountRepairDepth) {
    discountRepairDepth = discountRepairDepth || 0;
    const configEl = document.getElementById('CartDrawer-ProgressConfig');
    if (!configEl) {
      log('syncGiftProducts: no config element');
      return { cart, changed: false };
    }
    var raw;
    mngVipVoitPanier(cart);
    try { raw = mngFl5(JSON.parse(configEl.textContent)); } catch (e) {
      log('syncGiftProducts: config parse error', e);
      return { cart, changed: false };
    }
    var mngVipMaj = false;
    if (!mngVipEcrit && mngVipActif() && cart && cart.item_count > 0 && !(cart.attributes && cart.attributes[MNG_VIP.attr] === MNG_VIP.code)) {
      mngVipEcrit = true;
      try {
        var vAttr = {}; vAttr[MNG_VIP.attr] = MNG_VIP.code;
        var vRes = await fetch(this.getCartUpdateUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS, body: JSON.stringify({ attributes: vAttr }) }));
        if (vRes.ok) { cart = await this.fetchCart(); mngVipMaj = true; } else console.error('[vip] attribut de panier refusé (' + vRes.status + ')');
      } catch (e) { console.error('[vip] attribut de panier', e); }
    }
  var milestonesRaw = mngEffectiveMilestones(raw, cart);
    log('syncGiftProducts: config milestones', milestonesRaw.map(function (m, i) { return { i: i, label: m.label, type: m.type, giftVariantId: m.giftVariantId }; }));
    var giftMilestones = milestonesRaw.filter(function (m) {
      var type = (m.type || '').toString().toLowerCase();
      var gid = m.giftVariantId;
      var hasGiftId = gid != null && String(gid) !== '' && String(gid) !== '0';
      return (type === 'free_gift' && hasGiftId);
    });
    log('syncGiftProducts: start', { cartItemCount: (cart.items || []).length, giftMilestoneCount: giftMilestones.length, giftVariantIds: giftMilestones.map(function (m) { return m.giftVariantId; }) });
    if (!giftMilestones.length && !mngCodeRetireCadeaux(cart) && !mngCapsAboEnJeu(cart)) { /* 13/10/2026 (CADEAUX SUR LE PAYÉ) : avec un code, on continue jusqu'au nettoyage des lignes cadeau (plus bas) */
      log('syncGiftProducts: no gift milestones. In theme: set the milestone to "Free gift" and choose a "Gift product".');
      return { cart, changed: false };
    }

    var cartCurrency = (cart.currency || this.currency || '').toString().trim().toUpperCase();
    await this.ensureExchangeRate(cartCurrency);
    var currentCart = cart;
    var changed = mngVipMaj;

    function isGiftLine(item) {
      return item.properties && cartLineIsAutoGift(item.properties);
    }

    // Min threshold per gift variant (when same variant is in multiple milestones, remove only when below the lowest)
    var minThresholdByGiftVariant = {};
    giftMilestones.forEach(function (m) {
      var gid = String(m.giftVariantId);
      var t = this.getThresholdInCartCurrency(m.threshold, cartCurrency);
      if (minThresholdByGiftVariant[gid] == null || t < minThresholdByGiftVariant[gid]) {
        minThresholdByGiftVariant[gid] = t;
      }
    }.bind(this));

  var mngpWant = null;
  if (cartHasNoGiftProduct(currentCart) && !Array.isArray(raw) && raw.packMilestones) {
   // 29/09/2026 (BUG-04) : même calcul que la garde « 1 par commande » de layout/theme.liquid (mngCadeauxCibles).
   mngpWant = this.mngCadeauxCibles(currentCart);
   var mngpEligible = this.computeGiftProgressTotals(currentCart).eligibleTotal;
   var mngpBanner = null;
   var mngpVids = Object.keys(mngpWant);
   for (var mv = 0; mv < mngpVids.length; mv++) {
    var mvid = mngpVids[mv];
    var want = mngpWant[mvid];
    var mLine = (currentCart.items || []).find(function (item) { return lineIsRemovableGiftSku(item, mvid); });
    var have = mLine ? mLine.quantity : 0;
    if (have === want) continue;
    try {
     var mRes;
     if (!mLine) {
      mRes = await fetch(this.getCartAddUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS,
       body: JSON.stringify({ items: [{ id: Number(mvid), quantity: want, properties: { _gift: '1' } }] }) }));
     } else {
      mRes = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS,
       body: JSON.stringify({ id: mLine.key || mLine.id, quantity: want }) }));
     }
     if (mRes.ok) {
      currentCart = await this.fetchCart();
      changed = true;
      if (want > have) mngpBanner = true; else this.hideGiftProgressBanner();
     } else {
      logError('syncGiftProducts pack gift', { variantId: mvid, want: want, status: mRes.status });
     }
    } catch (e) { logError('syncGiftProducts pack gift:', e); }
   }
   if (mngpBanner) {
    var mngpTop = null;
    mngP06Pack(raw, currentCart).forEach(function (m) {
     if (mngpEligible >= this.getThresholdInCartCurrency(m.threshold, cartCurrency)) mngpTop = m;
    }.bind(this));
    if (mngpTop) {
     var mngpTpl = (this.strings.progress_gift_added || '🎁 {{ label }} ajouté !');
     this.showProgressBanner(mngpTpl.replace(/\{\{\s*label\s*\}\}/g, mngpTop.bannerLabel || mngpTop.doneLabel || mngpTop.label || 'Cadeau'), 'success');
    }
   }
  }

  for (var i = 0; !mngpWant && i < giftMilestones.length; i++) {
      var milestone = giftMilestones[i];
      var thresholdInCart = this.getThresholdInCartCurrency(milestone.threshold, cartCurrency);
      var gvidStr = String(milestone.giftVariantId);
      var gpTotals = this.computeGiftProgressTotals(currentCart);
      var eligibleTotal = gpTotals.eligibleTotal;
   var isAbove = eligibleTotal >= thresholdInCart;
      var minThresholdForThisVariant = minThresholdByGiftVariant[gvidStr];
   var isBelowAllThresholdsForVariant = minThresholdForThisVariant != null && eligibleTotal < minThresholdForThisVariant;
      var hasFreeGiftRowForVariant = (currentCart.items || []).some(function (item) {
        return lineIsRemovableGiftSku(item, gvidStr);
      });
      var hasStrictGiftProp = (currentCart.items || []).some(function (item) {
        return String(item.variant_id) === gvidStr && item.quantity > 0 && isGiftLine(item);
      });
      
      log('syncGiftProducts: milestone', { label: milestone.label, variantId: milestone.giftVariantId, thresholdInCart, eligibleTotal, isAbove, isBelowAllThresholdsForVariant, hasStrictGiftProp: hasStrictGiftProp, hasFreeGiftRow: hasFreeGiftRowForVariant });
      
      if (isAbove && !hasFreeGiftRowForVariant) {
        log('syncGiftProducts: Adding gift', { variantId: milestone.giftVariantId, label: milestone.label });
        try {
          var addRes = await fetch(this.getCartAddUrl(), cartFetchOpts({
            method: 'POST', headers: CART_HEADERS,
            body: JSON.stringify({ items: [{ id: milestone.giftVariantId, quantity: Number(milestone.giftQty) || 1, properties: { _gift: '1' } }] })
          }));
          if (addRes.ok) {
            log('syncGiftProducts: add API OK, fetching cart');
            currentCart = await this.fetchCart();
            changed = true;
            log('syncGiftProducts: add OK', { newCartItemCount: (currentCart.items || []).length });
            var giftTpl = (this.strings.progress_gift_added || '🎁 {{ label }} ajouté !');
      this.showProgressBanner(giftTpl.replace(/\{\{\s*label\s*\}\}/g, milestone.bannerLabel || milestone.doneLabel || milestone.label || 'Cadeau'), 'success');
          } else {
            var addBody = await addRes.text();
            try { addBody = JSON.parse(addBody); } catch (_) { /* keep as text */ }
            logError('syncGiftProducts add failed', { status: addRes.status, body: addBody });
          }
        } catch (e) { logError('syncGiftProducts add:', e); }
        
      } else if (isAbove && Number(milestone.giftQty) > 1) {
        // 13/10/2026 : cadeau à quantité fixe (20 capsules = 2 boîtes) : quantité FIXÉE par /cart/change, jamais ajoutée.
        var qLine = (currentCart.items || []).find(function (item) { return lineIsRemovableGiftSku(item, gvidStr); });
        if (qLine && qLine.quantity < Number(milestone.giftQty) && (qLine.key || qLine.id)) {
          try {
            var qRes = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS, body: JSON.stringify({ id: qLine.key || qLine.id, quantity: Number(milestone.giftQty) }) }));
            if (qRes.ok) { currentCart = await this.fetchCart(); changed = true; } else logError('syncGiftProducts gift qty', { variantId: gvidStr, status: qRes.status });
          } catch (e) { logError('syncGiftProducts gift qty:', e); }
        }
      } else if (isBelowAllThresholdsForVariant) {
        var removeSafety = 0;
        while (removeSafety++ < 24) {
          var rowToRemove = (currentCart.items || []).find(function (item) {
            return lineIsRemovableGiftSku(item, gvidStr);
          });
          if (!rowToRemove) break;
          var lineKey = rowToRemove.key || rowToRemove.id;
          if (!lineKey) {
            logError('syncGiftProducts: gift line has no key/id', rowToRemove);
            break;
          }
          log('syncGiftProducts: Removing gift', { variantId: milestone.giftVariantId, label: milestone.label });
          try {
            var rmRes = await fetch(this.getCartChangeUrl(), cartFetchOpts({
              method: 'POST', headers: CART_HEADERS,
              body: JSON.stringify({ id: lineKey, quantity: 0 })
            }));
            if (rmRes.ok) {
              currentCart = await this.fetchCart();
              changed = true;
              this.hideGiftProgressBanner();
            } else break;
          } catch (e) {
            logError('syncGiftProducts remove:', e);
            break;
          }
        }
      }
    }

    // At most one auto-added gift line per gift variant (same detection as removal: _gift or free line for that SKU)
    var uniqueGiftVariantIds = [];
    giftMilestones.forEach(function (m) {
      var gid = String(m.giftVariantId);
      if (uniqueGiftVariantIds.indexOf(gid) === -1) uniqueGiftVariantIds.push(gid);
    });
    for (var d = 0; d < uniqueGiftVariantIds.length; d++) {
      var gvid = uniqueGiftVariantIds[d];
      var giftLines = (currentCart.items || []).filter(function (item) {
        return lineIsRemovableGiftSku(item, gvid);
      });
      if (giftLines.length === 0) continue;
      // 1) Remove extra duplicate LINES (keep the first one)
      for (var r = 1; r < giftLines.length; r++) {
        var dupKey = giftLines[r].key || giftLines[r].id;
        if (!dupKey) continue;
        try {
          var dupRes = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS, body: JSON.stringify({ id: dupKey, quantity: 0 }) }));
          if (dupRes.ok) {
            currentCart = await this.fetchCart();
            changed = true;
            log('syncGiftProducts: removed duplicate gift line', { variantId: gvid, key: dupKey });
          }
        } catch (e) { logError('syncGiftProducts remove duplicate:', e); }
      }
      // 2) Normalize the kept gift line to quantity 1.
      // Concurrent /cart/add calls (race between updateCartUI triggers) get merged by
      // Shopify into a single line with quantity>1 — the duplicate-LINE pass above
      // never caught that. The Shopify "Buy X get Y" discount only frees 1 unit, so a
      // qty>1 gift means the extra units are charged at checkout. Force back to 1.
      var keptGiftLine = (currentCart.items || []).find(function (item) {
        return lineIsRemovableGiftSku(item, gvid);
      });
   var mngpKeepQty = (mngpWant && mngpWant[gvid] > 1) ? mngpWant[gvid] : 1;
   if (!mngpWant) giftMilestones.forEach(function (m) { if (String(m.giftVariantId) === gvid && Number(m.giftQty) > mngpKeepQty) mngpKeepQty = Number(m.giftQty); });
   if (keptGiftLine && keptGiftLine.quantity > mngpKeepQty) {
        var keptKey = keptGiftLine.key || keptGiftLine.id;
        if (keptKey) {
          try {
      var qtyRes = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS, body: JSON.stringify({ id: keptKey, quantity: mngpKeepQty }) }));
            if (qtyRes.ok) {
              currentCart = await this.fetchCart();
              changed = true;
              log('syncGiftProducts: normalized gift qty to 1', { variantId: gvid, key: keptKey, from: keptGiftLine.quantity });
            }
          } catch (e) { logError('syncGiftProducts normalize gift qty:', e); }
        }
      }
    }

    // 3) Legacy gift cleanup: remove auto-gift lines whose variant is NOT a configured
    // free_gift milestone anymore. Stale carts, cookie ~14 j, created before a gift swap
    // keep the old 0€ gift line forever — the loops above only handle configured variants.
    // Seen in prod after the 2026-08-17 swap poche café -> mixeur : 7 double-gift orders.
    // Only lines carrying the _gift property are touched: this system is their only writer.
    var configuredGiftIds = [];
    giftMilestones.forEach(function (m) {
      var cg = String(m.giftVariantId);
      if (configuredGiftIds.indexOf(cg) === -1) configuredGiftIds.push(cg);
    });
    var capsAboDus = mngCapsAboCadeaux(currentCart); // 19/10/2026 : cadeaux du pack encore dus = pas « anciens »
    var legacyGiftLines = (currentCart.items || []).filter(function (item) {
      return item.properties && cartLineIsAutoGift(item.properties) && item.quantity > 0
        && configuredGiftIds.indexOf(String(item.variant_id)) === -1 && !capsAboDus[String(item.variant_id)];
    });
    for (var lg = 0; lg < legacyGiftLines.length; lg++) {
      var legacyKey = legacyGiftLines[lg].key || legacyGiftLines[lg].id;
      if (!legacyKey) continue;
      try {
        var legacyRes = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS, body: JSON.stringify({ id: legacyKey, quantity: 0 }) }));
        if (legacyRes.ok) {
          currentCart = await this.fetchCart();
          changed = true;
          log('syncGiftProducts: removed legacy gift line', { variantId: legacyGiftLines[lg].variant_id, key: legacyKey });
        }
      } catch (e) { logError('syncGiftProducts remove legacy gift:', e); }
    }

    // 4) 19/10/2026 · cadeaux du pack Mush Caps en abonnement (MNG_CAPS_ABO) : une ligne _gift par cadeau dû, quantité FIXÉE à 1.
    //    Ligne absente : /cart/update (updates[variante] = 1, idempotent) puis /cart/change qui la marque _gift. Jamais /cart/add.
    //    Cadeau qui n'est plus dû : déjà retiré par l'étape 3 ci-dessus (et par la garde au paiement).
    var capsVeut = mngCapsAboCadeaux(currentCart), capsVids = Object.keys(capsVeut);
    for (var cv = 0; cv < capsVids.length; cv++) {
      var cvid = capsVids[cv];
      var cLignes = (currentCart.items || []).filter(function (it) { return String(it.variant_id) === cvid && it.quantity > 0 && cartLineIsAutoGift(it.properties); });
      try {
        if (!cLignes.length) {
          var cMaj = {}; cMaj[cvid] = 1;
          var cUp = await fetch(this.getCartUpdateUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS, body: JSON.stringify({ updates: cMaj }) }));
          if (!cUp.ok) { console.error('[cadeaux pack] /cart/update refusé (' + cUp.status + ')', cvid); continue; }
          currentCart = await this.fetchCart();
          changed = true;
          var cNue = (currentCart.items || []).find(function (it) { return String(it.variant_id) === cvid && it.quantity > 0 && !cartLineIsAutoGift(it.properties); });
          if (!cNue) { console.error('[cadeaux pack] ligne introuvable après /cart/update', cvid); continue; }
          var cMk = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS,
            body: JSON.stringify({ id: cNue.key, quantity: 1, properties: Object.assign({}, cNue.properties || {}, { _gift: '1' }) }) }));
          if (!cMk.ok) { console.error('[cadeaux pack] marquage _gift refusé (' + cMk.status + ')', cvid); continue; }
          currentCart = await this.fetchCart();
        } else {
          for (var cx = 1; cx < cLignes.length; cx++) {
            var cDup = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS, body: JSON.stringify({ id: cLignes[cx].key, quantity: 0 }) }));
            if (cDup.ok) { currentCart = await this.fetchCart(); changed = true; } else console.error('[cadeaux pack] doublon non retiré (' + cDup.status + ')', cvid);
          }
          if (Number(cLignes[0].quantity) !== 1) {
            var cQ = await fetch(this.getCartChangeUrl(), cartFetchOpts({ method: 'POST', headers: CART_HEADERS, body: JSON.stringify({ id: cLignes[0].key, quantity: 1 }) }));
            if (cQ.ok) { currentCart = await this.fetchCart(); changed = true; } else console.error('[cadeaux pack] quantité non fixée (' + cQ.status + ')', cvid);
          }
        }
      } catch (e) { console.error('[cadeaux pack] synchro', cvid, e); }
    }

    log('syncGiftProducts: done', { changed, cartItemCount: (currentCart.items || []).length });

    // cart/add.js and cart/change.js can clear cart-level discount codes; re-apply so checkout still matches the drawer.
    // After re-applying, run one more gift pass (depth 1) without re-apply so thresholds stay correct.
    if (changed && discountRepairDepth === 0) {
      try {
        var saved = sessionStorage.getItem(DRAWER_DISCOUNT_SESSION_KEY);
        if (saved && saved.trim()) {
          var re = await fetch(
            this.getCartUpdateUrl(),
            cartFetchOpts({
              method: 'POST',
              headers: CART_HEADERS,
              body: JSON.stringify({ discount: saved.trim() })
            })
          );
          var reText = await re.text();
          var reParsedOk = false;
          if (re.ok && reText && reText.trim()) {
            try {
              currentCart = JSON.parse(reText);
              reParsedOk = true;
            } catch (parseErr) {
              logError('syncGiftProducts: re-apply discount JSON parse', parseErr);
            }
          }
          if (reParsedOk) {
            var nested = await this.mngSyncGiftProductsNow(currentCart, 1);
            currentCart = nested.cart;
            if (nested.changed) changed = true;
          }
        }
      } catch (e) {
        logError('syncGiftProducts: re-apply discount after gift sync', e);
      }
    }

    return { cart: currentCart, changed };
  }

  hideGiftProgressBanner() {
    var banner = this.querySelector('#CartDrawer-ProgressBanner');
    if (!banner) return;
    clearTimeout(this._bannerTimer);
    // remove() et non opacity=0 : l'animation CSS cd-fade-in (fill-mode both)
    // écrase les styles inline — la boîte jaune vide (py-6px) restait visible.
    banner.remove();
  }

  showProgressBanner(message, type) {
    var banner = this.querySelector('#CartDrawer-ProgressBanner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'CartDrawer-ProgressBanner';
      banner.className = 'absolute bottom-full left-0 right-0 text-center font-[\'Source_Sans_Pro\'] font-semibold not-italic text-[11px] py-[6px] px-[10px] transition-opacity duration-300';
      banner.style.zIndex = '5';
      var progressArea = this.querySelector('#CartDrawer-ProgressBar');
      if (progressArea && progressArea.parentElement) progressArea.parentElement.style.position = 'relative';
      var container = this.querySelector('#CartDrawer-ProgressBar')?.parentElement;
      if (container) { container.style.position = 'relative'; container.appendChild(banner); }
    }
    banner.textContent = message;
    banner.style.background = type === 'success' ? '#f9f785' : '#ff6b6b';
    banner.style.color = type === 'success' ? '#21014f' : '#fff';
    banner.style.opacity = '1';
    clearTimeout(this._bannerTimer);
    this._bannerTimer = setTimeout(function () {
      banner.style.animation = 'none'; // libère l'opacity verrouillée par cd-fade-in (fill both)
      banner.style.opacity = '0';
      setTimeout(function () { banner.remove(); }, 350);
    }, 3000);
  }

  normalizeCurrency(code) {
    const c = (code || this.currency || '').toString().trim().toUpperCase();
    if (/^[A-Z]{3}$/.test(c)) return c;
    if (this.currency && /^[A-Z]{3}$/.test(this.currency.toString())) return this.currency;
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active && /^[A-Z]{3}$/.test(String(Shopify.currency.active))) return Shopify.currency.active;
    return 'EUR';
  }

  /**
   * Cart drawer totals — merchandise vs auto-gift vs milestones (single source for updateCartUI + syncGiftProducts).
   *
   * Excluded from merch sums: lines with _gift; or progress-config free_gift variant with original>0 and final===0.
   * displayTotal         = max(0, cart.total_price − pendingGiftSavings) — pending = _gift line still full price until checkout.
   * reductionDisplayCents = max(merch Σ(orig−final), nonGiftOriginalSum − displayTotal) — bridge covers cart-level discounts with stale line finals.
   * eligibleTotal         = min(Σ merch line finals, displayTotal) — avoids milestone “catalogue spend” when Shopify total is lower.
   * When reduction equals the bridge: nonGiftOriginalSum − reductionDisplay ≈ displayTotal (modulo rounding).
   * Limit: shipping/taxes not represented as line items can skew the bridge vs raw Shopify totals.
   */
  computeGiftProgressTotals(cart) {
    if (!cart) {
      return {
        giftItems: [],
        pendingGiftSavings: 0,
        eligibleTotal: 0,
        displayTotal: 0,
        nonGiftOriginalSum: 0,
        nonGiftFinalSum: 0,
        merchDiscountCents: 0,
        reductionDisplayCents: 0
      };
    }
    var giftVariantIds = getGiftVariantIdsFromProgressConfig();
    var items = cart.items || [];
    var giftItems = items.filter(function (item) {
      return item.properties && cartLineIsAutoGift(item.properties);
    });
    var pendingGiftSavings = giftItems.reduce(function (sum, item) {
      var original = item.original_line_price || 0;
      var fin = (item.final_line_price != null) ? item.final_line_price : original;
      return sum + (original > 0 && fin >= original ? original : 0);
    }, 0);
    var nonGiftOriginalSum = 0;
    var nonGiftFinalSum = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (lineExcludedFromMerchTotals(it, giftVariantIds)) continue;
      nonGiftOriginalSum += (it.original_line_price || 0);
      nonGiftFinalSum += (it.final_line_price != null ? it.final_line_price : (it.original_line_price || 0));
    }
    var displayTotal = Math.max(0, (cart.total_price || 0) - pendingGiftSavings);
    var merchDiscountCents = Math.max(0, nonGiftOriginalSum - nonGiftFinalSum);
    var bridgeDiscountCents = Math.max(0, nonGiftOriginalSum - displayTotal);
    var reductionDisplayCents = Math.max(merchDiscountCents, bridgeDiscountCents);
    var eligibleFromLines = Math.max(0, nonGiftFinalSum);
    var eligibleFromCart = displayTotal;
    // 06/10/2026 (Alex) : l'assurance colis ne compte pas dans le montant des paliers.
    var mngAssur = items.reduce(function (sum, it) {
      return sum + ((it && it.properties && it.properties._cart_upsell === 'insurance') ? (it.final_line_price != null ? it.final_line_price : (it.original_line_price || 0)) : 0);
    }, 0);
    eligibleFromLines = Math.max(0, eligibleFromLines - mngAssur);
    eligibleFromCart = Math.max(0, eligibleFromCart - mngAssur);
    var eligibleTotal = Math.min(eligibleFromLines, eligibleFromCart);
    return {
      giftItems: giftItems,
      pendingGiftSavings: pendingGiftSavings,
      eligibleTotal: eligibleTotal,
      displayTotal: displayTotal,
      nonGiftOriginalSum: nonGiftOriginalSum,
      nonGiftFinalSum: nonGiftFinalSum,
      merchDiscountCents: merchDiscountCents,
      reductionDisplayCents: reductionDisplayCents
    };
  }

  formatMoney(cents, currency) {
    const code = this.normalizeCurrency(currency);
    const locale = this.locale || 'fr';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + (code === 'EUR' ? ' €' : ' ' + code);
    }
  }

  // Panier v4 : « dès 59 € » plutôt que « dès 59,00 € ». Un seuil converti dans une autre devise
  // tombe rarement rond : il garde alors ses centimes.
  formatMoneyShort(cents, currency) {
    var c = Math.round(cents || 0);
    if (c % 100 !== 0) return this.formatMoney(c, currency);
    try {
      return new Intl.NumberFormat(this.locale || 'fr', {
        style: 'currency', currency: this.normalizeCurrency(currency), minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(c / 100);
    } catch (e) {
      return this.formatMoney(c, currency);
    }
  }

  persistDrawerDiscountCodes(discountCsv) {
    try {
      var s = discountCsv != null ? String(discountCsv).trim() : '';
      if (s) sessionStorage.setItem(DRAWER_DISCOUNT_SESSION_KEY, s);
      else sessionStorage.removeItem(DRAWER_DISCOUNT_SESSION_KEY);
    } catch (e) { /* private mode / blocked storage */ }
  }

  syncDrawerDiscountSessionFromCart(cart) {
    try {
      if (!cart || !cart.item_count) {
        sessionStorage.removeItem(DRAWER_DISCOUNT_SESSION_KEY);
        sessionStorage.removeItem(LINK_DISCOUNT_SESSION_KEY);
        return;
      }
      if (Array.isArray(cart.discount_codes)) {
        var applicable = cart.discount_codes.filter(function (d) {
          return d && d.code && String(d.code).trim() && d.applicable !== false;
        });
        if (applicable.length) {
          sessionStorage.setItem(
            DRAWER_DISCOUNT_SESSION_KEY,
            applicable
              .map(function (d) { return String(d.code).trim(); })
              .filter(Boolean)
              .join(',')
          );
          return;
        }
        sessionStorage.removeItem(DRAWER_DISCOUNT_SESSION_KEY);
        sessionStorage.removeItem(LINK_DISCOUNT_SESSION_KEY);
        return;
      }
      if ((cart.total_discount || 0) <= 0) {
        sessionStorage.removeItem(DRAWER_DISCOUNT_SESSION_KEY);
        sessionStorage.removeItem(LINK_DISCOUNT_SESSION_KEY);
      }
    } catch (e) { /* ignore */ }
  }

  getCartChangeUrl() {
    return this.routes.cart_change || (typeof window !== 'undefined' && window.routes && (window.routes.cart_change_url || '').replace(/\.js$/, '') + '.js') || '/cart/change.js';
  }
  getCartAddUrl() {
    return this.routes.cart_add || (typeof window !== 'undefined' && window.routes && (window.routes.cart_add_url || '').replace(/\.js$/, '') + '.js') || '/cart/add.js';
  }
  getCartUpdateUrl() {
    return this.routes.cart_update || (typeof window !== 'undefined' && window.routes && (window.routes.cart_update_url || '').replace(/\.js$/, '') + '.js') || '/cart/update.js';
  }
  getCartUrl() {
    return this.routes.cart || (typeof window !== 'undefined' && window.routes && window.routes.cart_url) || '/cart';
  }
  getCartJsUrl() {
    const base = this.getCartUrl();
    return base.endsWith('.js') ? base : base + '.js';
  }
  async fetchCart() {
    const res = await fetch(this.getCartJsUrl(), cartFetchOpts({ headers: CART_ACCEPT }));
    return parseJsonResponse(res);
  }
  }

  customElements.define('cart-drawer', CartDrawer);

  // 02/10/2026 (CADEAUX-ULTIME) : tout changement du panier fait HORS du tiroir (page /cart et assets/cart.js, page de
  // vente, fiches, autre script) relance la garde des cadeaux. Cause des commandes #36291 #36325 #36361 : Ultime x2 ou x3
  // (Café x2 + Chocolat offerts, juste), ramené à x1 sur /cart, que rien ne resynchronisait. Les requêtes du tiroir
  // portent X-MNG-Cadeaux et sont exclues : le tiroir resynchronise lui-même après elles.
  (function () {
    if (window.mngCadeauxGardeFetch || typeof window.fetch !== 'function') return;
    window.mngCadeauxGardeFetch = true;
    var natif = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : String((input && (input.url || input.href)) || input || '');
      var h = (init && init.headers) || (input && typeof input === 'object' && input.headers) || null;
      var duTiroir = false;
      try { duTiroir = !!(h && (h['X-MNG-Cadeaux'] || (typeof h.get === 'function' && h.get('X-MNG-Cadeaux')))); } catch (e) { duTiroir = false; }
      var p = natif.apply(this, arguments);
      if (!duTiroir && /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(url)) {
        p.then(function () {
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.mngApresMutation === 'function') d.mngApresMutation('changement hors tiroir');
        }, function () {});
      }
      return p;
    };
  })();

  // 02/10/2026 (CADEAUX-ULTIME) : page /cart, « Commander » (form#cart de sections/main-cart.liquid) passe d'abord par
  // la garde. Cadeau corrigé : page rechargée (les updates[] du formulaire ne suivent plus les lignes) ; sinon le
  // formulaire repart tel quel, avec son bouton.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== 'cart' || !mngPagePanier()) return;
    if (f.getAttribute('data-mng-garde-ok') === '1') { f.removeAttribute('data-mng-garde-ok'); return; }
    var d = document.querySelector('cart-drawer');
    if (!d || typeof d.mngPayerApresGarde !== 'function') return;
    e.preventDefault();
    var bouton = e.submitter || document.getElementById('checkout');
    d.mngPayerApresGarde(function () {
      f.setAttribute('data-mng-garde-ok', '1');
      if (typeof f.requestSubmit === 'function') {
        try { f.requestSubmit(bouton && bouton.form === f ? bouton : undefined); return; } catch (er) { /* repli ci-dessous */ }
      }
      if (bouton && bouton.name) {
        var champ = document.createElement('input');
        champ.type = 'hidden'; champ.name = bouton.name; champ.value = bouton.value || '';
        f.appendChild(champ);
      }
      HTMLFormElement.prototype.submit.call(f);
    }, mngRechargerPagePanier);
  }, true);
  // 29/09/2026 (BUG-04) : pour la garde « 1 par commande » de layout/theme.liquid.
  window.mngCadeauxCibles = function (cart) {
    const d = document.querySelector('cart-drawer');
    return d && typeof d.mngCadeauxCibles === 'function' ? d.mngCadeauxCibles(cart) : {};
  };

  // Also define cart-drawer-items
  class CartDrawerItems extends HTMLElement {
  constructor() {
    super();
  }
  }
  customElements.define('cart-drawer-items', CartDrawerItems);
  })();
